{
  "% к прошлой неделе": "% em relação à semana passada",
  ". STEOS ID и финансовые квитанции сохраняются.": ". O STEOS ID e os comprovantes financeiros são mantidos.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". As vozes prontas estão disponíveis em «Dublagem» → «Minhas».",
  ". Он не меняет голос озвучки чата.": ". Isso não altera a voz de dublagem do chat.",
  ". После подтверждения обновите профиль.": ". Após confirmar, atualize o perfil.",
  ". Проверьте папку «Спам».": ". Verifique a pasta «Spam».",
  "Circle каждый месяц по подписке": "Circle por assinatura mensal",
  "Circle по подписке на этот месяц потрачены": "Os Circle da assinatura deste mês acabaram",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Não conectado",
  "Telegram ID скопирован.": "ID do Telegram copiado.",
  "{0} {1} C сгорят {2}": "{0} {1} C expiram em {2}",
  "{0} из {1}": "{0} de {1}",
  "{0} фото хватит для сходства": "{0} fotos são suficientes para garantir a semelhança",
  "{0}: {1} работ": "{0}: {1} trabalhos",
  "{0}: пока недоступно": "{0}: indisponível por enquanto",
  "· Вы и варианты": "· Você e variantes",
  "· Новое": "· Novo",
  "· занято": "· ocupado",
  "· отменена": "· cancelada",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». O treinamento começará após tocar separadamente em «Reprocessar» no cartão.",
  "Автовоспроизведение примеров": "Reprodução automática de exemplos",
  "Аккаунт": "Conta",
  "Аккаунт подключён": "Conta conectada",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "O arquivo está indisponível ou o link expirou. Você pode solicitar uma nova exportação.",
  "Бабушка": "Avó",
  "Баланс и вывод доступны в STEOS ID.": "O saldo e os saques estão disponíveis no STEOS ID.",
  "Баланс и награды": "Saldo e recompensas",
  "Без имени": "Sem nome",
  "Бесплатный план": "Plano gratuito",
  "Ближайшие": "Mais próximos",
  "Близкие": "Pessoas queridas",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "A pessoa próxima desaparecerá do perfil. Suas fotos não estarão mais disponíveis para novos trabalhos.",
  "Близкий удалён.": "Pessoa próxima excluída.",
  "Близких пока нет.": "Você ainda não tem pessoas próximas.",
  "Брат": "Irmão",
  "В Steos с": "No Steos desde",
  "В избранное": "Adicionar aos favoritos",
  "Валюта": "Moeda",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "A variante será excluída. As fotos originais e o STEOS ID serão mantidos.",
  "Вариантов: {0}": "Variantes: {0}",
  "Варианты": "Variantes",
  "Ваш собственный голос": "Sua própria voz",
  "Введите УДАЛИТЬ": "Digite УДАЛИТЬ",
  "Введите пароль": "Digite a senha",
  "Введите почту": "Digite o e-mail",
  "Вернуться ко входу": "Voltar ao login",
  "Версия": "Versão",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "A versão do consentimento mudou. Atualize a página e confirme o texto atual.",
  "Версия согласия изменилась. Обновите страницу.": "A versão do consentimento mudou. Atualize a página.",
  "Версия:": "Versão:",
  "Взрослый": "Adulto",
  "Включаем микрофон…": "Ativando o microfone…",
  "Включено": "Ativado",
  "Возраст": "Idade",
  "Войти": "Entrar",
  "Восстановить пароль": "Recuperar senha",
  "Все Circle на балансе без срока": "Seus Circle não expiram",
  "Вы": "Você",
  "Вы и близкие": "Você e pessoas próximas",
  "Вы и варианты": "Você e seus visuais",
  "Выберите голос": "Escolha uma voz",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Escolha uma ferramenta e preencha o formulário. O trabalho concluído será salvo no histórico.",
  "Выбран": "Selecionado",
  "Выбрать голос": "Escolher voz",
  "Выбрать голос по умолчанию": "Escolher voz padrão",
  "Выбрать из работ": "Escolher entre os trabalhos",
  "Выгрузить мои данные": "Exportar meus dados",
  "Выгрузка:": "Exportação:",
  "Выключено": "Desativado",
  "Голос": "Voz",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Voz pronta. Ela está disponível na aba «Minhas», em dublagem.",
  "Голос и клон": "Voz e clone",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "A voz mudou. Os dados foram atualizados — verifique-os antes de salvar.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "A voz mudou. Verifique os dados atualizados antes de reprocessar.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "A voz desaparecerá da sua lista. Esta ação não pode ser desfeita.",
  "Голос по умолчанию для создания:": "Voz padrão para criação:",
  "Голос принят в обработку. Здесь появится его статус.": "A voz foi enviada para processamento. O status aparecerá aqui.",
  "Голос уже удалён или недоступен.": "A voz já foi excluída ou está indisponível.",
  "Голос:": "Voz:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Nenhuma voz encontrada. Abra o catálogo ou altere a pesquisa.",
  "Горизонтальное": "Horizontal",
  "Готов": "Pronto",
  "Готовим образцы": "Preparando amostras",
  "Готово": "Concluído",
  "Готовые работы": "Trabalhos prontos",
  "Далее": "Avançar",
  "Данные Telegram обновлены.": "Dados do Telegram atualizados.",
  "Данные баланса временно недоступны": "Dados do saldo temporariamente indisponíveis",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Os dados estão sendo transferidos para a conta confirmada. As sessões antigas foram encerradas; o comprovante permite continuar a verificação após recarregar.",
  "Дедушка": "Avô",
  "До 5 фото: лицо крупно, при хорошем свете": "Até 5 fotos: rosto em destaque, com boa iluminação",
  "До пяти фото. Они будут использоваться как ваш образ.": "Até cinco fotos. Elas serão usadas como sua representação visual.",
  "Добавить близкого": "Adicionar pessoa próxima",
  "Добавить фото": "Adicionar foto",
  "Добавьте ещё": "Adicione mais",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Adicione de 2 segundos a 1,5 minutos da sua fala. Fale naturalmente, sem música nem outras vozes.",
  "Дочь": "Filha",
  "Друг": "Amigo",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Se a conta existir, o link para criar uma nova senha foi enviado para",
  "Ещё варианты": "Mais variantes",
  "Ещё операции": "Mais operações",
  "Ещё работы": "Mais trabalhos",
  "Жена": "Esposa",
  "ЗАМЕНА ОБРАЗЦОВ": "SUBSTITUIR AMOSTRAS",
  "Забыли пароль?": "Esqueceu a senha?",
  "Загружаем аккаунт…": "Carregando conta…",
  "Загружаем варианты…": "Carregando variantes…",
  "Загружаем ваши голоса…": "Carregando suas vozes…",
  "Загружаем голоса…": "Carregando vozes…",
  "Загружаем настройки…": "Carregando configurações…",
  "Загружаем обновления…": "Carregando atualizações…",
  "Загружаем операции…": "Carregando operações…",
  "Загружаем пример…": "Carregando exemplo…",
  "Загружаем работы…": "Carregando trabalhos…",
  "Загружаем фото…": "Carregando fotos…",
  "Загрузить аудиофайлы": "Carregar arquivos de áudio",
  "Загрузить выбранные фото": "Carregar fotos selecionadas",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "O carregamento ainda não foi confirmado. Toque em «Continuar envio»: primeiro verificaremos o carregamento anterior.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "O carregamento não foi confirmado. Ao continuar, verificaremos primeiro os carregamentos anteriores.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "O carregamento foi rejeitado. Toque em «Continuar envio» para obter um novo link e carregar a amostra.",
  "Закрыть": "Fechar",
  "Закрыть мастер": "Fechar assistente",
  "Заменить образцы": "Substituir amostras",
  "Записать с микрофона": "Gravar pelo microfone",
  "Запись": "Gravação",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "A gravação não está disponível aqui. Abra o aplicativo via HTTPS ou envie um arquivo de áudio.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "A gravação foi interrompida. Tente novamente ou envie um arquivo.",
  "Запись-{0}.{1}": "Gravação-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Grave uma amostra, aguarde o treinamento e use sua própria voz para dublar textos.",
  "Запишите речь или загрузите аудиофайлы": "Grave sua fala ou carregue arquivos de áudio",
  "Запишите свой голос один раз — используйте его в озвучке.": "Grave sua voz uma vez e use-a na dublagem.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "Solicitação salva. Ao continuar, verificaremos a solicitação anterior sem criar uma segunda voz.",
  "Запустить обработку": "Iniciar processamento",
  "Здесь появятся ваши работы": "Seus trabalhos aparecerão aqui",
  "Из них": "Dentre eles",
  "Из них {0} C можно вывести": "Dentre eles, {0} C podem ser sacados",
  "Избранное": "Favoritos",
  "Избранные работы": "Trabalhos favoritos",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "A alteração não foi confirmada. Verifique o cartão atualizado antes de tentar novamente.",
  "Изменить": "Editar",
  "Изменить близкого": "Editar pessoa próxima",
  "Изменить вариант": "Editar variante",
  "Изменить голос": "Alterar voz",
  "Изменить мои фото": "Alterar minhas fotos",
  "Имя близкого": "Nome da pessoa próxima",
  "Имя голоса": "Nome da voz",
  "Имя пользователя не задано": "Nome de usuário não definido",
  "Использовать как себя": "Usar como minha representação",
  "Используем сохранённые образцы голоса «": "Usando as amostras de voz salvas «",
  "Используйте свои фото и фото близких в инструментах студии.": "Use suas fotos e as fotos de pessoas próximas nas ferramentas do estúdio.",
  "История очищена: {0} работ, {1} заказов.": "Histórico limpo: {0} trabalhos, {1} pedidos.",
  "КЛОН ГОЛОСА": "CLONE DE VOZ",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Cada amostra deve conter pelo menos um segundo de fala.",
  "Как в системе": "Como no sistema",
  "Как пользоваться": "Como usar",
  "Как снимать": "Como tirar fotos",
  "Каталог голосов": "Catálogo de vozes",
  "Квадрат": "Quadrado",
  "Кем приходится": "Parentesco",
  "Ко входу": "Voltar ao login",
  "Количество вариантов пока недоступно": "Quantidade de variantes indisponível por enquanto",
  "Конфиденциальность": "Privacidade",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Não é possível copiar. O ID está no cartão da conta.",
  "Кружок с героем": "Mensagem de vídeo com personagem",
  "Лимит {0} голосов выбран": "Limite de {0} vozes atingido",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Limite de vozes atingido. Exclua uma voz desnecessária para adicionar outra.",
  "Лимит:": "Limite:",
  "Мама": "Mãe",
  "Можно добавить до {0} образцов.": "Você pode adicionar até {0} amostras.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Você pode fechar o aplicativo. O status será atualizado após o processamento.",
  "Мои варианты": "Minhas variantes",
  "Мои голоса": "Minhas vozes",
  "Мои данные": "Meus dados",
  "Мои фото": "Minhas fotos",
  "Моё": "Meu",
  "Моё фото": "Minha foto",
  "Муж": "Marido",
  "НОВЫЙ ГОЛОС": "NOVA VOZ",
  "Награды": "Recompensas",
  "Награды и задания": "Recompensas e tarefas",
  "Назад": "Voltar",
  "Название варианта": "Nome da variante",
  "Назначить голос": "Atribuir voz",
  "Настройки": "Configurações",
  "Настройки уже изменились. Показана актуальная версия.": "As configurações já foram alteradas. A versão atual está sendo exibida.",
  "Начните с 2 секунд речи в тихом месте.": "Comece com 2 segundos de fala em um lugar silencioso.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "No máximo 5 fotos JPEG ou PNG, de até 10 MB cada.",
  "Не задано": "Não definido",
  "Не короче 8 знаков": "Pelo menos 8 caracteres",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Não foi possível ativar o microfone. Permita o acesso ou envie um arquivo.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Não foi possível entrar. Abra novamente o aplicativo pelo Telegram.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Não foi possível reproduzir o exemplo. Abra o cartão novamente e tente outra vez.",
  "Не удалось загрузить варианты.": "Não foi possível carregar as variantes.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Não foi possível carregar as vozes. Altere a pesquisa ou a aba para tentar novamente.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Não foi possível carregar as configurações. Tente atualizar.",
  "Не удалось загрузить работы.": "Não foi possível carregar os trabalhos.",
  "Не удалось загрузить следующую страницу.": "Não foi possível carregar a próxima página.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Não foi possível carregar a próxima página. Tente novamente.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Não foi possível atualizar os dados do Telegram. Tente mais tarde.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Não foi possível confirmar a alteração dos favoritos. Atualize o perfil.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Não foi possível confirmar a operação. Verifique o estado da conta antes de tentar novamente.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Não foi possível confirmar o salvamento. Atualize as configurações antes de tentar novamente.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Não foi possível confirmar a exclusão da pessoa próxima. Atualize o perfil.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Não foi possível obter uma resposta. Tente novamente — a solicitação continuará com a mesma chave.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Não foi possível verificar a exportação. Atualize a página: continuaremos a operação anterior.",
  "Не удалось прочитать запись.": "Não foi possível ler a gravação.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Não foi possível criar a voz. Abra o cartão para verificar o status ou repetir o processamento.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Não foi possível criar a voz. Verifique os dados e as amostras.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Não foi possível salvar a visualização. Você pode fechar e voltar mais tarde.",
  "Неверная почта или пароль": "E-mail ou senha incorretos",
  "Нет работ": "Nenhum trabalho",
  "Новая выгрузка": "Nova exportação",
  "Новости": "Notícias",
  "Новый вариант": "Nova variante",
  "Новый голос": "Nova voz",
  "Новых публикаций пока нет.": "Ainda não há novas publicações.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "É necessário um total de 2 segundos a 1,5 minutos de fala.",
  "О приложении": "Sobre o aplicativo",
  "Обновить": "Atualizar",
  "Обновить варианты": "Atualizar variantes",
  "Обновить из Telegram": "Atualizar do Telegram",
  "Обновить настройки": "Atualizar configurações",
  "Обновить профиль": "Atualizar perfil",
  "Обновить работы": "Atualizar trabalhos",
  "Обновления": "Atualizações",
  "Обновляем вход…": "Atualizando login…",
  "Обрабатывается": "Em processamento",
  "Образ готов": "Representação pronta",
  "Образ ещё не собран": "Representação ainda não criada",
  "Образец {0}": "Amostra {0}",
  "Образец голоса": "Amostra de voz",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "A amostra ainda não foi verificada. Aguarde e continue o envio.",
  "Образец не прошёл проверку. Выберите другую запись.": "A amostra não passou na verificação. Escolha outra gravação.",
  "Образцы готовы к повторной обработке.": "As amostras estão prontas para reprocessamento.",
  "Образцы для «": "Amostras para «",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Amostras atualizadas. Toque em «Reprocessar» para treinar a voz novamente.",
  "Обучаем голос": "Treinando voz",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "A duração total das amostras não pode exceder 1,5 minutos.",
  "Объединение STEOS ID": "Unificação do STEOS ID",
  "Объединяем аккаунты": "Unificando contas",
  "Объём образцов": "Duração das amostras",
  "Один аккаунт для бота и сайта STEOS": "Uma conta para o bot e o site STEOS",
  "Озвучить текст голосом «": "Dublar o texto com a voz «",
  "Операции": "Operações",
  "Операции в токенах STEOS ID": "Operações em tokens do STEOS ID",
  "Операции временно недоступны.": "Operações temporariamente indisponíveis.",
  "Операций пока нет.": "Ainda não há operações.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "A operação não foi confirmada. Uma nova tentativa usará a mesma chave.",
  "Описание": "Descrição",
  "Описание и согласие": "Descrição e consentimento",
  "Остановить запись ·": "Parar gravação ·",
  "Остаток Circle недоступен": "Saldo restante de Circle indisponível",
  "Отклик": "Resposta tátil",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Abra o link do e-mail e defina uma nova senha em id.steos.io. Depois, entre aqui.",
  "Откройте ссылку подтверждения для": "Abra o link de confirmação para",
  "Открыть id.steos.io": "Abrir id.steos.io",
  "Открыть историю": "Abrir histórico",
  "Отмена": "Cancelar",
  "Отметьте согласие с условиями": "Marque a caixa de consentimento com os termos",
  "Отправить ссылку": "Enviar link",
  "Отправляем…": "Enviando…",
  "Оформить подписку": "Assinar",
  "Оформление": "Aparência",
  "Очистить историю": "Limpar histórico",
  "Очистить историю?": "Limpar o histórico?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "A limpeza não foi confirmada. Uma nova tentativa verificará a operação anterior.",
  "Очищаем…": "Limpando…",
  "Ошибка": "Erro",
  "Папа": "Pai",
  "Пароль": "Senha",
  "Переименовать вариант": "Renomear variante",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "A transferência ainda não foi confirmada. O comprovante foi salvo; a verificação continuará.",
  "Перенос завершён, обновляем вход…": "Transferência concluída, atualizando login…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Transferindo dados para um STEOS ID existente. Após a transferência, o aplicativo atualizará a sessão. Não inicie outra unificação.",
  "Письмо отправлено": "E-mail enviado",
  "Питомец": "Animal de estimação",
  "Повторить загрузку": "Tentar carregar novamente",
  "Повторить обработку": "Reprocessar",
  "Подготовить ZIP для скачивания": "Preparar ZIP para download",
  "Поддержка": "Suporte",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "A conexão com o STEOS ID está indisponível no momento. Tente mais tarde ou abra o site do STEOS ID.",
  "Подключён": "Conectado",
  "Подключён:": "Conectado:",
  "Подруга": "Amiga",
  "Подтвердите почту": "Confirme seu e-mail",
  "Подтвердите согласие перед отправкой образцов.": "Confirme o consentimento antes de enviar as amostras.",
  "Подтвердить очистку истории": "Confirmar limpeza do histórico",
  "Подтвердить удаление": "Confirmar exclusão",
  "Подтвердить удаление аккаунта": "Confirmar exclusão da conta",
  "Подтвердить удаление близкого": "Confirmar exclusão da pessoa próxima",
  "Подтвердить удаление варианта": "Confirmar exclusão da variante",
  "Поиск голоса": "Pesquisar voz",
  "Поиск по имени": "Pesquisar por nome",
  "Пока нет своих голосов": "Você ainda não tem vozes próprias",
  "Показать ещё": "Mostrar mais",
  "Показать ещё голоса": "Mostrar mais vozes",
  "Показать пароль": "Mostrar senha",
  "Пополнить": "Adicionar saldo",
  "Попробовать": "Experimentar",
  "Портрет": "Retrato",
  "Пост": "Publicação",
  "Потрачено Circle:": "Circle gasto:",
  "Почта": "E-mail",
  "Почта уже занята": "Este e-mail já está em uso",
  "Почта уже занята, войдите с ней": "Este e-mail já está em uso. Entre com ele.",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Olá! Esta é uma gravação para minha voz. Falo calmamente e em um ritmo normal, como numa conversa com um amigo. Vou contar como foi meu dia, o que me deixou feliz e quais são meus planos para amanhã. Continue falando com suas próprias palavras por pelo menos trinta segundos.",
  "Приглашайте друзей": "Convide amigos",
  "Пример голоса {0}": "Exemplo de voz {0}",
  "Принимаю": "Aceitando",
  "Присылать готовые работы в чат": "Enviar trabalhos concluídos para o chat",
  "Проверен": "Verificado",
  "Проверить выгрузку": "Verificar exportação",
  "Проверить подтверждение": "Verificar confirmação",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "A verificação da voz falhou. Grave uma amostra sem música nem outras pessoas.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "A verificação das amostras falhou. Tente uma gravação limpa com apenas uma voz.",
  "Проверьте адрес": "Verifique o endereço",
  "Проверяем запись": "Verificando gravação",
  "Проверяем образец {0} из {1}…": "Verificando amostra {0} de {1}…",
  "Проверяем состояние переноса…": "Verificando o estado da transferência…",
  "Проверяем…": "Verificando…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Confira o saldo no perfil e receba as recompensas disponíveis.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Continuaremos verificando a solicitação anterior, sem iniciá-la novamente.",
  "Продолжим сохранённый запрос с теми же данными.": "Continuaremos a solicitação salva com os mesmos dados.",
  "Продолжить отправку": "Continuar envio",
  "Продолжить проверку": "Continuar verificação",
  "Продолжить создание голоса": "Continuar criação da voz",
  "Продолжить сохранение": "Continuar salvamento",
  "Прослушать {0}": "Ouvir {0}",
  "Профиль": "Perfil",
  "Профиль «Вы» пока недоступен.": "O perfil «Você» está indisponível por enquanto.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "O perfil já foi alterado. Feche o formulário e abra a versão atual.",
  "Работ в этом списке пока нет.": "Ainda não há trabalhos nesta lista.",
  "Работа №": "Trabalho nº",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Os trabalhos e os parâmetros dos pedidos desaparecerão do histórico. As vozes, as variantes de «Você» e as pessoas próximas serão mantidas. Os comprovantes financeiros serão preservados. Não será possível restaurar o histórico.",
  "Работы по неделям": "Trabalhos por semana",
  "Раздел профиля": "Seção do perfil",
  "Разделы профиля": "Seções do perfil",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "O tamanho de cada amostra deve ser de 1 byte a 20 MB.",
  "Ребёнок": "Criança",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "O resultado do processamento ainda está sendo determinado. Não é possível iniciar novamente por enquanto.",
  "Русский": "Русский",
  "С": "De",
  "Сбросить голос по умолчанию": "Redefinir voz padrão",
  "Светлая": "Claro",
  "Свой аватар": "Avatar próprio",
  "Сгорят {0}, если не потратить": "Expiram em {0} se não forem gastos",
  "Сделать кружок": "Criar mensagem de vídeo",
  "Серия:": "Série:",
  "Сестра": "Irmã",
  "Скачать ZIP": "Baixar ZIP",
  "Скопировать Telegram ID": "Copiar ID do Telegram",
  "Скорость речи": "Velocidade da fala",
  "Скрыть пароль": "Ocultar senha",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Muitas solicitações. Aguarde um pouco e tente novamente.",
  "Слишком много попыток. Попробуйте позже.": "Muitas tentativas. Tente mais tarde.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Fotografe o rosto sem filtros nem óculos escuros, com iluminação uniforme. Inclua diferentes ângulos. Deve haver apenas uma pessoa no enquadramento.",
  "Снять голос": "Gravar voz",
  "Снять фото": "Tirar foto",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "O consentimento mudou antes do início do treinamento. Atualize a página e confirme a versão atual antes de reprocessar.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Crie vídeos circulares com um personagem selecionado ou com sua própria representação.",
  "Создание": "Criação",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "A criação de vozes está temporariamente indisponível. As amostras foram salvas nesta janela.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "A criação de novas vozes está indisponível por enquanto. As vozes já criadas estão disponíveis abaixo.",
  "Создано:": "Criado:",
  "Создан {0}": "Criado em {0}",
  "Создать аккаунт": "Criar conta",
  "Создать голос": "Criar voz",
  "Создаём голос…": "Criando voz…",
  "Сохранение настроек создания сейчас выключено.": "O salvamento das configurações de criação está desativado no momento.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "O salvamento não foi confirmado. Feche o formulário e verifique o perfil atual.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "O salvamento não foi confirmado. Uma nova tentativa de criação usará a solicitação anterior.",
  "Сохранение недоступно.": "Salvamento indisponível.",
  "Сохранено": "Salvo",
  "Сохранить": "Salvar",
  "Сохранить близкого": "Salvar pessoa próxima",
  "Сохранить вариант": "Salvar variante",
  "Сохранить голос по умолчанию": "Salvar voz padrão",
  "Сохранить мои фото": "Salvar minhas fotos",
  "Сохранить образцы": "Salvar amostras",
  "Сохраняем образцы…": "Salvando amostras…",
  "Сохраняем…": "Salvando…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "As variantes salvas de você estão disponíveis no perfil e nas ferramentas de criação.",
  "Сохранённых вариантов пока нет.": "Ainda não há variantes salvas.",
  "Сроки партий Circle временно недоступны": "Os prazos dos lotes de Circle estão temporariamente indisponíveis",
  "Старший": "Mais velho",
  "Статистика": "Estatísticas",
  "Статистика по неделям временно недоступна.": "As estatísticas semanais estão temporariamente indisponíveis.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "O status da exclusão está temporariamente indisponível. O comprovante foi salvo nesta aba.",
  "Сторис": "Stories",
  "Сын": "Filho",
  "Тариф": "Plano",
  "Текст для чтения": "Texto para leitura",
  "Тема": "Tema",
  "Тема сохраняется на этом устройстве.": "O tema é salvo neste dispositivo.",
  "Тёмная": "Escuro",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Tenho o direito de usar estas fotos e o consentimento das pessoas retratadas.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Removendo ruído",
  "Убрать": "Remover",
  "Убрать {0}": "Remover {0}",
  "Убрать из избранного": "Remover dos favoritos",
  "Убрать фоновый шум": "Remover ruído de fundo",
  "Убрать фото": "Remover foto",
  "Уведомления": "Notificações",
  "Уведомления недоступны.": "Notificações indisponíveis.",
  "Уведомления пока недоступны.": "As notificações estão indisponíveis por enquanto.",
  "Удаление аккаунта Mini App": "Exclusão da conta do Mini App",
  "Удаление:": "Exclusão:",
  "Удалить": "Excluir",
  "Удалить «": "Excluir «",
  "Удалить «{0}»?": "Excluir «{0}»?",
  "Удалить аккаунт Mini App": "Excluir conta do Mini App",
  "Удалить близкого": "Excluir pessoa próxima",
  "Удалить вариант": "Excluir variante",
  "Удалить голос": "Excluir voz",
  "Удаляем…": "Excluindo…",
  "Удаляется": "Sendo excluído",
  "Українська": "Українська",
  "Условия использования": "Termos de uso",
  "Файл": "Arquivo",
  "Формат": "Formato",
  "Фото Telegram": "Foto do Telegram",
  "Фото {0}": "Foto {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "A foto e o nome são obtidos do seu perfil do Telegram. Se você os alterou, atualize os dados aqui.",
  "Фото и фотосессия": "Foto e sessão fotográfica",
  "Фото перед загрузкой": "Foto antes do carregamento",
  "Фото профиля": "Foto do perfil",
  "Фото профиля Telegram": "Foto do perfil do Telegram",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "As fotos, vozes, pessoas próximas e dados do Mini App serão excluídos de todos os serviços. O STEOS ID e os comprovantes financeiros serão mantidos. A exclusão não pode ser desfeita.",
  "Фото:": "Foto:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Parte do perfil está temporariamente indisponível. Tente atualizar.",
  "Читаем аудиофайлы…": "Lendo arquivos de áudio…",
  "Что нового": "Novidades",
  "Что нового пока не опубликовано или временно недоступно.": "As novidades ainda não foram publicadas ou estão temporariamente indisponíveis.",
  "Что нового пока не опубликовано.": "As novidades ainda não foram publicadas.",
  "Шаблоны": "Modelos",
  "Шаблоны и рилс": "Modelos e reels",
  "Эта неделя": "Esta semana",
  "Этот голос используется:": "Esta voz é usada:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Não é possível repetir esta execução por enquanto. Atualize o status da voz.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Este formato não é compatível. Escolha MP3, WAV, M4A, OGG ou WebM.",
  "Язык аккаунта": "Idioma da conta",
  "готова": "pronta",
  "готова частично": "parcialmente pronta",
  "дата недоступна": "data indisponível",
  "для переозвучки": "para redublagem",
  "до {0}, потом {1}": "até {0}, depois {1}",
  "другой тариф": "outro plano",
  "закончится {0}": "terminará em {0}",
  "и": "e",
  "из": "de",
  "из 1:30 · минимум 0:02": "de 1:30 · mínimo de 0:02",
  "лимит уточняется": "limite ainda sendo determinado",
  "не задан": "não definido",
  "не назначен": "não atribuído",
  "новых": "novos",
  "образец": "amostra",
  "образца": "amostra",
  "образцов": "amostras",
  "оплачено до {0}": "pago até {0}",
  "подарок до {0}": "presente até {0}",
  "пока недоступно": "indisponível por enquanto",
  "политику конфиденциальности STEOS": "política de privacidade do STEOS",
  "продлится {0}": "renova em {0}",
  "речи.": "de fala.",
  "токенов": "tokens",
  "условия": "termos",
  "уточняется": "a confirmar",
  "Қазақша": "Қазақша",
  "← Профиль": "← Perfil",
  "▶ Прослушать": "▶ Ouvir",
  "Озвучка": "Locução",
  "Клон": "Clone",
  "Студия": "Estúdio",
  "Баланс": "Saldo",
  "История": "Histórico",
  "Ещё": "Mais",
  "Клонирование голоса": "Clonagem de voz",
  "Партнёрство": "Parceria",
  "Добавить в чат": "Adicionar ao chat",
  "Разделы": "Seções",
  "Главное меню": "Menu principal",
  "Выберите": "Selecionar",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Todas as fotos foram mantidas após a união. Deixe até cinco para alterar sua aparência.",
  "Абзацы": "Parágrafos",
  "Альбом": "Álbum",
  "Аудио": "Áudio",
  "Без изменения": "Sem alterações",
  "Бесплатно по текущему тестовому dev-тарифу.": "Grátis no plano de teste dev atual.",
  "Бесплатно по тестовому dev-тарифу": "Grátis no plano de teste dev",
  "В избранном пока пусто": "Ainda não há favoritos",
  "В очереди": "Na fila",
  "Вариант {0}": "Opção {0}",
  "Введите текст до 1000 символов": "Digite um texto com até 1000 caracteres",
  "Вернули": "Reembolsado",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Não será possível restaurar o item no histórico. O arquivo permanecerá no chat.",
  "Видео": "Vídeo",
  "Виды работ": "Tipos de trabalho",
  "Все": "Tudo",
  "Вчера": "Ontem",
  "Выбранный вариант": "Opção selecionada",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "A opção selecionada não está disponível. Volte ao perfil e atualize a lista.",
  "Выполняется": "Em andamento",
  "Высота голоса": "Altura da voz",
  "Говорящее видео": "Vídeo falado",
  "Голоса": "Vozes",
  "Дата неизвестна": "Data desconhecida",
  "Длительность": "Duração",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Ainda não há nenhuma ferramenta publicada disponível para esta ação.",
  "Дополнительное поле": "Campo adicional",
  "Заголовок": "Título",
  "Загружаем историю…": "Carregando histórico…",
  "Загружаем работу…": "Carregando trabalho…",
  "Загружаем результат…": "Carregando resultado…",
  "Загружаем…": "A carregar…",
  "Загружено": "Carregado",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "O carregamento não foi confirmado. Continue verificando este arquivo.",
  "Заказ": "Pedido",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "O pedido não foi confirmado. Ao continuar, a solicitação anterior será verificada com a mesma chave.",
  "Заменить файл": "Substituir arquivo",
  "Избранное: {0}": "Favoritos: {0}",
  "Инструмент обновляется. Обновите форму позже.": "A ferramenta está sendo atualizada. Atualize o formulário mais tarde.",
  "Искать в {0} работах": "Pesquisar em {0} trabalhos",
  "Искать в истории": "Pesquisar no histórico",
  "Использовать фото выбранного варианта": "Usar a foto da opção selecionada",
  "Используется выбранный голос.": "A voz selecionada está em uso.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "O resultado da geração está sendo verificado. Um novo trabalho não será iniciado automaticamente.",
  "К инструментам": "Ir para as ferramentas",
  "Кавер": "Versão cover",
  "Карусель": "Carrossel",
  "Ключевые слова": "Palavras-chave",
  "Коллаж": "Colagem",
  "Кратко": "Resumido",
  "Кружки": "Mensagens de vídeo",
  "Кружок": "Mensagem de vídeo",
  "Кто в кадре": "Quem está no quadro",
  "Название": "Nome",
  "Не получилось": "Falha",
  "Не удалось выполнить": "Não foi possível concluir",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Não foi possível executar esta ação neste trabalho. Atualize-o e tente novamente.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Não foi possível concluir a criação. Tente alterar as configurações.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Não foi possível carregar o histórico. Tente novamente.",
  "Не удалось загрузить студию.": "Não foi possível carregar o estúdio.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Não foi possível carregar a foto da opção. Atualize o perfil.",
  "Не удалось обработать запись": "Não foi possível processar a gravação",
  "Не удалось озвучить текст": "Não foi possível narrar o texto",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Não foi possível abrir a ferramenta. Tente atualizar.",
  "Не удалось открыть результат. Попробуйте снова.": "Não foi possível abrir o resultado. Tente novamente.",
  "Не удалось отправить результат. Повторите отправку.": "Não foi possível enviar o resultado. Tente enviar novamente.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Não foi possível conectar ao serviço. Tente novamente.",
  "Не удалось скопировать. Выделите текст вручную.": "Não foi possível copiar. Selecione o texto manualmente.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Não foi possível salvar o envio. Permita o acesso ao armazenamento da aba e tente novamente.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Alguns arquivos usados na repetição não estão mais disponíveis. Carregue-os novamente.",
  "Ничего не нашли": "Não foram encontrados resultados",
  "Нужно разных фото": "São necessárias fotos diferentes",
  "Обрабатываем запись": "Processando gravação",
  "Озвучиваем текст": "Narrando texto",
  "Озвучить": "Narrar",
  "Озвучка готова": "Narração pronta",
  "Озвучка проекта": "Narração do projeto",
  "Оплата": "Pagamento",
  "Оплачено донатом": "Pago com doação",
  "Определить автоматически": "Detectar automaticamente",
  "Основа": "Base",
  "Открыть результат": "Abrir resultado",
  "Отменено": "Cancelado",
  "Отправить в чат": "Enviar para o chat",
  "Отправка не принята. Проверьте сообщение об ошибке.": "O envio não foi aceito. Verifique a mensagem de erro.",
  "Отправка принята. Бот доставит результат в чат.": "O envio foi aceito. O bot entregará o resultado no chat.",
  "Отправлено": "Enviado",
  "Переозвучить запись": "Refazer a narração da gravação",
  "Переозвучка": "Nova narração",
  "Персонаж": "Personagem",
  "Площадка": "Local",
  "Повтори движения": "Repita os movimentos",
  "Повторить": "Repetir",
  "Подпись": "Legenda",
  "Подтверждаю право использовать загружаемые материалы": "Confirmo que tenho o direito de usar os materiais enviados",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Confirmo que tenho o direito de usar estas fotos e que as pessoas retratadas consentiram com a criação da opção",
  "Поиск в истории": "Pesquisar no histórico",
  "Показатели истории": "Estatísticas do histórico",
  "Показатели истории временно недоступны": "As estatísticas do histórico estão temporariamente indisponíveis",
  "Показать все работы": "Mostrar todos os trabalhos",
  "Показать текст": "Mostrar texto",
  "Порядок": "Ordem",
  "Почистить запись": "Limpar gravação",
  "Прежний голос недоступен. Выберите другой голос.": "A voz anterior não está disponível. Selecione outra voz.",
  "Преимущества": "Vantagens",
  "Проверьте заполненные поля. Заказ не создан.": "Verifique os campos preenchidos. O pedido não foi criado.",
  "Проверяем итог операции": "Verificando o resultado da operação",
  "Проверяем отправку…": "Verificando o envio…",
  "Проверяем результат": "Verificando o resultado",
  "Проверяем списание токенов": "Verificando o débito de tokens",
  "Продолжить проверку озвучки": "Continuar verificando a narração",
  "Работ пока нет": "Ainda não há trabalhos",
  "Работ: {0}": "Trabalhos: {0}",
  "Работа": "Trabalho",
  "Работа больше не найдена. Обновите историю.": "O trabalho não foi mais encontrado. Atualize o histórico.",
  "Работа из истории": "Trabalho do histórico",
  "Работа не прошла проверку.": "O trabalho não passou na verificação.",
  "Работа обновилась. Загрузите её ещё раз.": "O trabalho foi atualizado. Carregue-o novamente.",
  "Распознавание": "Reconhecimento",
  "Распознанный текст": "Texto reconhecido",
  "Распознать речь": "Reconhecer fala",
  "Расшифровка": "Transcrição",
  "Режим озвучки": "Modo de narração",
  "Результат": "Resultado",
  "Результат больше недоступен": "O resultado não está mais disponível",
  "Результат операции уточняется. Повторный запуск отключён.": "O resultado da operação está sendo verificado. A execução novamente está desativada.",
  "Результат отправки пока неизвестен. Повторите проверку.": "O resultado do envio ainda é desconhecido. Verifique novamente.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "O resultado do envio ainda é desconhecido. Tente novamente com a mesma chave.",
  "Результат переозвучки": "Resultado da nova narração",
  "Результат работы": "Resultado do trabalho",
  "Реплики": "Falas",
  "Речевая запись": "Gravação de fala",
  "Рилс": "Reels",
  "Сегодня": "Hoje",
  "Сейчас создаётся": "Sendo criado agora",
  "Сервис сейчас недоступен.": "O serviço está indisponível no momento.",
  "Сессия истекла. Откройте приложение заново.": "A sessão expirou. Abra o aplicativo novamente.",
  "Синтез": "Síntese",
  "Скачать": "Baixar",
  "Скачать все файлы": "Baixar todos os arquivos",
  "Скачать набор": "Baixar pacote",
  "Скопировано": "Copiado",
  "Скопировать": "Copiar",
  "Слайды": "Slides",
  "Слишком много запросов. Подождите немного.": "Muitas solicitações. Aguarde um pouco.",
  "Слушать результат": "Ouvir resultado",
  "Смена голоса": "Alteração de voz",
  "Сначала новые": "Mais recentes primeiro",
  "Сначала старые": "Mais antigos primeiro",
  "Создать": "Criar",
  "Создаётся": "Sendo criado",
  "Списано": "Debitado",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "O status ainda não foi confirmado. Verificando o pedido anterior.",
  "Статус текущих заказов временно недоступен": "O status dos pedidos atuais está temporariamente indisponível",
  "Стиль": "Estilo",
  "Стоимость": "Custo",
  "Сцена": "Cena",
  "Съёмка": "Sessão de fotos",
  "Текст": "Texto",
  "Текст для озвучки": "Texto para narração",
  "Текст песни": "Letra da música",
  "Текст поста": "Texto da publicação",
  "Товар": "Produto",
  "Удалить из истории": "Excluir do histórico",
  "Удалить из истории?": "Excluir do histórico?",
  "Уточняем результат": "Verificando o resultado",
  "Уточняем состояние сохранённого заказа…": "Verificando o status do pedido salvo…",
  "Файл в чате останется": "O arquivo permanecerá no chat",
  "Файлов: {0}": "Arquivos: {0}",
  "Форма недоступна.": "O formulário está indisponível.",
  "Формат отправки": "Formato de envio",
  "Фото": "Fotografia",
  "Фотосессии": "Sessões de fotos",
  "Фотосессия": "Sessão de fotos",
  "Фотосессия товара": "Sessão de fotos do produto",
  "Части": "Partes",
  "Шаблон": "Modelo",
  "Эта работа недоступна вашему аккаунту.": "Este trabalho não está disponível para sua conta.",
  "Это вся история": "Este é todo o histórico",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Esta ferramenta está indisponível no momento. Tente atualizar o formulário.",
  "Язык записи": "Idioma da gravação",
  "MP3 · пауза между репликами 0,6 с": "MP3 · pausa de 0,6 s entre falas",
  "{0} / 1 000 знаков": "{0} / 1 000 caracteres",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20 000 caracteres · versão {1}",
  "{0} реплик": "{0} falas",
  "{0} ролей · {1} новых реплик": "{0} papéis · {1} novas falas",
  "Аудио больше недоступно. Обновите статус проекта.": "O áudio já não está disponível. Atualize o estado do projeto.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Área de transferência indisponível. Cole o texto manualmente no campo.",
  "В проекте должно быть от 1 до 50 ролей.": "O projeto deve ter entre 1 e 50 papéis.",
  "В проекте может быть не больше 500 реплик.": "O projeto pode ter no máximo 500 falas.",
  "Вставить из буфера": "Colar da área de transferência",
  "Вставить сценарий": "Colar roteiro",
  "Выберите голос для каждой непустой роли.": "Selecione uma voz para cada papel não vazio.",
  "Выше": "Acima",
  "Голос {0}": "Voz {0}",
  "Голос роли": "Voz do papel",
  "Готовим аудио…": "A preparar o áudio…",
  "Добавить {0} реплик": "Adicionar {0} falas",
  "Добавьте реплику или вставьте сценарий.": "Adicione uma fala ou cole um roteiro.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Aguarde o carregamento do ficheiro partilhado e tente novamente.",
  "Дублировать": "Duplicar",
  "Загружаем аудио…": "A carregar o áudio…",
  "Загружаем проекты…": "A carregar os projetos…",
  "Загрузить версию сервера": "Carregar versão do servidor",
  "Закрыть раздел без сохранения изменений?": "Fechar a secção sem guardar as alterações?",
  "Заменить текущие роли и реплики?": "Substituir os papéis e as falas atuais?",
  "Заменить текущий сценарий": "Substituir o roteiro atual",
  "Изменить сценарий": "Editar roteiro",
  "Имя роли": "Nome do papel",
  "Кто говорит": "Quem fala",
  "Мои проекты": "Os meus projetos",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Prima reproduzir no leitor para ativar o som.",
  "Название проекта": "Nome do projeto",
  "Название слишком длинное.": "O nome é demasiado longo.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Não foi possível recuperar as operações. Não volte a iniciar a locução; consulte o histórico.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Não foi possível executar a ação. As alterações continuam no ecrã.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Não foi possível carregar o áudio. Verifique a ligação e tente novamente.",
  "Не удалось озвучить проект": "Não foi possível dar voz ao projeto",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Não foi possível preparar o áudio. Verifique a fala e a voz selecionada.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Não foi possível verificar o proprietário do projeto. Atualize a página.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Saldo Circle insuficiente. Adicione fundos ao saldo e repita a ação.",
  "Ниже": "Abaixo",
  "Новый дубль реплики": "Nova versão da fala",
  "Общий файл · MP3": "Ficheiro partilhado · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Uma das vozes já não está disponível. Selecione outra voz.",
  "Озвучено реплик: {0} из {1}": "Falas com voz: {0} de {1}",
  "Озвучиваем проект": "A dar voz ao projeto",
  "Озвучить · {0} Circle": "Dar voz · {0} Circle",
  "Озвучить проект": "Dar voz ao projeto",
  "Озвучка проектов": "Locução de roteiros",
  "Озвучка уже выполняется. Дождитесь результата.": "A locução já está em curso. Aguarde o resultado.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "A operação já foi aceite ou o resultado é desconhecido. Verifique o pedido anterior.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Descartar as alterações locais e carregar a versão do servidor?",
  "Открыть в истории": "Abrir no histórico",
  "Отменить изменения": "Cancelar alterações",
  "Отменить несохранённые изменения?": "Cancelar as alterações não guardadas?",
  "Перед озвучкой дождитесь сохранения изменений.": "Aguarde que as alterações sejam guardadas antes de iniciar a locução.",
  "Переозвучить": "Gerar nova locução",
  "Переозвучить реплику": "Gerar nova locução da fala",
  "Повторить проверку": "Verificar novamente",
  "Подтвердить и запустить": "Confirmar e iniciar",
  "Подтверждение озвучки": "Confirmação da locução",
  "Проверить прежний запрос": "Verificar solicitação anterior",
  "Проверить статус": "Verificar estado",
  "Проверьте роли, голоса и длину реплик.": "Verifique os papéis, as vozes e o comprimento das falas.",
  "Проект больше недоступен.": "O projeto já não está disponível.",
  "Проект длиннее 20 000 знаков.": "O projeto excede 20 000 caracteres.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "O projeto foi alterado noutra janela. Compare a sua versão e carregue a versão mais recente.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "O projeto foi alterado. Guarde-o e verifique novamente o preço.",
  "Проект или результат больше недоступен.": "O projeto ou o resultado já não está disponível.",
  "Проект озвучен": "Projeto com locução concluída",
  "Проекты {0}": "Projetos {0}",
  "Прослушать": "Ouvir",
  "Прослушать реплику": "Ouvir fala",
  "Прослушать текущую версию": "Ouvir versão atual",
  "Прослушивание в очереди": "Audição na fila",
  "Прослушивание реплики": "Audição da fala",
  "Результат изменился. Загрузите его актуальную версию.": "O resultado foi alterado. Carregue a versão atualizada.",
  "Результат озвучки проекта": "Resultado da locução do projeto",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "O resultado está a ser verificado. Não será iniciada automaticamente uma nova geração.",
  "Реплика {0}": "Fala {0}",
  "Реплика длиннее 1 000 знаков.": "A fala excede 1 000 caracteres.",
  "Реплики · {0}": "Falas · {0}",
  "Реплику {0} выше": "Mover a fala {0} para cima",
  "Реплику {0} ниже": "Mover a fala {0} para baixo",
  "Роли и голоса": "Papéis e vozes",
  "Роль {0}": "Papel {0}",
  "Роль реплики": "Papel da fala",
  "Скачать MP3": "Transferir MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "Muitas solicitações. Aguarde e tente verificar novamente.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Crie um projeto e, em seguida, cole um roteiro ou adicione papéis e falas.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "O custo foi confirmado pelo servidor. Verificar novamente este mesmo pedido não gera uma nova cobrança.",
  "Стоимость: {0} Circle": "Custo: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "As linhas «Nome: fala» serão convertidas em papéis e falas. Pode manter os códigos de tempo.",
  "Сценарий": "Roteiro",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "O roteiro foi alterado. Esta faixa corresponde à versão anterior do projeto.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Roteiro por papéis — cada papel fala com a sua própria voz.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "O texto ou a voz foram alterados. É necessário ouvir novamente a versão atual.",
  "Текст реплики": "Texto da fala",
  "Удалить проект": "Eliminar projeto",
  "Удалить реплику {0}": "Eliminar fala {0}",
  "Удалить реплику?": "Eliminar fala?",
  "Удалить роль {0}": "Eliminar papel {0}",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "Eliminar o papel «{0}» juntamente com as respetivas falas ({1})?",
  "Удалить этот проект?": "Eliminar este projeto?",
  "Укажите имя каждой роли.": "Introduza o nome de cada papel.",
  "Уточняем результат озвучки": "A verificar o resultado da locução",
  "Цена изменилась. Проверьте новую цену перед запуском.": "O preço foi alterado. Verifique o novo preço antes de iniciar.",
  "есть несохранённые изменения": "existem alterações não guardadas",
  "сохранено": "guardado",
  "＋ Новый проект": "＋ Novo projeto",
  "＋ Реплика": "＋ Fala",
  "＋ Роль": "＋ Papel",
  "Circle из пакетов без срока действия.": "Circle de pacotes sem prazo de validade.",
  "Circle каждый месяц": "Circle todos os meses",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Os Circle são creditados a cada {0} dias, com o primeiro lote creditado imediatamente.",
  "Circle этой партии действуют до {0}": "Os Circle deste lote são válidos até {0}",
  "{0} Circle каждый месяц": "{0} Circle por mês",
  "{0} Circle каждый месяц · до {1} своих голосов": "{0} Circle por mês · até {1} vozes próprias",
  "{0} мес.": "{0} meses",
  "Баланс и профиль": "Saldo e perfil",
  "В текущем месяце осталось {0} из {1} Circle": "Restam {0} de {1} Circle neste mês",
  "Ваш текущий тариф": "Seu plano atual",
  "Включить тестовое продление": "Ativar renovação de teste",
  "Выбор тарифа": "Escolher plano",
  "Действует до {0}": "Válido até {0}",
  "Для этой подписки продление пока недоступно.": "A renovação ainda não está disponível para esta assinatura.",
  "До {0} своих голосов": "Até {0} vozes próprias",
  "До {0} сохраняется текущий тариф.": "O plano atual será mantido até {0}.",
  "Докупить Circle": "Comprar mais Circle",
  "Доступные сроки": "Períodos disponíveis",
  "Загружаем подписку…": "Carregando assinatura…",
  "Запланировать переход": "Agendar mudança de plano",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "A solicitação não corresponde à operação salva. Não repita a compra; entre em contato com o suporte.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "É necessário verificar o resultado da solicitação anterior. Uma nova compra está temporariamente bloqueada.",
  "Начислить {0} тестовых Circle": "Adicionar {0} Circle de teste",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Não foi possível recuperar a operação. Verifique a assinatura antes de fazer uma nova compra.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Operação confirmada. Atualize os dados; não é necessário repetir a compra.",
  "Оставить текущий тариф": "Manter o plano atual",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Cancelar a renovação mantém o plano e os limites até o fim do período pago.",
  "Отменить продление": "Cancelar renovação",
  "Оформить dev-подписку": "Assinar plano dev",
  "Пакет Circle начислен.": "Pacote de Circle creditado.",
  "Пакеты Circle доступны с активной подпиской.": "Os pacotes de Circle estão disponíveis com uma assinatura ativa.",
  "Перейти на выбранный тариф": "Mudar para o plano selecionado",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "A mudança ocorrerá após o término da assinatura atual. Nenhum pagamento é necessário agora.",
  "Подписка": "Assinatura",
  "Подписка временно недоступна. Попробуйте обновить данные.": "A assinatura está temporariamente indisponível. Tente atualizar os dados.",
  "Подписка не продлится": "A assinatura não será renovada",
  "Подписка обновлена.": "Assinatura atualizada.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "A assinatura já está ativa. Atualize os dados e escolha uma ação disponível.",
  "Подписка уже закончилась. Обновите данные.": "A assinatura já expirou. Atualize os dados.",
  "Подтвердить": "Confirmar",
  "Подтверждение подписки": "Confirmação da assinatura",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "A compra está indisponível no momento. Os pagamentos reais não estão habilitados.",
  "Получить dev-пакет бесплатно": "Obter pacote dev grátis",
  "Потом: {0}": "Depois: {0}",
  "Предыдущая подписка закончилась {0}": "A assinatura anterior terminou em {0}",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Ao renovar um período pago, o novo lote será creditado no próximo período.",
  "Проверка операции": "Verificação da operação",
  "Продление включено": "Renovação ativada",
  "Продлить подписку": "Renovar assinatura",
  "Свои голоса": "Vozes próprias",
  "Свои голоса: {0} из {1}": "Vozes próprias: {0} de {1}",
  "Сравнить тарифы": "Comparar planos",
  "Срок": "Período",
  "Срок подписки": "Duração da assinatura",
  "Срок: {0} мес.": "Período: {0} meses",
  "Тариф останется до конца срока. Следующего продления не будет.": "O plano permanecerá ativo até o fim do período. Não haverá outra renovação.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Os planos estão temporariamente indisponíveis. Tente atualizar os dados mais tarde.",
  "Текущий тариф": "Plano atual",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Catálogo de teste dev. Não há pagamentos reais; Circle de teste são creditados.",
  "Управление подпиской": "Gerenciar assinatura",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "As condições do plano foram alteradas. Atualize os dados antes de confirmar.",
  "Что входит": "O que está incluído",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Esta é uma operação dev gratuita. Nenhum dinheiro ou Telegram Stars será cobrado.",
  "Этот переход между тарифами недоступен.": "Esta mudança entre planos não está disponível.",
  "Этот тариф больше недоступен. Обновите список.": "Este plano não está mais disponível. Atualize a lista.",
  "QR-код": "Código QR",
  "QR-код приглашения": "Código QR de convite",
  "{0} из {1} · {2} Circle": "{0} de {1} · {2} Circle",
  "Виды заданий": "Tipos de tarefas",
  "Выполнение этого задания пока недоступно.": "A execução desta tarefa ainda não está disponível.",
  "Готовим материал…": "A preparar o material…",
  "Действие подтверждено. Обновляем задания.": "Ação confirmada. A atualizar as tarefas.",
  "День {0}": "Dia {0}",
  "День {0} из {1}": "Dia {0} de {1}",
  "Дней подряд: {0}": "Dias consecutivos: {0}",
  "Друзья": "Amigos",
  "Ежедневная серия": "Sequência diária",
  "Ежедневные": "Diárias",
  "Есть награды": "Tem recompensas",
  "Забрать {0} Circle": "Recolher {0} Circle",
  "Загружаем награды…": "A carregar recompensas…",
  "Задание ещё не выполнено. Обновите прогресс.": "A tarefa ainda não foi concluída. Atualize o progresso.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "A tarefa regista a abertura da opção de publicação de stories. O Telegram não confirma a publicação.",
  "Заданий в этой группе пока нет.": "Ainda não há tarefas neste grupo.",
  "Задания дня": "Tarefas do dia",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Entre todos os dias. Se falhar um dia, a sequência recomeça.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "É necessário verificar o resultado do pedido anterior. Novos créditos estão temporariamente bloqueados.",
  "Копирование недоступно. Выделите текст вручную.": "A cópia não está disponível. Selecione o texto manualmente.",
  "Материал для сторис": "Material para stories",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Recompensa confirmada. Atualize os dados; não é necessário repetir o crédito.",
  "Награда получена": "Recompensa recebida",
  "Награда получена. Завтра +{0} Circle": "Recompensa recebida. Amanhã +{0} Circle",
  "Награда уже получена. Обновите данные.": "A recompensa já foi recebida. Atualize os dados.",
  "Награды временно недоступны. Попробуйте обновить данные.": "As recompensas estão temporariamente indisponíveis. Tente atualizar os dados.",
  "Награды за друзей": "Recompensas por amigos",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "As recompensas são recebidas em Circle: podem ser usadas para pagar no STEOS, mas não podem ser levantadas.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Crédito não confirmado. Verifique o pedido anterior; a nova recompensa está temporariamente bloqueada.",
  "Начисления приостановлены.": "Os créditos estão suspensos.",
  "Начислено {0} Circle": "Creditado: {0} Circle",
  "Начислено: {0} Circle": "Creditado: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Não foi possível recuperar o pedido de recompensa. Verifique o saldo e contacte o suporte.",
  "Не удалось загрузить QR-код.": "Não foi possível carregar o código QR.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Não foi possível abrir a opção de publicação de stories. A recompensa não foi creditada.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Não foi possível preparar o story. Tente novamente.",
  "Новый день: {0}": "Novo dia: {0}",
  "Обновить награды": "Atualizar recompensas",
  "Обновятся: {0}": "Serão atualizados: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Abra a Mini App no Telegram com suporte para stories.",
  "Открыть STEOS ID в профиле": "Abrir STEOS ID no perfil",
  "Открыть сторис": "Abrir stories",
  "Отправить в сторис": "Publicar nos stories",
  "Партнёрские данные временно недоступны.": "Os dados dos parceiros estão temporariamente indisponíveis.",
  "Партнёрство · Статистика, материалы и вывод": "Parceria · Estatísticas, materiais e saque",
  "Первые шаги": "Primeiros passos",
  "Перейти к заданию": "Ir para a tarefa",
  "Получить ежедневную награду": "Receber recompensa diária",
  "Приглашено: {0} · Покупателей: {1}": "Convidados: {0} · Compradores: {1}",
  "Прогресс задания": "Progresso da tarefa",
  "Прогресс задания временно недоступен.": "O progresso da tarefa está temporariamente indisponível.",
  "Промокод": "Código promocional",
  "Разовые": "Únicas",
  "Скопировать приглашение": "Copiar convite",
  "Скопировать промокод": "Copiar código promocional",
  "Ссылка приглашения": "Link de convite",
  "Сторис в Telegram": "Stories no Telegram",
  "Челленджи недели": "Desafios da semana",
  "Circle используются внутри STEOS": "Os Circle são utilizados dentro do STEOS",
  "Telegram подтвердил отправку сообщения.": "O Telegram confirmou o envio da mensagem.",
  "Без покупок": "Sem compras",
  "В этом списке пока нет друзей.": "Ainda não há amigos nesta lista.",
  "Возможен вывод по условиям программы": "O saque está disponível nos termos do programa",
  "Вопросы": "Perguntas",
  "Всё время": "Todo o período",
  "Вы здесь": "Você está aqui",
  "Выберите PDF, JPG или PNG.": "Selecione PDF, JPG ou PNG.",
  "Выберите плательщика": "Selecione o pagador",
  "Выбрать чат в Telegram": "Selecionar chat no Telegram",
  "Выбрать чат для отправки": "Selecionar chat para envio",
  "Вывод": "Saque",
  "Вывод недоступен на текущем уровне.": "O saque não está disponível no nível atual.",
  "Вывод сейчас недоступен.": "O saque está indisponível no momento.",
  "Вывод средств": "Saque de fundos",
  "Выплачен": "Pago",
  "Выставьте счёт на": "Faturar a",
  "Для вывода войдите в STEOS ID.": "Para sacar fundos, entre no STEOS ID.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "São necessários níveis e tarifas publicados para o cálculo.",
  "До уровня «{0}»: ещё {1} покупателей": "Até o nível «{0}»: faltam {1} compradores",
  "Доступно к выводу": "Disponível para saque",
  "Доступных шаблонов пока нет.": "Ainda não há modelos disponíveis.",
  "Доход": "Rendimento",
  "Если купят {0} друзей": "Se {0} amigos comprarem",
  "Есть покупки": "Há compras",
  "За этот период начислений пока нет.": "Ainda não há valores creditados neste período.",
  "Загружаем QR-код…": "Carregando código QR…",
  "Загружаем друзей…": "Carregando amigos…",
  "Загружаем материалы…": "Carregando materiais…",
  "Загружаем партнёрские данные…": "Carregando dados de parceiros…",
  "Загрузите проверенный счёт на оплату.": "Carregue uma fatura de pagamento verificada.",
  "Заказать материал в чат": "Solicitar material no chat",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Solicitação recebida. A entrega no chat ainda não foi confirmada.",
  "Заявка принята. Статус выплаты появится в истории.": "Solicitação recebida. O status do pagamento aparecerá no histórico.",
  "Заявок на вывод пока нет.": "Ainda não há solicitações de saque.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "A alteração dos dados bancários está bloqueada até que o resultado desta solicitação seja recebido.",
  "Имя получателя": "Nome do beneficiário",
  "История выводов": "Histórico de levantamentos",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "É necessário verificar o resultado da solicitação. O novo material está temporariamente bloqueado.",
  "Как определяется уровень?": "Como o nível é determinado?",
  "Как это работает": "Como funciona",
  "Калькулятор станет доступен после публикации расчётной политики.": "A calculadora ficará disponível após a publicação da política de cálculo.",
  "Количество друзей": "Número de amigos",
  "Материалы": "Materiais",
  "Материалы временно недоступны. Попробуйте обновить список.": "Os materiais estão temporariamente indisponíveis. Tente atualizar a lista.",
  "Материалы пока недоступны.": "Os materiais ainda não estão disponíveis.",
  "Месяц": "Mês",
  "Минимальная сумма": "Valor mínimo",
  "На рассмотрении": "Em análise",
  "Налоговый номер": "Número de identificação fiscal",
  "Начисления за период": "Créditos do período",
  "Начислено Circle": "Circle creditados",
  "Начислено за период: {0} Circle": "Creditado no período: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Não foi possível salvar a solicitação com segurança ou verificar o titular. O envio não foi realizado.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Não foi possível recuperar o envio. Entre em contato com o suporte antes de fazer uma nova solicitação.",
  "Не удалось загрузить друзей.": "Não foi possível carregar os amigos.",
  "Не удалось загрузить историю выводов.": "Não foi possível carregar o histórico de levantamentos.",
  "Не удалось загрузить тарифы.": "Não foi possível carregar as tarifas.",
  "Не удалось открыть отправку в Telegram.": "Não foi possível abrir o envio no Telegram.",
  "Не удалось проверить владельца. Обновите страницу.": "Não foi possível verificar o titular. Atualize a página.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Não foi possível ler a solicitação salva. O novo saque está bloqueado.",
  "Не удалось сохранить состояние отправки.": "Não foi possível salvar o estado do envio.",
  "Неделя": "Semana",
  "Нет данных": "Sem dados",
  "Новая заявка": "Nova solicitação",
  "Новая заявка на вывод сейчас недоступна.": "Não é possível criar uma nova solicitação de saque no momento.",
  "О программе": "Sobre o programa",
  "Обзор": "Visão geral",
  "Обновите страницу или обратитесь в поддержку.": "Atualize a página ou entre em contato com o suporte.",
  "Обновить историю выводов": "Atualizar histórico de levantamentos",
  "Обновить материалы": "Atualizar materiais",
  "От {0} покупателей": "A partir de {0} compradores",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Nenhuma resposta recebida. Verifique a mesma solicitação: os dados e a chave foram salvos.",
  "Отклонён": "Rejeitado",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Abra o Mini App no Telegram com suporte para envio de materiais.",
  "Открыть сторис в Telegram": "Abrir story no Telegram",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "O envio não foi confirmado. A nova tentativa verificará a solicitação anterior sem realizar outro envio.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Envio cancelado. Você pode abrir novamente a seleção de chat.",
  "Оценка дохода": "Estimativa de rendimento",
  "Оценка за {0} месяцев: {1} Circle": "Estimativa para {0} meses: {1} Circle",
  "Оценка за месяц: {0} Circle": "Estimativa mensal: {0} Circle",
  "Переходы": "Cliques",
  "Период обзора": "Período da visão geral",
  "Плательщик": "Pagador",
  "Подать заявку на вывод": "Solicitar saque",
  "Подготовить QR-код": "Preparar código QR",
  "Подготовить другой материал": "Preparar outro material",
  "Подготовить материал": "Preparar material",
  "Поделитесь своей ссылкой или промокодом.": "Compartilhe seu link ou código promocional.",
  "Поделиться": "Compartilhar",
  "Пока без покупок": "Ainda sem compras",
  "Пока недоступно": "Indisponível por enquanto",
  "Покупатели": "Compradores",
  "Покупки друзей учитывает сервер STEOS ID.": "As compras dos amigos são contabilizadas pelo servidor STEOS ID.",
  "Полные условия программы": "Termos completos do programa",
  "Пользователь": "Usuário",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Experimente o STEOS: {0}\nCódigo promocional: {1}",
  "Привязка до: {0}": "Vinculação até: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "A vinculação do amigo convidado é válida por {0} meses.",
  "Приглашён: {0}": "Convidado: {0}",
  "Проверить загрузку счёта": "Verificar carregamento da fatura",
  "Проверить ту же заявку": "Verificar a mesma solicitação",
  "Проверьте налоговый номер получателя.": "Verifique o número de identificação fiscal do beneficiário.",
  "Проверьте реквизиты и счёт.": "Verifique os dados bancários e a fatura.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Verifique o valor do saque: deve ser um número inteiro dentro do intervalo disponível.",
  "Проверяем владельца…": "Verificando o titular…",
  "Проверяем заявку или счёт…": "Verificando a solicitação ou a fatura…",
  "Процент и доступность вывода определяет опубликованная программа.": "A porcentagem e a disponibilidade de saque são determinadas pelo programa publicado.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "As porcentagens, os prazos e as restrições são apresentados com base nos dados publicados pelo servidor.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "O tamanho da fatura deve ser de 1 byte a 10 MB.",
  "Регистрации": "Registros",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "O resultado do carregamento da fatura é desconhecido. Verifique o carregamento sem reenviar o arquivo.",
  "Скачать PNG": "Baixar PNG",
  "Сколько действует привязка друга?": "Por quanto tempo dura a vinculação de um amigo?",
  "Скопировать текст": "Copiar texto",
  "Сохранена неподтверждённая заявка": "Solicitação não confirmada salva",
  "Срок рассмотрения, дней": "Prazo de análise, em dias",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "O link e o código promocional são adicionados pelo servidor. Selecione um material disponível.",
  "Ссылка на полный документ условий пока не опубликована.": "O link para o documento completo dos termos ainda não foi publicado.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "O story foi aberto no Telegram. É necessário confirmar a publicação no editor.",
  "Сумма в Circle": "Valor em Circle",
  "Сумма меньше минимальной суммы вывода.": "O valor é inferior ao valor mínimo para saque.",
  "Сумма превышает доступный остаток.": "O valor excede o saldo disponível.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Fatura de pagamento · PDF, JPG ou PNG, até 10 MB",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "A fatura não foi carregada ou verificada com sucesso. Selecione um PDF, JPG ou PNG de até 10 MB.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "A fatura ainda não foi confirmada. Repita a verificação ou selecione outro arquivo.",
  "Счёт проверен": "Fatura verificada",
  "Текст приглашения": "Texto do convite",
  "Текст сообщения": "Texto da mensagem",
  "Тексты": "Textos",
  "Тестовая заявка": "Solicitação de teste",
  "Тестовая программа dev. Реальные выплаты выключены.": "Programa de teste dev. Os pagamentos reais estão desativados.",
  "Тестовая программа: реальные выплаты отключены.": "Programa de teste: pagamentos reais desativados.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Cálculo de teste dev. Isto é apenas uma estimativa; nenhum crédito será efetuado.",
  "Укажите имя получателя: до 200 символов.": "Informe o nome do beneficiário: até 200 caracteres.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "O servidor determina o nível com base nos compradores contabilizados. Consulte a aba «Níveis».",
  "Уровни": "Níveis",
  "Условия начислений пока не опубликованы.": "As condições de crédito ainda não foram publicadas.",
  "Условия программы": "Termos do programa",
  "Учёт переходов по ссылке пока недоступен.": "O rastreamento de cliques no link ainda não está disponível.",
  "Фильтр друзей": "Filtro de amigos",
  "Что делать, если данные не обновились?": "O que fazer se os dados não forem atualizados?",
  "Шаги": "Etapas",
  "Баннер": "Banner",
  "QR-постер": "Pôster QR",
  "{0} / 300 знаков": "{0} / 300 caracteres",
  "· до 20 МБ": "· até 20 MB",
  "Агент готовит ответ…": "O agente está preparando uma resposta…",
  "Аудиозапись": "Gravação de áudio",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Grátis apenas no dev. Até 30 segundos e 10 MB. O texto pode ser corrigido antes do envio.",
  "Ваш вопрос": "Sua pergunta",
  "Вопрос или название инструмента": "Pergunta ou nome da ferramenta",
  "Вопросов: {0}": "Perguntas: {0}",
  "Вопросы · {0}": "Perguntas · {0}",
  "Восстанавливаем чат…": "Restaurando o chat…",
  "Все сервисы работают": "Todos os serviços estão funcionando",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Selecione MP3, WAV ou M4A de até 20 MB.",
  "Выберите инструкцию к нужному инструменту или странице.": "Selecione a instrução para a ferramenta ou página desejada.",
  "Диктовать вопрос": "Ditar pergunta",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "A ditado não foi confirmado. Repita a verificação da solicitação ou do upload anterior.",
  "До": "Até",
  "Ещё спрашивают": "Também perguntam",
  "Загружаем справку…": "Carregando a ajuda…",
  "Загружаем статус…": "Carregando o status…",
  "Закрыть чат": "Fechar chat",
  "ИИ-агент поддержки": "Agente de suporte com IA",
  "ИИ-агент сейчас недоступен.": "O agente de suporte com IA está indisponível no momento.",
  "Инструкции": "Instruções",
  "Инструкции · {0}": "Instruções · {0}",
  "Инструкции пока не опубликованы.": "As instruções ainda não foram publicadas.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "O resultado da solicitação ainda é desconhecido. Uma nova pergunta não será enviada.",
  "Как пользоваться STEOS": "Como usar o STEOS",
  "Кружки и говорящие видео": "Círculos e vídeos falados",
  "Медленнее обычного": "Mais lento que o normal",
  "Написать агенту": "Escrever para o agente",
  "Начать": "Começar",
  "Начать новую диктовку": "Iniciar uma nova ditado",
  "Не помогло": "Não ajudou",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Não foi possível restaurar a ditado. A nova solicitação está bloqueada.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Não foi possível restaurar o chat. Entre em contato com o suporte.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Não foi possível carregar o suporte. Tente novamente.",
  "Не удалось загрузить статус сервисов.": "Não foi possível carregar o status dos serviços.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Não foi possível confirmar a resposta. Você pode iniciar um novo chat ou escrever para o suporte.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Não foi possível obter uma resposta. Repita a verificação sem fazer uma nova pergunta.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Não foi possível verificar o proprietário do chat. Tente abrir novamente.",
  "Не удалось сохранить новый чат.": "Não foi possível salvar o novo chat.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Não foi possível salvar a avaliação. Tente novamente.",
  "Недоступен": "Indisponível",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Alguns serviços estão mais lentos que o normal. Abrir status",
  "Нет подтверждённых данных": "Nenhum dado confirmado",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Não encontramos nada. Tente outras palavras ou pergunte ao agente de IA.",
  "Новый чат": "Novo chat",
  "Обзор приложения": "Visão geral do aplicativo",
  "Обновить справку": "Atualizar ajuda",
  "Обновить статус": "Atualizar status",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Verificação publicada. O monitoramento automático não é declarado.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "A resposta não foi confirmada. Verifique a solicitação anterior ou escreva para o suporte.",
  "Отвечает по опубликованной справке STEOS": "Responde com base na ajuda publicada do STEOS",
  "Открыть инструкции": "Abrir instruções",
  "Открыть инструкцию": "Abrir instrução",
  "Открыть инструмент": "Abrir ferramenta",
  "Открыть ответ справки": "Abrir resposta da ajuda",
  "Открыть раздел": "Abrir seção",
  "Отправить вопрос": "Enviar pergunta",
  "Оценка ответа": "Avaliação da resposta",
  "Очистить поиск": "Limpar pesquisa",
  "Поиск по справке": "Pesquisar na ajuda",
  "Полезно": "Útil",
  "Помощь": "Ajuda",
  "Популярные вопросы": "Perguntas populares",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "A última verificação está desatualizada. O estado atual é desconhecido.",
  "Посмотреть короткий обзор": "Ver resumo rápido",
  "Предыдущая": "Anterior",
  "Проверено: {0}": "Verificado: {0}",
  "Проверить диктовку": "Verificar ditado",
  "Пропустить": "Pular",
  "Работает": "Funcionando",
  "Распознать вопрос": "Reconhecer pergunta",
  "Распознаём вопрос…": "Reconhecendo a pergunta…",
  "Результаты поиска": "Resultados da pesquisa",
  "Следующая": "Próxima",
  "Советы": "Dicas",
  "Справка пока не опубликована.": "A ajuda ainda não foi publicada.",
  "Спросите что угодно": "Pergunte qualquer coisa",
  "Спросить ИИ-агента": "Perguntar ao agente de IA",
  "Спросить ИИ-агента поддержки": "Perguntar ao agente de suporte com IA",
  "Статус": "Status",
  "Статус сервисов": "Status dos serviços",
  "Статус сервисов пока не публикуется.": "O status dos serviços ainda não é publicado.",
  "Статья недоступна": "Artigo indisponível",
  "Темы": "Tópicos",
  "Темы пока не опубликованы.": "Os tópicos ainda não foram publicados.",
  "Точного ответа в справке нет.": "Não há uma resposta exata na ajuda.",
  "Чат не отправляет сообщения человеку автоматически.": "O chat não envia mensagens para uma pessoa automaticamente.",
  "Читаем запись…": "Lendo a gravação…",
  "Эта статья больше не входит в опубликованную справку.": "Este artigo não faz mais parte da ajuda publicada.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Selecione um arquivo MP3, WAV ou M4A de até {0} MB.",
  "До {0} · до {1} МБ": "Até {0} · até {1} MB",
  "Нужна запись от 1 секунды до {0}.": "A gravação deve ter entre 1 segundo e {0}.",
  "Остановить запись · {0}": "Parar gravação · {0}",
  "{0} C/сек": "{0} C/s",
  "Все инструменты": "Todas as ferramentas",
  "Все шаблоны": "Todos os modelos",
  "Вся подборка": "Toda a coleção",
  "Выбрать, кто играет": "Escolher quem participa",
  "Голос и музыка": "Voz e música",
  "Двое": "Duas pessoas",
  "Дети": "Crianças",
  "Дешевле": "Mais barato",
  "Для бизнеса": "Para empresas",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Há vários modelos disponíveis para esta ação. Escolha o mais adequado no catálogo.",
  "Загружаем шаблон…": "A carregar o modelo…",
  "Закрыть поиск": "Fechar pesquisa",
  "Закрыть превью": "Fechar pré-visualização",
  "Инструменты": "Ferramentas",
  "Искать во всех шаблонах": "Pesquisar em todos os modelos",
  "Короче": "Mais curto",
  "Кто играет": "Quem participa",
  "Найти инструмент или шаблон": "Encontrar uma ferramenta ou modelo",
  "Не удалось загрузить выбранный вариант.": "Não foi possível carregar a opção selecionada.",
  "Не удалось загрузить шаблон. Обновите превью.": "Não foi possível carregar o modelo. Atualize a pré-visualização.",
  "Не удалось открыть инструмент.": "Não foi possível abrir a ferramenta.",
  "Несколько": "Várias pessoas",
  "Новые": "Novos",
  "Один": "Uma pessoa",
  "от {0} C": "A partir de {0} C",
  "от {0} C/сек": "A partir de {0} C/s",
  "От {0} Circle": "A partir de {0} Circle",
  "От А до Я": "De A a Z",
  "Очистить": "Limpar",
  "Питомцы": "Animais de estimação",
  "По желанию": "Opcional",
  "Подборка пока недоступна.": "A coleção ainda não está disponível.",
  "Подборки": "Coleções",
  "Поиск": "Pesquisar",
  "Пока нет доступных шаблонов": "Ainda não há modelos disponíveis",
  "Популярные": "Populares",
  "После": "Depois",
  "Превью шаблона": "Pré-visualização do modelo",
  "Пример результата пока не опубликован.": "Ainda não foi publicado nenhum exemplo do resultado.",
  "Пример сейчас недоступен.": "O exemplo não está disponível neste momento.",
  "Рекомендуем": "Recomendados",
  "Смотреть все": "Ver tudo",
  "Сначала": "Ordenar",
  "Сравнить до и после": "Comparar antes e depois",
  "Стилей: {0}. Выбор на следующем шаге.": "Estilos: {0}. Escolha na próxima etapa.",
  "Удерживайте для просмотра": "Mantenha premido para visualizar",
  "Цена уточняется в форме создания.": "O preço será confirmado no formulário de criação.",
  "Частые вопросы": "Perguntas frequentes",
  "Что нужно": "O que é necessário",
  "Что хотите сделать?": "O que pretende fazer?",
  "Шаблоны и подборки": "Modelos e coleções",
  "Это действие пока недоступно.": "Esta ação ainda não está disponível.",
  "е": "e",
  "за секунду": "por segundo",
  "ё": "ё",
  "{0} C в минуту": "{0} € por minuto",
  "{0} C за 100 знаков": "{0} € por 100 caracteres",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "O proprietário da sessão foi alterado. Volte ao estúdio após atualizar a página.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Não foi possível restaurar a solicitação salva. Uma nova geração foi bloqueada.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Não foi possível atualizar a solicitação salva. Uma nova geração foi bloqueada.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Não foi possível verificar o proprietário. Uma nova geração foi bloqueada.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Não foi possível salvar a solicitação. O envio não foi realizado.",
  "от {0} C в минуту": "A partir de {0} € por minuto",
  "от {0} C за 100 знаков": "A partir de {0} € por 100 caracteres",
  "Проверить статус заказа": "Verificar o status do pedido",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "O status ainda não foi confirmado. Verifique este mesmo pedido mais tarde.",
  "в минуту": "por minuto",
  "за 100 знаков": "por 100 caracteres",
  "Анимация звука": "Animação do som",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "O vídeo manterá a fala original. Selecione um trecho de até um minuto.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "O vídeo manterá as palavras originais. A voz pode ser alterada. Selecione um trecho de até um minuto.",
  "Вид персонажа": "Aparência do personagem",
  "Видео готово": "Vídeo pronto",
  "Видео не создано": "Vídeo não criado",
  "Волна": "Onda",
  "Выберите, кто говорит": "Escolha quem está a falar",
  "Выбранное фото": "Foto selecionada",
  "Движение": "Movimento",
  "Добавьте видео": "Adicione um vídeo",
  "Дополнительная настройка": "Configuração adicional",
  "Другой голос для записи": "Outra voz para a gravação",
  "Ещё вариант": "Mais uma opção",
  "Ещё настройки": "Mais configurações",
  "Изменить данные": "Alterar dados",
  "Источник": "Fonte",
  "Источник лица": "Fonte do rosto",
  "Источник речи": "Fonte da fala",
  "Кадр по вертикали": "Enquadramento vertical",
  "Кадр по горизонтали": "Enquadramento horizontal",
  "Каких движений избегать": "Que movimentos evitar",
  "Конец фрагмента, секунды": "Fim do trecho, em segundos",
  "Кружком": "Como mensagem de vídeo",
  "Кружок готов": "Vídeo circular pronto",
  "Кружок не создан": "Vídeo circular não criado",
  "Люди и персонажи": "Pessoas e personagens",
  "Напишите текст или добавьте запись": "Escreva um texto ou adicione uma gravação",
  "Начало фрагмента, секунды": "Início do trecho, em segundos",
  "Не удалось загрузить виды персонажа.": "Não foi possível carregar as aparências dos personagens.",
  "Не удалось загрузить людей и персонажей.": "Não foi possível carregar as pessoas e os personagens.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Não foi possível confirmar a conclusão do pedido. Uma nova geração não foi iniciada.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Não foi possível verificar o envio. Abra o histórico do pedido.",
  "Оставить голос записи": "Manter a voz da gravação",
  "Открыть в чате": "Abrir no chat",
  "Отправлено в чат": "Enviado para o chat",
  "По умолчанию": "Por predefinição",
  "Подтвердите право использовать материалы": "Confirme o direito de utilizar os materiais",
  "Полосы": "Faixas",
  "Портретное": "Formato retrato",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "O pedido anterior ainda não foi concluído. Verifique primeiro o resultado.",
  "Приближение": "Aproximação",
  "Проверка отклонила материал. Измените исходные данные.": "A verificação rejeitou o material. Altere os dados de origem.",
  "Продолжить проверку отправки": "Continuar a verificar o envio",
  "Результат недоступен. Проверьте историю заказа.": "Resultado indisponível. Verifique o histórico do pedido.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "O resultado do envio ainda não foi confirmado. Continue a verificação com a mesma chave.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "O resultado ainda não foi confirmado. Verifique este pedido antes de criar outro.",
  "Своё видео": "O seu vídeo",
  "Своё фото": "A sua foto",
  "Создание сейчас недоступно": "A criação está indisponível neste momento",
  "Создать кружок": "Criar mensagem de vídeo",
  "Создаём видео": "A criar vídeo",
  "Списание возвращено": "Débito reembolsado",
  "Тестовый заказ без списания": "Pedido de teste sem débito",
  "Файлом": "Como ficheiro",
  "Фоновый звук": "Som de fundo",
  "Фото с лицом": "Foto com rosto",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "O preço ou a versão da ferramenta foi alterado. Atualize o formulário e verifique o custo.",
  "Человек или персонаж": "Pessoa ou personagem",
  "Что скажет?": "O que vai dizer?",
  "Напишите не меньше {0} знаков": "Escreva pelo menos {0} caracteres",
  "Текст отклонён проверкой. Измените текст.": "Texto rejeitado pela verificação. Altere o texto.",
  "В видео прозвучат новые слова.": "No vídeo, serão pronunciadas palavras novas.",
  "Если речь длиннее видео, ролик повторится.": "Se a fala for mais longa que o vídeo, o clipe será repetido.",
  "Исходная речь": "Fala original",
  "Новая запись": "Nova gravação",
  "Новые слова текстом": "Novas palavras em texto",
  "Речь в видео": "Fala no vídeo",
  "Размер файла не должен превышать {0} МБ.": "O arquivo não deve exceder {0} MB.",
  "До {0} МБ": "Até {0} MB",
  "Альбомное": "Paisagem",
  "Альбомом": "Em formato paisagem",
  "Без стиля": "Sem estilo",
  "В новом стиле": "Em um novo estilo",
  "Вариант": "Variante",
  "Во весь экран": "Tela cheia",
  "Восстановить фото": "Restaurar foto",
  "Все стили": "Todos os estilos",
  "Все темы": "Todos os temas",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Selecione uma ferramenta no catálogo e, em seguida, confirme o uso da foto.",
  "Выберите подходящее фото до {0} МБ.": "Selecione uma foto adequada de até {0} MB.",
  "Выберите стиль или свой референс": "Escolha um estilo ou sua própria referência",
  "Выбран свой референс": "Referência própria selecionada",
  "Выбрать стиль": "Escolher estilo",
  "Двигайте картинку, чтобы выбрать кадр": "Mova a imagem para selecionar o enquadramento",
  "Диафрагма": "Abertura",
  "Добавить человека": "Adicionar pessoa",
  "Добавьте описание, от 10 знаков": "Adicione uma descrição com pelo menos 10 caracteres",
  "Загрузите фото": "Carregue uma foto",
  "Заполните обязательные поля": "Preencha os campos obrigatórios",
  "Изменить фото": "Alterar foto",
  "Использовать выбранное фото результата": "Usar a foto de resultado selecionada",
  "Кадр": "Enquadramento",
  "Кадрирование": "Recorte",
  "Как у фото": "Como na foto",
  "Камера": "Câmera",
  "Найти настройку съёмки": "Encontrar configuração de fotografia",
  "Найти стиль": "Encontrar estilo",
  "Настройки съёмки недоступны.": "As configurações de fotografia não estão disponíveis.",
  "Начать новое улучшение": "Iniciar uma nova melhoria",
  "Не выбран": "Não selecionado",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Não foi possível restaurar a melhoria. Um novo envio foi bloqueado.",
  "Не удалось загрузить режимы фото.": "Não foi possível carregar os modos de foto.",
  "Не удалось загрузить фото.": "Não foi possível carregar a foto.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Não foi possível usar a foto do resultado. Abra o pedido original e tente novamente.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Não foi possível abrir o modo. Tente novamente.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Não foi possível enviar a foto selecionada. Tente novamente.",
  "Не удалось проверить владельца.": "Não foi possível verificar o proprietário.",
  "Не удалось прочитать фото.": "Não foi possível ler a foto.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Não foi possível melhorar o texto. O texto original foi mantido.",
  "О стиле": "Sobre o estilo",
  "Объектив": "Lente",
  "Оживить фото": "Animar foto",
  "Описание во весь экран": "Descrição em tela cheia",
  "Описание длиннее допустимого": "A descrição excede o limite permitido",
  "По вертикали": "Verticalmente",
  "По горизонтали": "Horizontalmente",
  "По описанию": "Por descrição",
  "Повторить прежнее улучшение": "Repetir a melhoria anterior",
  "Подтвердите права на материалы": "Confirme os direitos sobre os materiais",
  "Пример": "Exemplo",
  "Проверить улучшение": "Verificar melhoria",
  "Проверяем фото…": "Verificando a foto…",
  "Ракурс": "Ângulo",
  "Раскрасить чёрно-белое": "Colorir foto em preto e branco",
  "Режим фото": "Modo de foto",
  "Референс должен быть не меньше 256 × 256 пикселей.": "A referência deve ter pelo menos 256 × 256 pixels.",
  "Свернуть": "Recolher",
  "Свет": "Luz",
  "Свой референс": "Referência própria",
  "Свой референс сейчас недоступен": "A referência própria está indisponível no momento",
  "Сделать рилс": "Criar Reel",
  "Сколько фото": "Quantidade de fotos",
  "Создать фото": "Criar foto",
  "Создаём фото": "Criando foto",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "O prazo para verificar a melhoria expirou. O texto original foi mantido.",
  "Тема стиля": "Tema do estilo",
  "Убрать из кадра": "Remover do enquadramento",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "A melhoria ainda não foi confirmada. O texto original foi mantido.",
  "Улучшить": "Melhorar",
  "Формат файла": "Formato do arquivo",
  "Фото готовы": "Fotos prontas",
  "Фото на аватарку": "Foto para avatar",
  "Фото не создано": "A foto não foi criada",
  "Цвет": "Cor",
  "Что дальше": "O que vem a seguir",
  "Что делает в кадре": "O que faz no enquadramento",
  "Выберите разных людей в кадре": "Escolha pessoas diferentes para a cena",
  "Измените описание и попробуйте улучшить его снова.": "Altere a descrição e tente melhorá-la novamente.",
  "Использовать референс": "Usar referência",
  "Авто": "Auto",
  "Без движения": "Sem movimento",
  "Видео должно длиться не меньше секунды": "O vídeo deve durar pelo menos um segundo",
  "Выберите главное фото": "Selecione a foto principal",
  "Выберите один исходный файл": "Escolha um arquivo de origem",
  "Выберите файл подходящего формата и размера": "Escolha um arquivo com formato e tamanho aceitos",
  "Выберите фрагмент от 1 до 10 секунд": "Selecione um trecho de 1 a 10 segundos",
  "Главное фото": "Foto principal",
  "Длительность исходника: {0} с": "Duração do original: {0} s",
  "Добавить речь": "Adicionar fala",
  "Загрузите видео": "Envie um vídeo",
  "Загрузите фото или видео": "Envie uma foto ou vídeo",
  "Загрузить": "Enviar",
  "Загрузить видео": "Enviar vídeo",
  "Загрузить фото": "Enviar foto",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "O áudio original não é mantido: o modelo cria um novo áudio.",
  "Звук от модели": "Áudio gerado pelo modelo",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "O modelo cria sons de fundo, ruídos e música. A fala pode ser adicionada depois.",
  "Использовать видео результата": "Usar o vídeo resultante",
  "Исходное видео": "Vídeo original",
  "Исходный файл": "Arquivo original",
  "Как двигаться": "Como se mover",
  "Конец фрагмента, мс": "Fim do trecho, ms",
  "Конец, секунды": "Fim, segundos",
  "Люди в кадре недоступны для этого режима": "Pessoas em cena indisponíveis neste modo",
  "Начало фрагмента, мс": "Início do trecho, ms",
  "Начало, секунды": "Início, segundos",
  "Не удалось загрузить режимы видео.": "Não foi possível carregar os modos de vídeo.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Não foi possível usar o vídeo resultante. Abra o pedido original e tente novamente.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Não foi possível transferir o vídeo. Abra o pedido original e tente novamente.",
  "Новое": "Novo",
  "Объёмное фото создаётся без звука": "A foto em profundidade é criada sem áudio",
  "Первый кадр": "Primeiro quadro",
  "Продолжить загрузку": "Continuar envio",
  "Разрешение": "Resolução",
  "Режим видео": "Modo de vídeo",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Usaremos a foto principal. Selecione a principal para recortar.",
  "Снять": "Capturar",
  "Снять видео": "Gravar vídeo",
  "Создать видео": "Criar vídeo",
  "Темп": "Ritmo",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Formato fixo: retrato 3:4, vídeo de 5 segundos",
  "Фото товара": "Fotos do produto",
  "Фрагмент от 1 до 10 секунд": "Trecho de 1 a 10 segundos",
  "Хит": "Popular",
  "Что изменить": "O que mudar",
  "Этот режим видео пока недоступен": "Este modo de vídeo está indisponível no momento",
  "Как у исходника": "Como o original",
  "Со звуком": "Com áudio",
  "Без звука": "Sem áudio",
  "5 секунд": "5 segundos",
  "10 секунд": "10 segundos",
  "Не удалось прочитать файл.": "Não foi possível ler o arquivo.",
  "1. Видео с вами": "1. Vídeo com você",
  "1. Видео с движениями": "1. Vídeo de movimentos",
  "2. Кем стать": "2. Em quem se transformar",
  "2. Кто повторит": "2. Quem vai repetir",
  "Видео должно длиться не меньше {0} секунд": "O vídeo deve durar pelo menos {0} segundos",
  "Водяной знак — недоступен": "Marca d’água — indisponível",
  "Вы, близкий или персонаж": "Você, alguém próximo ou um personagem",
  "Выберите допустимый фрагмент видео": "Selecione um trecho com duração permitida",
  "Выберите одного героя": "Escolha um protagonista",
  "Выберите фон": "Selecione um fundo",
  "Выберите, кто повторит движения": "Escolha quem repetirá os movimentos",
  "Голос героя — недоступен": "Voz do personagem — indisponível",
  "Другой голос — недоступен": "Outra voz — indisponível",
  "Загрузите видео с движениями": "Envie um vídeo de movimentos",
  "Из видео": "Do vídeo",
  "Изменить людей и свои фото": "Gerenciar pessoas e suas fotos",
  "Источник героя": "Origem do personagem",
  "Исходный звук сохраняется, если он есть в ролике.": "O áudio original é mantido se o vídeo tiver som.",
  "Кадр, ракурс и фон берутся с фото героя.": "O enquadramento, o ângulo e o fundo vêm da foto do personagem.",
  "Кто повторит движения": "Quem repetirá os movimentos",
  "На фото должны быть видны голова, плечи и корпус.": "A foto deve mostrar a cabeça, os ombros e o tronco.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Deve haver uma pessoa no quadro. A foto e o vídeo devem mostrar a cabeça, os ombros e o tronco.",
  "Подтвердите права и согласие человека": "Confirme os direitos e o consentimento da pessoa",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Confirmo meus direitos sobre os materiais e o consentimento da pessoa para usar sua imagem",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "A conversão em vídeo circular está indisponível: o resultado não tem uma faixa de áudio confirmada.",
  "Режим движения": "Modo de movimento",
  "С героя": "Do personagem",
  "Смена голоса пока недоступна": "A troca de voz está indisponível no momento",
  "Снять выбор": "Limpar seleção",
  "Сохранение исходного звука не подтверждено.": "A preservação do áudio original não está confirmada.",
  "Стать персонажем": "Virar um personagem",
  "Сцена и движения берутся из видео; внешность может отличаться.": "A cena e os movimentos vêm do vídeo; a aparência pode variar.",
  "Только свои фото или с согласием человека на фото": "Use apenas suas fotos ou com o consentimento da pessoa fotografada",
  "Фон": "Fundo",
  "Фото героя": "Foto do personagem",
  "Фрагмент от {0} до {1} секунд": "Trecho de {0} a {1} segundos",
  "{0} символов": "{0} caracteres",
  "Авито": "Avito",
  "Английский": "Inglês",
  "Выберите аудио или видео": "Escolha áudio ou vídeo",
  "Выбрать": "Selecionar",
  "Гарантия": "Garantia",
  "Да": "Sim",
  "Для чего нужен промпт": "Finalidade do prompt",
  "Для этого инструмента сократите текст до 500 символов.": "Reduza o texto a 500 caracteres para esta ferramenta.",
  "Добавьте текст": "Adicione texto",
  "Добавьте файл": "Adicione um arquivo",
  "Дополнительные варианты": "Mais variantes",
  "Дополнительные варианты пока не подтверждены.": "As variantes adicionais ainda não foram confirmadas.",
  "Дружелюбный": "Amigável",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Envie uma gravação ou grave sua voz. A transcrição começa após a confirmação.",
  "Исходное фото": "Foto original",
  "Как изменить текст": "Como alterar o texto",
  "Комплект": "Conteúdo da embalagem",
  "Короткий": "Curto",
  "Материал": "Material",
  "Музыка": "Música",
  "На весь экран": "Tela cheia",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Não foi possível abrir a ferramenta. Verifique a conta e o tamanho do texto.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Não foi possível confirmar as variantes. Verifique a mesma solicitação.",
  "Не удалось скачать текст.": "Não foi possível baixar o texto.",
  "Не удалось скопировать текст.": "Não foi possível copiar o texto.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Não foi possível salvar o rascunho. A criação está bloqueada para evitar perda de dados.",
  "Нейтральный": "Neutro",
  "Нет": "Não",
  "Объём описания": "Tamanho da descrição",
  "Описание товара": "Descrição do produto",
  "Повторить запрос с тем же ключом": "Repetir com a mesma chave",
  "Подарочный": "Presente",
  "Подробнее": "Mais detalhes",
  "Подробный": "Detalhado",
  "Подтверждаю права на материалы": "Confirmo meus direitos sobre os materiais",
  "Пожелания": "Preferências",
  "Показать время": "Mostrar tempos",
  "Показать всё": "Mostrar tudo",
  "Премиальный": "Premium",
  "Проверить тот же запрос": "Verificar a mesma solicitação",
  "Продающий": "Voltado a vendas",
  "Промпт из видео пока недоступен.": "Prompt a partir de vídeo ainda indisponível.",
  "Промпт из фото": "Prompt de uma foto",
  "Разделить по собеседникам": "Separar falantes",
  "Размеры": "Dimensões",
  "Распознавание по ссылке YouTube пока недоступно.": "A transcrição por link do YouTube ainda está indisponível.",
  "Распознать": "Transcrever",
  "Редактировать текст": "Editar texto",
  "Сайт": "Site",
  "Сбросить сохранённый черновик": "Redefinir rascunho salvo",
  "Скачать TXT": "Baixar TXT",
  "Скопировать весь текст": "Copiar todo o texto",
  "Собеседник {0}": "Falante {0}",
  "Создать промпт": "Criar um prompt",
  "Создать сценарий": "Criar um roteiro",
  "Создаём текст": "Criando texto",
  "Сократите пожелания": "Reduza as preferências",
  "Сократите текст": "Reduza o texto",
  "Список": "Lista",
  "Текст готов": "Texto pronto",
  "Текст из аудио и видео": "Texto de áudio e vídeo",
  "Текст не создан": "O texto não foi criado",
  "Тестовый режим без списания": "Modo de teste sem cobrança",
  "Тон описания": "Tom da descrição",
  "Улучшить промпт": "Melhorar um prompt",
  "Уход": "Cuidados",
  "Что добавить в описание": "O que adicionar à descrição",
  "Экспертный": "Especializado",
  "Язык": "Idioma",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Adicione uma foto na ferramenta aberta.",
  "Не удалось открыть фото.": "Não foi possível abrir a foto.",
  "Текст для видео": "Texto para o vídeo",
  "Цена этого выбора пока не подтверждена": "O preço desta escolha ainda não foi confirmado",
  "C за фото": "C por foto",
  "C за секунду": "C por segundo",
  "Обычный": "Normal",
  "Кто повторил": "Quem repetiu",
  "Человек с фото": "Pessoa da foto",
  "Сменить фон": "Mudar o fundo",
  "Убрать лишнее": "Remover o excesso",
  "Добавить очки": "Adicionar óculos",
  "Причёска": "Penteado",
  "Улыбка": "Sorriso",
  "Деловой образ": "Visual executivo",
  "Летний фон": "Fundo de verão",
  "Машет рукой": "Acenando",
  "Ветер": "Vento",
  "Плавнее": "Mais suave",
  "Ярче": "Mais brilho",
  "День в ночь": "Dia para noite",
  "Снег": "Neve",
  "Очки": "Óculos",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "O que deve aparecer na foto? Por exemplo: uma garota com guarda-chuva numa rua molhada, fim de tarde, luzes das vitrines",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "O que mudar na foto? Por exemplo: troque o fundo por uma cidade à noite, adicione óculos",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "O que adicionar ou mudar? Por exemplo: um terno social, um sorriso leve",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "O que acontece no vídeo? Por exemplo: a câmera sobrevoa devagar uma cidade à noite, luzes e asfalto molhado",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Como se mover? Por exemplo: sorri e acena, vento no cabelo",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "O que mudar no vídeo? Por exemplo: troque o fundo por uma cidade à noite, adicione neve",
  "Что добавить? Например: движения плавнее, ярче": "O que adicionar? Por exemplo: movimentos mais suaves, mais brilho",
  "Сменить голос в записи": "Mudar a voz de uma gravação",
  "Загрузите запись": "Envie uma gravação",
  "Ваша речь зазвучит выбранным голосом": "Sua fala vai soar com a voz escolhida",
  "Голосовое, интервью или заметку: уберём шум": "Mensagem de voz, entrevista ou nota: removeremos o ruído",
  "Библиотека и ваши клоны": "Biblioteca e seus clones",
  "Без переозвучки, выберите другой": "Sem conversão de voz, escolha outra",
  "· Мой голос": "· Minha voz",
  "· ещё {0}+ голосов": "· mais {0}+ vozes",
  "Убрать шум": "Remover ruído",
  "Перед сменой голоса уберём фон и эхо": "Antes de mudar a voz, removeremos o fundo e o eco",
  "Оставим только голос, без фона и эха": "Manteremos só a voz, sem fundo nem eco",
  "Голосовым или файлом: выберете, когда запись будет готова": "Como mensagem de voz ou arquivo: você escolhe quando a gravação estiver pronta",
  "Сменить голос": "Mudar a voz",
  "Сделать голосовым": "Transformar em mensagem de voz",
  "{0} · от {1} C": "{0} · a partir de {1} C",
  "Сначала остановите запись": "Primeiro pare a gravação",
  "Загрузите или запишите аудио": "Envie ou grave um áudio",
  "Читаем запись, секунду": "Lendo a gravação, um momento",
  "Запись длиннее {0}, загрузите короче": "A gravação tem mais de {0}, envie uma mais curta",
  "Выберите голос, которым зазвучит запись": "Escolha a voz com que a gravação vai soar",
  "Этот голос не умеет переозвучку, выберите другой": "Esta voz não faz conversão, escolha outra",
  "Пауза": "Pausar",
  "Длиннее {0}": "Mais de {0}",
  "Звучит запись": "Reproduzindo a gravação",
  "Прослушать запись": "Ouvir a gravação",
  "Загрузите запись короче": "Envie uma gravação mais curta",
  "Запись с микрофона": "Gravação do microfone",
  "Без шума": "Sem ruído",
  "Как в записи": "Como na gravação",
  "Слушать": "Ouvir",
  "Отправить голосовым": "Enviar como mensagem de voz",
  "Отправить файлом": "Enviar como arquivo",
  "Голосовое в чате": "Mensagem de voz no chat",
  "Файл в чате": "Arquivo no chat",
  "Голосовое в чате, в отдельной теме": "Mensagem de voz no chat, em um tópico separado",
  "Файл в чате, в отдельной теме": "Arquivo no chat, em um tópico separado",
  "Тут откроется тема чата, куда бот прислал голосовое": "Aqui vai abrir o tópico do chat onde o bot enviou a mensagem de voz",
  "Тут откроется тема чата, куда бот прислал запись": "Aqui vai abrir o tópico do chat onde o bot enviou a gravação",
  "Меняем голос": "Mudando a voz",
  "Собираем запись": "Montando a gravação",
  "Шум убран": "Ruído removido",
  "Запись готова": "A gravação está pronta",
  "Голос изменён": "Voz alterada",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Você pode sair da tela: o bot vai avisar quando a gravação estiver pronta.",
  "Голос ваш, шума больше нет.": "Sua voz, sem ruído.",
  "Голос ваш, запись готова стать голосовым.": "Sua voz, e a gravação está pronta para virar mensagem de voz.",
  "Слова и интонация ваши, голос новый.": "Suas palavras e entonação, uma voz nova.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Enviaremos no chat como mensagem de voz ou arquivo, como preferir.",
  "Запись ещё собирается": "A gravação ainda está sendo montada",
  "Заставить говорить": "Fazer falar",
  "Заменить запись": "Substituir a gravação",
  "Загружаем запись": "Enviando a gravação",
  "Запись загружена": "Gravação enviada",
  "Запись собрана": "Gravação montada",
  "Запись не прошла проверку": "A gravação não passou na verificação",
  "запись не собрана": "a gravação não foi montada",
  "голос не изменён": "a voz não foi alterada",
  "Не получилось убрать шум": "Não foi possível remover o ruído",
  "Не получилось собрать запись": "Não foi possível montar a gravação",
  "Не получилось сменить голос": "Não foi possível mudar a voz",
  "Обновить форму": "Atualizar o formulário",
  "Запись {0}": "Gravação {0}",
  "Проверяем доступность": "Verificando a disponibilidade",
  "Загрузите запись заново": "Envie a gravação novamente",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Não foi possível escolher a voz. Tente novamente.",
  "Запись здесь недоступна, загрузите файл": "A gravação não está disponível aqui, envie um arquivo",
  "Не удалось прочитать запись, попробуйте ещё раз": "Não foi possível ler a gravação, tente novamente",
  "Ваш голос": "Sua voz",
  "в аудио": "no áudio",
  "со скидкой, {0} водяной знак": "com desconto, marca d’água {0}",
  "Запись ещё загружается": "A gravação ainda está carregando",
  "Проверяем отправку": "Verificando o envio",
  "Этот способ отправки сейчас недоступен": "Esta forma de envio não está disponível agora",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "O envio ainda não foi confirmado. Toque novamente e verificaremos a mesma solicitação.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Não foi possível passar a gravação. Abra o trabalho em «Histórico» e tente novamente.",
  "Попробовать ещё раз": "Tentar novamente",
  "Проверить ещё раз": "Verificar novamente",
  "К настройкам": "Voltar às configurações",
  "Заказ не создан": "Pedido não criado",
  "Заказ не подтверждён": "Pedido não confirmado",
  "остаток": "saldo",
  "Права на материалы": "Direitos sobre os materiais",
  "Только свои файлы или с согласия владельца": "Apenas arquivos próprios ou com o consentimento do titular",
  "Загружаем файл": "Enviando o arquivo",
  "Создаём": "Criando",
  "Файл больше {0} МБ, загрузите меньше": "O arquivo tem mais de {0} MB, envie um menor",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "A foto tem menos de {0} × {1} pixels, envie uma maior",
  "Видео длиннее {0}, загрузите короче": "O vídeo tem mais de {0}, envie um mais curto",
  "Запись короче {0}, загрузите длиннее": "A gravação tem menos de {0}, envie uma mais longa",
  "Видео короче {0}, загрузите длиннее": "O vídeo tem menos de {0}, envie um mais longo",
  "Не удалось открыть фото. Загрузите его заново.": "Não foi possível abrir a foto. Envie-a novamente.",
  "Не удалось открыть видео. Загрузите его заново.": "Não foi possível abrir o vídeo. Envie-o novamente.",
  "Можно до {0} фото": "Até {0} fotos",
  "Этот человек не участвует": "Esta pessoa não participa",
  "Добавьте фото": "Adicione fotos",
  "Файл не читается, загрузите другой": "Não é possível ler o arquivo, envie outro",
  "Запись слишком короткая": "A gravação é curta demais",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Não foi possível abrir a gravação para ouvir. Envie-a novamente.",
  "Файл не прошёл проверку. Выберите другой файл.": "O arquivo não passou na verificação. Escolha outro arquivo.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Muitos envios seguidos. Aguarde um minuto e escolha o arquivo novamente.",
  "Файл не принят. Выберите его снова.": "O arquivo não foi aceito. Escolha-o novamente.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "O personagem, a voz ou o modelo escolhido ficou indisponível. Escolha outro — o pedido não foi criado.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "A criação está indisponível agora. O pedido não foi criado e nenhum Circle foi debitado.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "O trabalho anterior ainda está sendo criado. Quando estiver pronto, envie o pedido novamente.",
  "Политику и запрещённые темы не пропускаем.": "Não aceitamos política nem temas proibidos.",
  "{0} C списаны, {1}.": "{0} C foram debitados, {1}.",
  "{0} C вернулись на баланс.": "{0} C voltaram para o seu saldo.",
  ", на шаге «{0}»": ", na etapa «{0}»",
  "Сбой на нашей стороне": "Falha do nosso lado",
  "{0} или {1}": "{0} ou {1}",
  "до {0}": "até {0}",
  "Записать": "Gravar",
  "Заменить": "Substituir",
  "Нужна запись: MP3, WAV или M4A": "É preciso uma gravação: MP3, WAV ou M4A",
  "Нужно фото: JPG или PNG": "É preciso uma foto: JPG ou PNG",
  "Нужно видео: MP4 или MOV": "É preciso um vídeo: MP4 ou MOV",
  "Нужен файл PDF, DOCX или TXT": "É preciso um arquivo PDF, DOCX ou TXT",
  "Нужно фото или видео": "É preciso uma foto ou um vídeo",
  "Файл больше {0} МБ": "O arquivo tem mais de {0} MB",
  "Остановить запись": "Parar a gravação",
  "Запрашиваем микрофон": "Solicitando o microfone",
  "Отменить запись": "Cancelar a gravação",
  "{0} КБ": "{0} KB",
  "{0} МБ": "{0} MB",
  "Не хватает {0} C · Пополнить": "Faltam {0} C · Adicionar saldo",
  "Не хватает Circle": "Circle insuficiente",
  "Не хватает {0} C": "Faltam {0} C",
  "На балансе {0} C, нужно {1} C": "Saldo de {0} C, são necessários {1} C",
  "Создать за {0} вместо {1} C": "Criar por {0} em vez de {1} C",
  "Создать за {0} C вместо {1} C": "Criar por {0} C em vez de {1} C",
  "Со скидкой всё равно не хватает {0}": "Mesmo com desconto, faltam {0}",
  "Со скидкой всё равно не хватает {0} C": "Mesmo com desconto, faltam {0} C",
  "Для этой работы скидки нет": "Não há desconto para este trabalho",
  "Сделать дешевле на {0}%, с водяным знаком": "Deixar {0}% mais barato, com marca d’água",
  "Сделать дешевле на 10%, с водяным знаком": "Deixar 10% mais barato, com marca d’água",
  "Назад в студию": "Voltar ao estúdio",
  "Работа ещё создаётся": "O trabalho ainda está sendo criado",
  "Ваше фото": "Sua foto",
  "Ваши фото": "Suas fotos",
  "Ваш текст": "Seu texto",
  "Ваша тема": "Seu tema",
  "Тема поста": "Tema da publicação",
  "Готовые кадры": "Fotos prontas",
  "Готовый кружок": "Vídeo circular pronto",
  "Готовый ролик": "Vídeo pronto",
  "Готовое фото": "Foto pronta",
  "Готовая аватарка": "Avatar pronto",
  "Готовые слайды": "Slides prontos",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Uma história pronta com você: edição e música já estão no modelo",
  "Пост в стиле шаблона, {0} на выбор": "Uma publicação no estilo do modelo, {0} para escolher",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Um avatar para redes sociais e mensageiros, {0} para escolher",
  "Фотосессия из {0} кадра в стиле шаблона": "Uma sessão de {0} foto no estilo do modelo",
  "Фотосессия из {0} кадров в стиле шаблона": "Uma sessão de {0} fotos no estilo do modelo",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Sua foto ganha vida em um vídeo curto, {0} para escolher",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Um personagem dirá seu texto em um vídeo circular do Telegram, {0} para escolher",
  "Карусель слайдов для поста, {0} на выбор": "Um carrossel de slides para a publicação, {0} para escolher",
  "{0} стиль": "{0} estilo",
  "{0} стиля": "{0} estilos",
  "{0} стилей": "{0} estilos",
  "{0}, выберете на следующем шаге": "{0}, você escolhe na próxima etapa",
  "Что скажет герой, до 250 знаков": "O que o personagem vai dizer, até 250 caracteres",
  "1 фото": "1 foto",
  "Любое, где хорошо видно лицо": "Qualquer uma em que o rosto apareça bem",
  "Лицо крупно и при хорошем свете": "Rosto em close e com boa luz",
  "Селфи, лицо крупно": "Uma selfie, rosto em close",
  "Снимок оживёт в ролике": "A foto ganha vida em um vídeo",
  "Или фото, из которых сделаем слайды": "Ou fotos com as quais faremos os slides",
  "Стиль кружка": "Estilo do vídeo circular",
  "1 человек": "1 pessoa",
  "Вы, близкие или персонаж": "Você, alguém próximo ou um personagem",
  "Ваши дети, до {0}": "Seus filhos, até {0}",
  "Ребёнок, одно фото": "Uma criança, uma foto",
  "Питомец, одно фото": "Um pet, uma foto",
  "Вы или близкие, одно фото": "Você ou alguém próximo, uma foto",
  "По желанию: вы, близкие или персонаж": "Opcional: você, alguém próximo ou um personagem",
  "По желанию: ваши дети, до {0}": "Opcional: seus filhos, até {0}",
  "По желанию: ребёнок, одно фото": "Opcional: uma criança, uma foto",
  "По желанию: питомец, одно фото": "Opcional: um pet, uma foto",
  "По желанию: вы или близкие, одно фото": "Opcional: você ou alguém próximo, uma foto",
  "Reels": "Reels",
  "Аватар": "Avatar",
  "{0} кадр": "{0} foto",
  "{0} кадра": "{0} fotos",
  "{0} кадров": "{0} fotos",
  "Выбрать, кто играет: {0}": "Escolher quem participa: {0}",
  "Сравнить: {0} и {1}": "Comparar: {0} e {1}",
  "Поровну": "Metade e metade",
  "Пример результата пока не опубликован": "O exemplo do resultado ainda não foi publicado",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "O resultado está guardado em «Histórico». Não o enviamos para o chat — foi o que escolheu nas definições.",
  "Результат сохранён в «Истории».": "O resultado está guardado em «Histórico».",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "O ficheiro do resultado ainda não está disponível. Verifique o trabalho em «Histórico».",
  ", голос для: {0}": ", voz para: {0}",
  ", играет: {0}": ", interpreta: {0}",
  ": добавьте свои фото": ": adicione suas fotos",
  ": добавьте фото": ": adicione fotos",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> de <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG ou PNG, até 10 MB",
  "JPG, PNG · до {0} снимков": "JPG, PNG · até {0} fotos",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV ou M4A, até 50 MB",
  "MP4 или MOV, до 200 МБ": "MP4 ou MOV, até 200 MB",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX ou TXT, até 20 MB",
  "{0} и {1}": "{0} e {1}",
  "{0} фото": "{0} fotos",
  "{0} фото · как в жизни": "{0} fotos · como na vida real",
  "{0}, персонаж": "{0}, personagem",
  "Анфас, вполоборота, с улыбкой и без": "De frente, de três quartos, com e sem sorriso",
  "Без модели": "Sem modelo",
  "Без сильных теней и фильтров": "Sem sombras fortes nem filtros",
  "Было": "Antes",
  "В близких": "Em pessoas próximas",
  "В кадре {0}": "No quadro: {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Já há {0} de {1} no quadro: desmarque alguém",
  "В кадре: {0}": "No quadro: {0}",
  "В роли «{0}» не больше {1}": "No papel «{0}», no máximo {1}",
  "В роль «{0}» персонажи не входят": "Personagens não entram no papel «{0}»",
  "В роль «{0}» подходят {1}": "No papel «{0}» cabem {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "As variantes são feitas a partir das suas fotos em «Avatar próprio». A escolhida aparece em «Quem está no quadro» em todas as telas.",
  "Ваш питомец из близких": "Seu animal de estimação das pessoas próximas",
  "Ваш ребёнок из близких": "Seu filho das pessoas próximas",
  "Ваши фото: один раз для всех инструментов": "Suas fotos: uma vez para todas as ferramentas",
  "Вкл": "Ligado",
  "Впишите имя": "Digite um nome",
  "Все <span class=\"mono\">{0}</span>": "Todos <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Todas as opções estão à vista",
  "Все персонажи": "Todos os personagens",
  "Вы и персонажи": "Você e personagens",
  "Вы или персонаж": "Você ou um personagem",
  "Вы, близкие и персонажи": "Você, pessoas próximas e personagens",
  "Вы, свои фото": "Você, suas fotos",
  "Вы: добавьте свои фото": "Você: adicione suas fotos",
  "Выберите вариант": "Escolha uma variante",
  "Выберите вариант для поля «{0}»": "Escolha uma opção para o campo «{0}»",
  "Выберите ниже": "Escolha abaixo",
  "Выберите одного": "Escolha uma pessoa",
  "Выберите, кто играет: {0}": "Escolha quem interpreta: {0}",
  "Выберите, кто это для вас": "Escolha quem é para você",
  "Выбирать во всех инструментах без загрузки": "Escolher em todas as ferramentas sem carregar de novo",
  "Выбор встанет во все инструменты": "A escolha vale para todas as ferramentas",
  "Выбрать «{0}»": "Escolher «{0}»",
  "Выбрать вариант": "Escolher uma variante",
  "Выбрать: {0}": "Escolher: {0}",
  "Выкл": "Desligado",
  "Выключится, когда выберете вариант": "Desliga quando você escolhe uma opção",
  "Группы": "Grupos",
  "Добавить": "Adicionar",
  "Добавить в кадр": "Adicionar ao quadro",
  "Добавьте свои фото": "Adicione suas fotos",
  "Добавьте свои фото или вариант": "Adicione suas fotos ou uma variante",
  "Добавьте фото: {0}": "Adicione fotos: {0}",
  "Другой голос": "Outra voz",
  "Ещё {0}: {1}": "Mais {0}: {1}",
  "Заготовки": "Modelos",
  "Загрузите файл": "Envie um arquivo",
  "Загрузить ещё": "Enviar mais",
  "Закрыть камеру": "Fechar câmera",
  "Запись недоступна. Загрузите видео.": "A gravação não está disponível. Envie um vídeo.",
  "Здесь подходят {0}": "Aqui cabem {0}",
  "Здесь только персонажи своей подборки": "Aqui, só personagens da própria coleção",
  "Играет: {0}": "Interpreta: {0}",
  "Из ваших фото": "A partir das suas fotos",
  "Из каталога": "Do catálogo",
  "Изменить ваши фото": "Editar suas fotos",
  "Изменить свои фото": "Editar suas fotos",
  "Изменить: {0}": "Editar: {0}",
  "Иллюстрация": "Ilustração",
  "Имя": "Nome",
  "Имя и фото · роли выбираются в ряду": "Nome e fotos · os papéis são escolhidos na fileira",
  "Искать стиль": "Pesquisar estilo",
  "Каким вы будете": "Como você vai aparecer",
  "Камера · лицо в кадр": "Câmera · rosto no enquadramento",
  "Камера · селфи в кадр": "Câmera · selfie no enquadramento",
  "Камера недоступна · имитация": "Câmera indisponível · simulação",
  "Камера недоступна. Загрузите файл.": "A câmera não está disponível. Envie um arquivo.",
  "Каталог 2 400+ голосов, подборки": "Catálogo com mais de 2.400 vozes, coleções",
  "Ко всем стилям": "Para todos os estilos",
  "Кто будет моделью на фото": "Quem será o modelo na foto",
  "Кто играет: <b>{0}</b>": "Quem interpreta: <b>{0}</b>",
  "Кто играет: {0}": "Quem interpreta: {0}",
  "Кто это для вас": "Quem é para você",
  "Лицо в круг, смотрите в камеру": "Rosto no círculo, olhe para a câmera",
  "Люди": "Pessoas",
  "Можно близких или персонажа": "Pessoas próximas ou um personagem",
  "Можно ваших близких": "Suas pessoas próximas",
  "Можно до {0} видео": "Até {0} vídeos",
  "Можно до {0} записей": "Até {0} gravações",
  "Можно до {0} записи": "Até {0} gravações",
  "Можно до {0} запись": "Até {0} gravação",
  "Можно до {0} файл": "Até {0} arquivo",
  "Можно до {0} файла": "Até {0} arquivos",
  "Можно до {0} файлов": "Até {0} arquivos",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Assim funciona, mas 3 fotos ou mais dão uma semelhança mais fiel",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Assim funciona, mas 3 fotos ou mais dão uma semelhança mais fiel",
  "Можно себя или близких": "Você ou pessoas próximas",
  "Можно себя, близких или персонажа": "Você, pessoas próximas ou um personagem",
  "На этом экране вы в кадре всегда": "Nesta tela você está sempre no quadro",
  "Навсегда, вместе с фото": "Para sempre, junto com as fotos",
  "Нажмите, чтобы выбрать": "Toque para escolher",
  "Найти": "Pesquisar",
  "Напишите пару слов, и мы предложим варианты": "Escreva algumas palavras e sugeriremos opções",
  "Например: Барсик": "Por exemplo: Max",
  "Например: Лёша": "Por exemplo: Alex",
  "Нашли": "Encontrados",
  "Не получилось подготовить файл": "Não foi possível preparar o arquivo",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Não foi possível melhorar. Tente acrescentar algumas palavras",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Não cabe<span class=\"nfx\">: até {0} caracteres</span>",
  "Необязательно: всё уже настроено": "Opcional: tudo já está configurado",
  "Ничего не нашлось": "Nada encontrado",
  "Нужно выбрать": "Escolha necessária",
  "Объём": "Volume",
  "Один раз для всех инструментов": "Uma vez para todas as ferramentas",
  "Отменить свой вариант": "Cancelar sua opção",
  "Отметьте, кто будет в кадре · {0}": "Marque quem estará no quadro · {0}",
  "Персонажи": "Personagens",
  "Подберём сами": "Nós escolhemos",
  "Подбираем варианты": "Buscando opções",
  "Пожилой": "Idoso",
  "Поиск стилей": "Pesquisa de estilos",
  "Пока нечего сохранять": "Ainda não há nada para salvar",
  "Попробуйте другое слово": "Tente outra palavra",
  "Порядок здесь один": "Aqui há apenas uma ordem",
  "Примеры": "Exemplos",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Será removido {0} junto com as fotos. Não será possível recuperar.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Será removido das pessoas próximas junto com as fotos. Não será possível recuperar.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Será removido das pessoas próximas e {0} junto com as fotos. Não será possível recuperar.",
  "Профиль близкого": "Perfil da pessoa próxima",
  "Разные ракурсы и выражения": "Ângulos e expressões diferentes",
  "Реалистичный": "Realista",
  "Реалистичный, иллюстрация или 3D": "Realista, ilustração ou 3D",
  "Роли": "Papéis",
  "Роль «{0}»": "Papel «{0}»",
  "Роль «{0}» для женского персонажа": "O papel «{0}» é para uma personagem feminina",
  "Роль «{0}» для мужского персонажа": "O papel «{0}» é para um personagem masculino",
  "Роль «{0}» для персонажей своей подборки": "O papel «{0}» é para personagens da própria coleção",
  "Свой вариант": "Sua opção",
  "Скачать здесь не получится": "Não é possível baixar aqui",
  "Создайте новый вариант": "Crie uma nova variante",
  "Сортировка": "Ordenar",
  "Сохранится в близких": "Será salvo em pessoas próximas",
  "Сохранить в близких": "Salvar em pessoas próximas",
  "Стало": "Depois",
  "Только для этой фотосессии": "Somente para esta sessão de fotos",
  "Удаление": "Exclusão",
  "Удалить «{0}» {1}?": "Remover «{0}» {1}?",
  "Удалить «{0}» из близких?": "Remover «{0}» das pessoas próximas?",
  "Удалить из близких": "Remover das pessoas próximas",
  "Удалить из фотосессии": "Remover da sessão de fotos",
  "Удерживайте, чтобы посмотреть примеры": "Mantenha pressionado para ver exemplos",
  "Управление": "Gerenciamento",
  "Файл готов. Нажмите ещё раз": "O arquivo está pronto. Toque novamente",
  "Фото до 10 МБ, видео до 200 МБ": "Fotos até 10 MB, vídeos até 200 MB",
  "Фрагмент": "Trecho",
  "Что делает? Например: поправляет шарф": "O que está fazendo? Por exemplo: ajeita o cachecol",
  "Что делают в кадре": "O que fazem no quadro",
  "Эта настройка здесь закреплена": "Esta configuração está fixa aqui",
  "Этот голос не умеет переозвучку записи": "Esta voz não consegue redublar uma gravação",
  "вариант «{0}»": "variante «{0}»",
  "взрослая": "adulta",
  "взрослый": "adulto",
  "всё видео умещается": "o vídeo inteiro cabe",
  "выберите": "escolha",
  "до <span class=\"mono\">{0}</span>": "até <span class=\"mono\">{0}</span>",
  "до {0} человек": "até {0} pessoas",
  "до {0} человека": "até {0} pessoas",
  "ещё {0} из {1}": "mais {0} de {1}",
  "женская роль": "papel feminino",
  "из фотосессии": "da sessão de fotos",
  "из этой фотосессии": "desta sessão de fotos",
  "камера": "câmera",
  "максимум {0} секунд": "máximo de {0} segundos",
  "максимум {0} секунда": "máximo de {0} segundo",
  "максимум {0} секунды": "máximo de {0} segundos",
  "можно до <span class=\"mono\">{0}</span>": "até <span class=\"mono\">{0}</span>",
  "мужская роль": "papel masculino",
  "не из подборки этой роли": "não é da coleção deste papel",
  "не подходит по возрасту": "a idade não combina",
  "не участвует в этой фотосессии": "não participa desta sessão de fotos",
  "необязательно": "opcional",
  "нет фото": "sem fotos",
  "нужно выбрать": "escolha necessária",
  "нужно: Вы": "necessário: você",
  "персонажи в эту роль не входят": "personagens não entram neste papel",
  "питомец": "animal de estimação",
  "по желанию": "opcional",
  "пожилая": "idosa",
  "пожилой": "idoso",
  "ребёнок": "criança",
  "роль для взрослого": "papel para um adulto",
  "роль для женщины": "papel para uma mulher",
  "роль для мужчины": "papel para um homem",
  "роль для питомца": "papel para um animal de estimação",
  "роль для ребёнка": "papel para uma criança",
  "роль для человека": "papel para uma pessoa",
  "Попробуйте другое слово или сбросьте тему": "Tente outra palavra ou limpe o tema",
  "Искать среди {n}+ голосов": "Buscar em {n}+ vozes",
  "Голосов: {n}": "Vozes: {n}",
  "Персонажей: {n}": "Personagens: {n}",
  "Голосов: {0}": "Vozes: {0}",
  "Прослушать {n}": "Ouvir {n}",
  "Загружаем ещё {n}": "Carregando mais {n}",
  "{a} из {b}": "{a} de {b}",
  "Подборка": "Coleção",
  "Закрыть подборку": "Fechar coleção",
  "По имени": "Por nome",
  "Загружаем подборки…": "Carregando coleções…",
  "Не удалось загрузить голоса": "Não foi possível carregar as vozes",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Não foi possível tocar a amostra. Tente de novo.",
  "Мой голос": "Minha",
  "Мои": "Minhas",
  "Своих голосов пока нет": "Você ainda não tem vozes próprias",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Clone sua voz e ela aparecerá aqui.",
  "Клонировать голос": "Clonar voz",
  "Открыть персонажа {0}": "Abrir {0}",
  "От": "Desde",
  "Тренды недели": "Em alta na semana",
  "Голоса, которые быстрее всего набирают заказы": "Vozes que mais ganham pedidos",
  "Мужские": "Masculinas",
  "Все мужские голоса библиотеки": "Todas as vozes masculinas",
  "Женские": "Femininas",
  "Все женские голоса библиотеки": "Todas as vozes femininas",
  "Детские": "Infantis",
  "Детские и мультяшные голоса": "Vozes infantis e de desenho",
  "меню: Озвучка": "Vozes",
  "Системная": "Sistema",
  "Для аватарки и ленты": "Para avatar e feed",
  "Как снимок с телефона": "Como uma foto de celular",
  "Для ленты": "Para o feed",
  "На весь экран телефона": "Tela cheia do celular",
  "Для обложки и экрана": "Para capa e tela",
  "Станет голосом по умолчанию для озвучки.": "Será a voz padrão das locuções.",
  "Когда генерация закончится": "Quando a geração terminar",
  "Награды и серия": "Prêmios e sequência",
  "Напомним о награде за день": "Lembrete do prêmio diário",
  "Новые шаблоны и стили": "Novos modelos e estilos",
  "Не чаще раза в неделю": "No máximo uma vez por semana",
  "Новости STEOS": "Novidades da STEOS",
  "Только крупные обновления": "Só grandes atualizações",
  "Тут откроется документ в браузере": "O documento abrirá no navegador",
  "Язык и валюта": "Idioma e moeda",
  "Интерфейс и цены картой": "Interface e preços no cartão",
  "новое|новых|новых": "novo|novos",
  "работа|работы|работ": "trabalho|trabalhos",
  "заказ|заказа|заказов": "pedido|pedidos",
  "Счётчики недоступны": "Contadores indisponíveis",
  "История пуста": "O histórico está vazio",
  "Не задан": "Não definido",
  "Недоступны": "Indisponíveis",
  "Срок истёк": "Expirado",
  "Не удалась": "Falhou",
  "Готовится": "Preparando",
  "Запрошено": "Solicitado",
  "Запрошено {0}": "Solicitado {0}",
  "Недоступно": "Indisponível",
  "Пусто": "Vazio",
  "Данные Mini App удалены": "Dados do Mini App excluídos",
  "Удаление данных не удалось": "Falha ao excluir os dados",
  "Данные удалены частично": "Dados excluídos parcialmente",
  "Удаление требует проверки": "A exclusão precisa de revisão",
  "Запрос удаления принят": "Pedido de exclusão recebido",
  "Удаляем данные Mini App": "Excluindo dados do Mini App",
  "Удаление данных в очереди": "Exclusão na fila",
  "STEOS ID сохранён": "STEOS ID mantido",
  "Финансовые квитанции сохранены": "Recibos financeiros mantidos",
  "Статус удаления не подтверждён": "Status da exclusão não confirmado",
  "Удаление аккаунта": "Excluir conta",
  "Удалить данные Mini App?": "Excluir os dados do Mini App?",
  "Удалить аккаунт?": "Excluir a conta?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Seus trabalhos, vozes e visuais no Mini App serão excluídos. Seu STEOS ID e os recibos serão mantidos.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Seus trabalhos, vozes, visuais e Circle serão excluídos. Não dá para desfazer.",
  "Удалить данные Mini App": "Excluir dados do Mini App",
  "Удалить аккаунт": "Excluir conta",
  "Данные Mini App. STEOS ID сохранится": "Só dados do Mini App. STEOS ID fica",
  "Все данные удалятся навсегда": "Todos os dados serão excluídos para sempre",
  "В прототипе аккаунт не удаляется": "No protótipo a conta não é excluída",
  "Автовоспроизведение": "Reprodução automática",
  "Пример при выборе голоса": "Amostra ao escolher uma voz",
  "Присылать в чат": "Enviar no chat",
  "Готовые работы от бота": "Trabalhos prontos do bot",
  "Уведомления и отклик": "Notificações e vibração",
  "Данные": "Dados",
  "Выгрузить данные": "Exportar dados",
  "Настройки создания сейчас только для чтения": "As configurações de criação estão só para leitura agora",
  "Формат по умолчанию": "Formato padrão",
  "Для новых фото и видео": "Para novas fotos e vídeos",
  "На экране создания их можно поменять для одной работы.": "Dá para mudar em um único trabalho na tela de criação.",
  "Сообщения приходят в чат с ботом": "As mensagens chegam no chat com o bot",
  "Бот напишет только в ответ на действия": "O bot só vai responder às suas ações",
  "Уведомления пока недоступны": "As notificações ainda não estão disponíveis",
  "Вибрация": "Vibração",
  "Лёгкий отклик на нажатия": "Leve resposta ao tocar",
  "Выгрузка данных": "Exportação de dados",
  "Выгрузка запрошена": "Exportação solicitada",
  "Пришлём архив в чат в течение суток": "Enviaremos o arquivo no chat em até 24 horas",
  "Настройки и доступные текстовые данные аккаунта": "Configurações e dados de texto disponíveis da conta",
  "Ссылка на архив придёт в чат с ботом": "O link do arquivo chegará no chat com o bot",
  "Готовые работы и заказы": "Trabalhos prontos e pedidos",
  "Клоны и записи образцов": "Clones e gravações de amostra",
  "Ваши фото и варианты себя": "Suas fotos e visuais",
  "Люди и питомцы из фотосессий": "Pessoas e pets dos ensaios",
  "Запросить выгрузку": "Solicitar exportação",
  "Готовим архив": "Preparando o arquivo",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Leva alguns minutos. Pode fechar, a exportação continua",
  "Срок хранения архива истёк": "O arquivo expirou",
  "Запросите новую выгрузку данных": "Solicite uma nova exportação",
  "Архив не собрался": "Não foi possível montar o arquivo",
  "Запросите выгрузку ещё раз": "Solicite a exportação de novo",
  "Не вошли: {0}": "Não incluído: {0}",
  "Вошли частично: {0}": "Incluído em parte: {0}",
  "Не входят в выгрузку: {0}": "Fora da exportação: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Alguns dados estão indisponíveis. O conteúdo exato está em manifest.json no arquivo",
  "Архив готов, но не полностью": "Arquivo pronto, mas incompleto",
  "Архив готов": "Arquivo pronto",
  "Скачать можно до {0}": "Disponível para baixar até {0}",
  "Архив в формате ZIP": "Arquivo ZIP",
  "Скачать архив": "Baixar arquivo",
  "Счётчики истории не загрузились": "Os contadores não carregaram",
  "Загружаем историю": "Carregando histórico",
  "Проверьте связь и повторите загрузку": "Verifique a conexão e tente de novo",
  "История очищена": "Histórico limpo",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Suas vozes, visuais, pessoas queridas e Circle continuam aqui",
  "Здесь появятся работы, когда вы что-то создадите": "Seus trabalhos vão aparecer aqui quando você criar algo",
  "Раздел «История»": "Seção Histórico",
  "Работы": "Trabalhos",
  "Фото, видео, кружки и озвучки": "Fotos, vídeos, círculos e locuções",
  "Заказы": "Pedidos",
  "Параметры и статусы генераций": "Parâmetros e status das gerações",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Suas vozes, visuais, pessoas queridas e Circle ficam.",
  "Удалить работы и заказы": "Excluir trabalhos e pedidos",
  "Без возможности восстановления": "Não dá para desfazer",
  "Подтверждение удаления": "Confirmar exclusão",
  "Попробовать: {0}": "Experimentar: {0}",
  "Обновление": "Atualização",
  "Загружаем «Что нового»": "Carregando Novidades",
  "Новых обновлений пока нет": "Ainda não há novidades",
  "Уведомления сейчас не сохранить": "Não dá para salvar as notificações agora",
  "Настройки сейчас только для чтения": "As configurações estão só para leitura agora",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Não foi possível solicitar a exportação. Tente de novo",
  "Удалить всю историю?": "Excluir todo o histórico?",
  "{0}. Вернуть не получится.": "{0}. Não dá para desfazer.",
  "История не очистилась. Попробуйте ещё раз": "O histórico não foi limpo. Tente de novo",
  "Удаление не началось. Попробуйте ещё раз": "A exclusão não começou. Tente de novo",
  "Не удалось загрузить настройки": "Não foi possível carregar as configurações",
  "«Что нового» не загрузилось": "As Novidades não carregaram",
  "Сохранение настроек сейчас недоступно": "Não dá para salvar as configurações agora",
  "Настройки уже изменились, показываем актуальные": "As configurações mudaram, mostrando as atuais",
  "Не удалось сохранить. Попробуйте ещё раз": "Não foi possível salvar. Tente de novo",
  "Настройки, ресурсы и история": "Configurações, recursos e histórico",
  "Данные Mini App": "Dados do Mini App",
  "Учётная запись и финансовые данные STEOS ID": "Conta e dados financeiros do STEOS ID",
  "Переписка с ботом": "Conversa com o bot",
  "Фото, аудио, видео и модели": "Fotos, áudio, vídeos e modelos",
  "Данные других продуктов STEOS": "Dados de outros produtos STEOS",
  "Рубли": "Rublos",
  "Драмы": "Drams",
  "Евро": "Euros",
  "Доллары": "Dólares",
  "Другие языки": "Mais idiomas",
  "Интерфейс и сообщения бота": "Interface e mensagens do bot",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Os preços no cartão aparecem nesta moeda. As Telegram Stars são iguais em todo lugar.",
  "сегодня, {0}": "hoje, {0}",
  "вчера, {0}": "ontem, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Cartão ou SBP",
  "СБП только для РФ": "SBP só na Rússia",
  "1 месяц": "1 mês",
  "3 месяца": "3 meses",
  "6 месяцев": "6 meses",
  "Год": "Ano",
  "год": "um ano",
  "С днём рождения": "Feliz aniversário",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Feliz aniversário. Que tudo dê certo de primeira",
  "Просто так": "Só porque sim",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Só porque sim. Que você tenha mais círculos e vozes engraçadas",
  "Спасибо": "Obrigado",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Obrigado por estar por perto. Um presentinho meu",
  "С праздником": "Boas festas",
  "С праздником. Твори, снимай и удивляй": "Boas festas. Crie, grave e surpreenda",
  "Для блога": "Para seu blog",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Para seu blog: mais vídeos, com menos esforço",
  "Удачи": "Boa sorte",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Boa sorte no novo projeto. Que a voz e a imagem saiam como você planejou",
  "картой": "no cartão",
  "оплата картой каждый месяц": "pago no cartão todo mês",
  "оплата картой за {0}": "pago no cartão por {0}",
  "{0} в месяц": "{0} por mês",
  "{0} за {1}": "{0} por {1}",
  "кружок|кружка|кружков": "mensagem de vídeo|mensagens de vídeo",
  "рилс|рилса|рилсов": "reel|reels",
  "свой голос|своих голоса|своих голосов": "voz própria|vozes próprias",
  "своего голоса|своих голосов|своих голосов": "voz própria|vozes próprias",
  "день|дня|дней": "dia|dias",
  "звезда|звезды|звёзд": "estrela|estrelas",
  "Подписаться на {0}": "Assinar por {0}",
  "Продлевается каждый месяц, отмена в любой момент": "Renova todo mês, cancele quando quiser",
  "Без автопродления, Circle приходят каждый месяц": "Sem renovação automática, os Circle chegam todo mês",
  "Перейти на {0}": "Mudar para {0}",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C chegam agora e o {1} não será mais renovado",
  "Сразу придут {0} C": "{0} C chegam agora",
  "Перейти на {0} с {1}": "Mudar para {0} em {1}",
  "До {0} остаётся {1}, потом {2}": "{1} continua até {0}, depois {2}",
  "Продлить на {0}": "Estender por {0}",
  "Ещё {0} после {1}, без автопродления": "Mais {0} depois de {1}, sem renovação",
  "Следующее списание {0}, {1}": "Próxima cobrança em {0}, {1}",
  "Способ оплаты": "Forma de pagamento",
  "Звёздами": "Com estrelas",
  "Тестовая оплата": "Pagamento de teste",
  "Звёзды и деньги не списываются": "Nenhuma estrela ou dinheiro é cobrado",
  "Оплата картой скоро": "Pagamento com cartão em breve",
  "Ваш тариф": "Seu plano",
  "выгоднее на {0}%": "{0}% mais vantajoso",
  "{0} C в месяц": "{0} C por mês",
  "или": "ou",
  "Что сотворим в этом месяце?": "O que vamos criar este mês?",
  "Готовы творить без пауз?": "Pronto para criar sem pausa?",
  "Ваш тариф {0}": "Seu plano: {0}",
  "{0} C каждый месяц": "{0} C todo mês",
  "До {0} {1}": "Até {0} {1}",
  "Пакеты Circle, если не хватит": "Pacotes de Circle se faltar",
  "{0} включает": "{0} inclui",
  "Сравнить": "Comparar",
  "Помесячно": "Mensal",
  "Выгода {0}": "Economize {0}",
  "Одним платежом": "Pagamento único",
  "{0} с {1}": "{0} a partir de {1}",
  "Оставить {0}": "Manter {0}",
  "Продлить {0}": "Renovar {0}",
  "Продлить": "Renovar",
  "Включить продление": "Ativar renovação",
  "Возобновить {0}": "Retomar {0}",
  "Возобновить": "Retomar",
  "Оплата пока не подключена": "O pagamento ainda não está conectado",
  "Сейчас недоступно": "Indisponível agora",
  "Переход на {0} на {1}": "Mudança para {0} por {1}",
  "Переход на {0}": "Mudança para {0}",
  "Продление {0} на {1}": "Estender {0} por {1}",
  "Подписка {0} на {1}": "{0} por {1}",
  "Как удобнее оплатить": "Escolha como pagar",
  "Подарок друга": "Presente de amigo",
  "{0} на первый пакет {1} после подписки": "{0} no primeiro pacote por {1} após assinar",
  "Не загрузилось": "Não carregou",
  "Прошлую операцию не проверить": "Não dá para verificar a última operação",
  "разрешите хранение данных и откройте раздел снова": "permita o armazenamento de dados e abra a seção de novo",
  "Оплата требует проверки": "O pagamento precisa de revisão",
  "Исход подтверждения оплаты ещё неизвестен": "O resultado da confirmação ainda é desconhecido",
  "Исход отмены счёта неизвестен": "O resultado do cancelamento é desconhecido",
  "Ждём подтверждения оплаты": "Aguardando confirmação do pagamento",
  "Исход прошлой операции неизвестен": "Resultado da última operação desconhecido",
  "проверьте его перед новой покупкой": "verifique antes de uma nova compra",
  "Проверить": "Verificar",
  "Открыть оплату": "Abrir pagamento",
  "Отменить счёт": "Cancelar fatura",
  "Продление отменено": "Renovação cancelada",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Pode chegar uma mensagem com a fatura antiga. Ela não confirma uma nova assinatura",
  "Продление требует проверки": "A renovação precisa de revisão",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Fatura não confirmada. Atualize ou fale com o suporte",
  "Не удалось подготовить счёт": "Não foi possível preparar a fatura",
  "Сервер повторит проверку. Текущие права не меняются": "O servidor vai verificar de novo. Seu acesso atual não muda",
  "Счёт отправлен": "Fatura enviada",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "O bot enviou a fatura. A assinatura começa após o pagamento confirmado",
  "Счёт подготовлен": "Fatura preparada",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Entregue ao bot. Entrega e pagamento ainda não confirmados",
  "Срок счёта истёк": "Fatura expirada",
  "Продление не оплачено. Выберите тариф ещё раз": "A renovação não foi paga. Escolha um plano de novo",
  "Запланированное продление отменено": "Renovação agendada cancelada",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Seu plano atual continua. Uma nova assinatura exige outro pagamento",
  "Продление запланировано": "Renovação agendada",
  "Счёт на свою подписку придёт в конце подарочного месяца": "A fatura da sua assinatura chegará no fim do mês de presente",
  "Подарок ещё действует": "O presente ainda está ativo",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "A assinatura mensal estará disponível quando ele acabar. Agora dá para estender por 3 ou 12 meses",
  "выберите другой тариф или срок": "escolha outro plano ou período",
  "−{0}% на первый пакет · ещё {1}": "−{0}% no primeiro pacote · mais {1}",
  "Circle из пакетов не сгорают": "Circle de pacotes não expiram",
  "Подарить другу": "Dar de presente",
  "С открыткой, без продления": "Com cartão, sem renovação",
  "Промокод {0}": "Cupom {0}",
  "{0} C, сгорят {1}": "{0} C, expiram em {1}",
  "Промокод применён": "Cupom aplicado",
  "{0} C и {1} на первый пакет": "{0} C e {1} no primeiro pacote",
  "после подписки": "após assinar",
  "Вы пришли по ссылке партнёра": "Você veio por um link de parceiro",
  "привязка уже действует": "o vínculo já está ativo",
  "Есть промокод?": "Tem um cupom?",
  "Загружаем тарифы": "Carregando planos",
  "Счёт придёт {0}": "A fatura chega em {0}",
  "Счёт придёт в конце текущего срока": "A fatura chega no fim do período atual",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "O novo plano começa após o pagamento. Nada é cobrado agora.",
  "Оплата подтверждена": "Pagamento confirmado",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "O período pago já terminou. Circle de períodos passados não são creditados.",
  "Баланс пополнен": "Saldo recarregado",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Agora seu saldo é {0} C. Circle de pacotes não expiram",
  "следующие {0} C придут {1}": "os próximos {0} C chegam em {1}",
  "До этой даты действует {0}": "{0} continua ativo até essa data",
  "{0} продлён до {1}": "{0} estendido até {1}",
  "Circle приходят каждый месяц, {0}": "Os Circle chegam todo mês, {0}",
  "Тариф {0} подключён": "Plano {0} ativado",
  "Подписка {0} оформлена": "Assinatura {0} ativada",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Pago até {0}. Os Circle chegam todo mês, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Assinatura de teste até {0}. Nada é cobrado",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Os Circle valem até {0}, quando vem a próxima cobrança: {1}",
  "Circle действуют до {0}, продление выключено": "Os Circle valem até {0}, renovação desativada",
  "В месяц": "Por mês",
  "Кружки или фото": "Círculos ou fotos",
  "Видео говорит": "Vídeo fala",
  "Рилсы": "Reels",
  "Сравнение тарифов": "Comparação de planos",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Todo plano: {0} {1} em vez de {2}, todas as ferramentas e pacotes Circle",
  "Следующее списание": "Próxima cobrança",
  "Сумма": "Valor",
  "Тестовая, без списаний": "Teste, sem cobrança",
  "Картой": "No cartão",
  "Оплачено до": "Pago até",
  "Действует до": "Ativo até",
  "Потом": "Depois",
  "Продление": "Renovação",
  "Счёт на {0} запланирован": "Fatura do {0} agendada",
  "подписку": "assinatura",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Chega em {0}. O novo plano começa após o pagamento",
  "Отменить": "Cancelar",
  "Отменить подписку": "Cancelar assinatura",
  "Тариф останется до {0}": "O plano continua até {0}",
  "Потом тариф {0}": "Depois {0}",
  "Подарок на месяц": "Presente de um mês",
  "Оплачено вперёд": "Pago adiantado",
  "Подписка {0}": "Assinatura {0}",
  "Условия тарифа уточняются": "Detalhes do plano em confirmação",
  "Сменить тариф": "Mudar de plano",
  "Отмена подписки": "Cancelamento da assinatura",
  "Этот переход сейчас недоступен": "Esta mudança não está disponível agora",
  "Переход уже назначен": "A mudança já está agendada",
  "Выберите другой тариф": "Escolha outro plano",
  "С {0} начнётся этот тариф": "Este plano começa em {0}",
  "Это ваш тариф": "Este é seu plano",
  "К подписке": "Voltar à assinatura",
  "Сейчас {0}, {1}": "Agora {0}, {1}",
  "Латиница, цифры и «_»": "Letras latinas, números e _",
  "Ник начинается с буквы": "Deve começar com uma letra",
  "Не короче 5 знаков": "Pelo menos 5 caracteres",
  "Не длиннее 32 знаков": "No máximo 32 caracteres",
  "Ник не кончается на _": "Não pode terminar com _",
  "Это ваш ник": "Esse é o seu usuário",
  "Сначала проверьте прежнюю операцию": "Verifique primeiro a operação anterior",
  "Подарок сейчас недоступен": "O presente não está disponível agora",
  "Укажите ник друга в Telegram": "Informe o usuário do Telegram do seu amigo",
  "Проверьте ник": "Verifique o usuário",
  "Друг увидит: {0}": "Seu amigo verá: {0}",
  "Подарок придёт без имени": "O presente chega sem nome",
  "{0} дарит вам": "{0} está te dando",
  "вам подарили": "você ganhou",
  "Вам подарили": "Você ganhou",
  "{0} подписку STEOS {1} на месяц.": "{0} uma assinatura STEOS {1} por um mês.",
  "Забрать подарок": "Resgatar presente",
  "От друга": "De um amigo",
  "{0} C и {1} {2}": "{0} C e {1} {2}",
  "Подарить {0}": "Dar {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "Presente de teste: nada é cobrado",
  "На месяц, без продления": "Por um mês, sem renovação",
  "Тариф подарка": "Plano do presente",
  "Кому": "Para",
  "ник друга в Telegram": "usuário do Telegram",
  "Ник друга в Telegram": "Usuário do Telegram do amigo",
  "Пожелание": "Mensagem",
  "Пара тёплых слов, по желанию": "Algumas palavras carinhosas, opcional",
  "Подписать от меня": "Assinar como eu",
  "Так увидит друг": "Assim seu amigo verá",
  "Подарок оформлен для {0}": "Presente criado para {0}",
  "Подарок отправлен {0}": "Presente enviado para {0}",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "O bot enviou um cartão com o link “Resgatar presente”.",
  "Месяц {0} начнётся, когда друг заберёт подарок": "O mês de {0} começa quando seu amigo resgatar",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Seu amigo ainda não abriu o STEOS? Encaminhe o cartão você mesmo",
  "Переслать": "Encaminhar",
  "Загружаем подарок": "Carregando presente",
  "Вам подарок": "Um presente para você",
  "Подписка STEOS на месяц": "Assinatura STEOS de um mês",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Este presente é para {0}. Encaminhe o cartão com o link.",
  "Подарок уже получен": "Presente já resgatado",
  "Подарок добавлен": "Presente adicionado",
  "Подписка {0} подключена": "Assinatura {0} ativada",
  "Circle подарка сгорят {0}": "Os Circle do presente expiram em {0}",
  "Месяц без продления, Circle действуют до {0}": "Um mês sem renovação, Circle valem até {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Você já tem {0}: o presente adiciona {1} C que expiram em um mês",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "Você recebe {0} C e {1} {2}. Não renova sozinha",
  "За последние 7 дней": "Últimos 7 dias",
  "Потрачено": "Gasto",
  "Начислено": "Creditado",
  "Пакеты пока недоступны": "Pacotes ainda indisponíveis",
  "Пакет": "Pacote",
  "Оплата пакетов пока не подключена": "O pagamento de pacotes ainda não está conectado",
  "Введите промокод": "Digite um cupom",
  "Применить": "Aplicar",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Cupons de parceiro valem até a primeira compra; um cupom STEOS, uma vez",
  "От партнёра или от STEOS": "De um parceiro ou da STEOS",
  "Например, ANNA24": "Por exemplo, ANNA24",
  "Не удалось загрузить операции": "Não foi possível carregar as operações",
  "Начисление": "Crédito",
  "Списание": "Débito",
  "Загружаем операции": "Carregando operações",
  "Журнал STEOS ID": "Registro do STEOS ID",
  "Операций пока нет": "Ainda não há operações",
  "Применение не подтверждено. Проверьте прежний запрос": "Não confirmado. Verifique a solicitação anterior",
  "Отменить подписку?": "Cancelar a assinatura?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} continua até {1} e depois não renova.",
  "Оставить": "Manter",
  "Не удалось подготовить открытку": "Não foi possível preparar o cartão",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Abra o Mini App no Telegram para encaminhar o cartão",
  "Отправка отменена": "Envio cancelado",
  "Ссылка на подарок скопирована": "Link do presente copiado",
  "Не получилось. Попробуйте ещё раз": "Não deu certo. Tente de novo",
  "Счёт отменён": "Fatura cancelada",
  "Оплата не завершена": "Pagamento não concluído",
  "Подтверждение оплаты": "Confirmação do pagamento",
  "Проверяем подтверждение оплаты": "Verificando a confirmação",
  "Проверяем отмену счёта": "Verificando o cancelamento",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "O Telegram começou a confirmar a fatura. O resultado ainda é desconhecido. Não pague de novo: verifique esta fatura ou fale com o suporte.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "O presente será criado após a confirmação do servidor. O mês começa quando seu amigo resgatar. Voltar da janela de pagamento não significa que o pagamento foi concluído.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Os Circle chegam após a confirmação do servidor. Voltar da janela de pagamento não significa que o pagamento foi concluído.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Os Circle e a assinatura aparecem após a confirmação do servidor. Voltar da janela de pagamento não significa que o pagamento foi concluído.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Não foi possível abrir o pagamento. Verifique a solicitação anterior",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Abra o Mini App no Telegram para pagar com estrelas",
  "Оплата ещё не подтверждена сервером": "O servidor ainda não confirmou o pagamento",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "O cartão está pronto. Abra o Mini App no Telegram para encaminhá-lo",
  "Отменить счёт?": "Cancelar a fatura?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Só esta fatura não paga é cancelada. Sua assinatura atual continua. Se o pagamento já estiver em confirmação, o servidor não permitirá cancelar.",
  "Вернуться к оплате": "Voltar ao pagamento",
  "{0} на первый пакет после подписки": "{0} no primeiro pacote após assinar",
  "{0} на первый пакет, ещё {1}": "{0} no primeiro pacote, mais {1}",
  "{0} на первый пакет": "{0} no primeiro pacote",
  "Промокод {0} применён": "Cupom {0} aplicado",
  "Circle сгорят {0}": "Os Circle expiram em {0}",
  "Circle начислены": "Circle creditados",
  "Привязка к партнёру подтверждена": "Vínculo com parceiro confirmado",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Desconto: {0}. Circle bônus expiram em {1}",
  "Привязка к партнёру действует": "Vínculo com parceiro ativo",
  "{0} C и {1}": "{0} C e {1}",
  "Открытка передана боту для доставки.": "O cartão foi entregue ao bot para envio.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "O bot está preparando o envio. Você também pode encaminhá-lo.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "O envio não foi confirmado. Você pode encaminhá-lo.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Primeiro são gastos os Circle com validade (bônus e assinatura), depois o resto; os sacáveis por último.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Destinatário não encontrado no STEOS. Verifique o usuário ou peça ao amigo para iniciar o bot.",
  "Условия оплаты изменились. Обновите данные.": "As condições de pagamento mudaram. Atualize os dados.",
  "Эту открытку может переслать только отправитель подарка.": "Só quem enviou o presente pode encaminhar este cartão.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Abra o chat com o bot e tente de novo.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Entrega ao destinatário não confirmada. Encaminhe o cartão você mesmo.",
  "Предложение не найдено. Обновите данные.": "Oferta não encontrada. Atualize os dados.",
  "Такого промокода нет": "Esse cupom não existe",
  "Срок действия промокода закончился": "Este cupom expirou",
  "Этот промокод пока не действует": "Este cupom ainda não está ativo",
  "Вы уже активировали этот промокод": "Você já usou este cupom",
  "Промокод больше не действует": "Este cupom não é mais válido",
  "Это ваш промокод": "Esse é o seu próprio cupom",
  "Партнёрские промокоды работают только до первой покупки": "Cupons de parceiro só valem antes da primeira compra",
  "Промокод партнёра временно недоступен": "Este cupom de parceiro está temporariamente indisponível",
  "Вы уже привязаны к партнёру": "Você já está vinculado a um parceiro",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "O destinatário mudou. Cancele a fatura anterior não paga e verifique o usuário antes de comprar de novo.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "A mensagem deve ter até 200 caracteres, sem caracteres de controle.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Verifique o usuário: o destinatário precisa ter aberto o STEOS, e você não pode presentear a si mesmo",
  "Получатель сейчас занят. Повторите позже": "O destinatário está ocupado agora. Tente mais tarde",
  "Подарок не найден": "Presente não encontrado",
  "Этот подарок предназначен другому пользователю": "Este presente é para outro usuário",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Não foi possível confirmar as condições de renovação. Atualize os planos.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Sua assinatura mudou. Atualize antes de renovar de novo.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "A renovação já está agendada. Você pode cancelá-la no gerenciamento da assinatura.",
  "Запланированное продление отменено. Обновите данные.": "Renovação agendada cancelada. Atualize os dados.",
  "Счёт будет доступен в конце текущего срока.": "A fatura estará disponível no fim do período atual.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "A assinatura mensal estará disponível após o presente. Agora dá para estender por 3 ou 12 meses.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "A alteração anterior ainda está em verificação. Verifique de novo.",
  "Изменение подписки ещё не подтверждено Telegram.": "O Telegram ainda não confirmou a alteração da assinatura.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Sua assinatura mudou. Atualize e verifique de novo.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "O desconto já está vinculado à fatura anterior. Verifique o pagamento dela.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "A fatura já está em confirmação ou não pode ser cancelada. Verifique o resultado do pagamento.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "O pagamento precisa de revisão. O servidor salvou o pagamento, mas o acesso ainda não foi confirmado. Não pague de novo: verifique depois ou fale com o suporte.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Fatura cancelada. Nenhuma assinatura ou Circle foi creditado. Você pode iniciar um novo pagamento.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Pagamento não concluído. Dinheiro e Circle não confirmados; você pode iniciar um novo pagamento.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "O cartão está sendo preparado. Toque em “Verificar” para ver o resultado.",
  "Подарить подписку": "Presentear assinatura",
  "Оплата подписки": "Pagamento da assinatura",
  "Итог оплаты": "Resultado do pagamento",
  "Подарок": "Presente",
  "Пакет Circle": "Pacote de Circle",
  "лента: Хит": "Top",
  "настройки: Очистить историю": "Limpar histórico",
  "Разделы, которых нет в меню": "Seções fora do menu",
  "Базовый": "Básico",
  "Продвинутый": "Avançado",
  "Амбассадор": "Embaixador",
  "задание ждёт|задания ждут|заданий ждут": "tarefa pendente|tarefas pendentes",
  ", до +{0} C": ", até +{0} C",
  "Серия {0}, задания на сегодня": "Sequência de {0}, tarefas de hoje",
  "Задания на каждый день": "Tarefas diárias",
  "Всё созданное в одном месте": "Tudo o que você criou em um só lugar",
  "Пока пусто: всё созданное будет здесь": "Vazio por enquanto: suas criações aparecerão aqui",
  "{0}, последняя {1}": "{0}, a última {1}",
  "тариф {0}": "plano {0}",
  "без подписки": "sem assinatura",
  "{0}, {1}% с покупок": "{0}, {1}% das compras",
  "{0} уровень, {1}% с покупок": "Nível {0}, {1}% das compras",
  "До {0}% с покупок друзей": "Até {0}% das compras dos amigos",
  "ИИ-агент ответит сразу": "O agente de IA responde na hora",
  "Черновики ролей и реплик": "Rascunhos de papéis e falas",
  "Тема, язык и валюта": "Tema, idioma e moeda",
  "{0} ждут": "{0} pendentes",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Aqui o Telegram abre a escolha de chat: o bot entra no grupo e funciona lá",
  "голос {0}": "voz {0}",
  "Искать в {0} {1}": "Pesquisar em {0} {1}",
  "работе|работах|работах": "trabalho|trabalhos",
  "Не прошло модерацию": "Não passou na moderação",
  "Бесплатно": "Grátis",
  "Цена недоступна": "Preço indisponível",
  "Не удалось загрузить историю": "Não foi possível carregar o histórico",
  "Проверьте написание или поищите по номеру заказа": "Verifique a ortografia ou pesquise pelo número do pedido",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Verifique a ortografia ou pesquise por título, voz ou personagem",
  "Сбросить поиск": "Limpar pesquisa",
  "В этой вкладке пока пусто": "Nada aqui ainda",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Marque trabalhos com o coração para encontrá-los aqui rapidamente",
  "Новые работы этого вида появятся здесь сами": "Novos trabalhos deste tipo aparecerão aqui",
  "Показать все": "Ver tudo",
  "Поиск по истории": "Pesquisar no histórico",
  "Что показать": "O que mostrar",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Vídeos circulares, fotos, vídeos, locuções e textos que você criar",
  "Открыть студию": "Abrir Estúdio",
  "{0}: шаг {1} из {2}. Открыть": "{0}: etapa {1} de {2}. Abrir",
  "Шаг {0} из {1}": "Passo {0} de {1}",
  "{0}: {1}. Открыть": "{0}: {1}. Abrir",
  "Раскладка": "Layout",
  "Широкий": "Largo",
  "Инструмент": "Ferramenta",
  "голос|голоса|голосов": "voz|vozes",
  "Как в оригинале": "Como no original",
  "фото|фото|фото": "foto|fotos",
  "слайд|слайда|слайдов": "slide|slides",
  "снимок|снимка|снимков": "foto|fotos",
  "кадр|кадра|кадров": "foto|fotos",
  "Длительность записи": "Duração da gravação",
  "Цена": "Preço",
  "Списание не подтверждено": "Débito não confirmado",
  "Кадры": "Fotos",
  "знак|знака|знаков": "caractere|caracteres",
  "пункт|пункта|пунктов": "item|itens",
  "фраза|фразы|фраз": "frase|frases",
  "человек|человека|человек": "pessoa|pessoas",
  "Смотреть видео": "Ver vídeo",
  "символ|символа|символов": "caractere|caracteres",
  "Дорожка": "Faixa",
  "фрагмент 1:00": "trecho de 1:00",
  "вся песня": "música inteira",
  "образец|образца|образцов": "amostra|amostras",
  "Свой голос": "Voz própria",
  "{0} C списаны": "{0} C cobrados",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Ainda em criação. O resultado aparecerá aqui e no chat",
  "Проверяем результат. Обычно это занимает пару минут": "Verificando o resultado. Costuma levar alguns minutos",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Não passou na moderação. Não aceitamos política nem temas proibidos. {0}",
  "Не прошло модерацию. {0}": "Não passou na moderação. {0}",
  "Не получилось. {0}": "Não deu certo. {0}",
  "Не получилось. {0} C вернулись на баланс": "Não deu certo. {0} C devolvidos ao seu saldo",
  "Удалится только запись о заказе": "Apenas o registro do pedido será excluído",
  "Удаление из истории": "Excluir do histórico",
  "Смотреть: {0}": "Ver: {0}",
  "В этой работе нет файлов для просмотра": "Este trabalho não tem arquivos para visualizar",
  "Вернуть запись в историю не получится.": "Não será possível restaurar o registro.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "O arquivo continua no chat. Não será possível restaurar o trabalho.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "O envio ainda não foi confirmado. Toque de novo",
  "Принято": "Aceito",
  "Бот пришлёт результат в чат": "O bot enviará o resultado no chat",
  "Возврат обрабатывается": "Reembolso em andamento",
  "Не списано": "Não debitado",
  "Circle не списаны": "Nenhum Circle debitado",
  "Circle вернулись на баланс": "Os Circle voltaram para o seu saldo",
  "Списание пока не подтверждено": "Débito ainda não confirmado",
  "Возврат не подтверждён": "Reembolso não confirmado",
  "Ожидаем подтверждения оплаты": "Aguardando pagamento",
  "история: Повторить": "Repetir",
  "история: Кружки": "Mensagens de vídeo",
  "Фотосессия из селфи": "Sessão de fotos com selfie",
  "Рилс с вами": "Reels com você",
  "Фото говорит": "Foto fala",
  "Слайды с преимуществами": "Slides de benefícios",
  "Карусель для поста": "Carrossel para post",
  "Коллаж из фото": "Colagem de fotos",
  "Карточка для маркетплейса": "Card para marketplace",
  "шаг|шага|шагов": "passo|passos",
  "вопрос|вопроса|вопросов": "pergunta|perguntas",
  "Открыть": "Abrir",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "A resposta a esta pergunta não foi confirmada. Se for importante, escreva para o suporte: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "A resposta a esta pergunta não foi confirmada. Se for importante, escreva para o suporte.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Ainda sem resposta. Vamos verificar a mesma pergunta; ela não será enviada duas vezes.",
  "Открыть профиль": "Abrir perfil",
  "Войти через STEOS ID": "Entrar com STEOS ID",
  "Тут Telegram откроет выбор чата": "Aqui o Telegram abrirá a escolha do chat",
  "Разделы поддержки": "Seções do suporte",
  "Ответит сразу": "Responde na hora",
  "Отвечает сразу": "Responde na hora",
  "Поддержка в Telegram, {0}": "Suporte no Telegram, {0}",
  "Поддержка в Telegram": "Suporte no Telegram",
  "Видео медленнее обычного": "Vídeo: mais devagar que o normal",
  "Видео работает медленнее обычного": "O vídeo funciona mais devagar que o normal",
  "Спросить ИИ‑агента поддержки": "Perguntar ao agente de suporte de IA",
  "Отвечает сразу и знает всё о STEOS": "Responde na hora e sabe tudo sobre o STEOS",
  "Поиск по вопросам и инструкциям": "Pesquisar perguntas e instruções",
  "Шесть коротких сторис о главном": "Seis stories curtos sobre o essencial",
  "Попробуйте другие слова или спросите ИИ-агента": "Tente outras palavras ou pergunte ao agente de IA",
  "Проверено в {0}": "Verificado às {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Os pedidos não se perdem: o resultado chegará ao chat e, se algo falhar, os Circle voltarão ao seu saldo.",
  "Сервисы": "Serviços",
  "Загружаем статус сервисов": "Carregando o status dos serviços",
  "Загружаем справку": "Carregando a ajuda",
  "Статус не загрузился": "O status não carregou",
  "Статус сервисов пока не отслеживается": "O status dos serviços ainda não é monitorado",
  "Если что-то не работает, напишите в поддержку": "Se algo não funcionar, escreva para o suporte",
  "Часть сервисов работает с перебоями": "Alguns serviços apresentam instabilidade",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Veja o status dos seus trabalhos e os reembolsos confirmados em “Histórico”.",
  "Справка не загрузилась": "A ajuda não carregou",
  "Справка пока не опубликована": "A ajuda ainda não foi publicada",
  "Вопрос можно задать поддержке в Telegram": "Você pode perguntar ao suporte no Telegram",
  "Инструкции появятся после публикации справки": "As instruções aparecerão após a publicação da ajuda",
  "Назад к ИИ-агенту": "Voltar ao agente de IA",
  "Инструкция · {0}": "Guia · {0}",
  "Вопрос · {0}": "Pergunta · {0}",
  "Справка": "Ajuda",
  "Вопрос из Справки": "Pergunta da Ajuda",
  "Подробнее из Справки": "Mais na Ajuda",
  "Назад по таблице": "Rolar a tabela para trás",
  "Вперёд по таблице": "Rolar a tabela para frente",
  "Здравствуйте, {0}.": "Olá, {0}.",
  "Здравствуйте.": "Olá.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Sou o agente de suporte com IA do STEOS: ajudo com planos e Circle, ferramentas e modelos, códigos promocionais, STEOS ID e o programa de parceiros. Pergunte com suas palavras ou escolha uma pergunta.",
  "ИИ-агент печатает": "O agente de IA está digitando",
  "ИИ-агент ещё отвечает": "O agente de IA ainda está respondendo",
  "Напишите вопрос": "Digite uma pergunta",
  "Диалог с ИИ-агентом": "Conversa com o agente de IA",
  "Распознаём…": "Reconhecendo…",
  "Слушаю": "Ouvindo",
  "Спросите о STEOS": "Pergunte sobre o STEOS",
  "Вопрос ИИ-агенту": "Pergunta ao agente de IA",
  "Остановить диктовку": "Parar o ditado",
  "Сказать голосом": "Ditar por voz",
  "Отправить": "Enviar",
  "Не удалось начать новый чат": "Não foi possível iniciar um novo chat",
  "Спасибо, учтём": "Obrigado, vamos considerar",
  "Спасибо, передадим команде": "Obrigado, vamos repassar à equipe",
  "Оценка не сохранилась": "A avaliação não foi salva",
  "Чат ещё загружается": "O chat ainda está carregando",
  "В чате уже {0} вопросов. Начните новый": "Este chat já tem {0} perguntas. Comece um novo",
  "Вопрос не сохранился. Попробуйте ещё раз": "A pergunta não foi salva. Tente novamente",
  "Некоторые сервисы работают медленнее обычного": "Alguns serviços funcionam mais devagar que o normal",
  "{0} не работают": "{0} não funcionam",
  "{0} не работает": "{0} não funciona",
  "{0} медленнее обычного": "{0}: mais devagar que o normal",
  "{0} работают медленнее обычного": "{0} funcionam mais devagar que o normal",
  "{0} работает медленнее обычного": "{0} funciona mais devagar que o normal",
  "Микрофон здесь недоступен": "O microfone não está disponível aqui",
  "Нет доступа к микрофону": "Sem acesso ao microfone",
  "Нужна запись от 1 до 30 секунд": "A gravação deve ter de 1 a 30 segundos",
  "Не удалось разобрать запись": "Não foi possível entender a gravação",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "O ditado não foi reconhecido. Toque no microfone para verificar novamente",
  "Вопрос не подошёл. Сформулируйте иначе": "A pergunta não é válida. Reformule",
  "Ответ не подтвердился. Напишите в поддержку": "A resposta não foi confirmada. Escreva para o suporte",
  "Ответ не пришёл. Проверьте ещё раз": "A resposta não chegou. Verifique novamente",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Vídeo circular falante, Vídeo fala, Foto fala, Repita os movimentos, avatar próprio",
  "Оживить фото, видео по описанию, рилсы и сцены": "Animar foto, vídeo por descrição, reels e cenas",
  "Фото, фотосессии, товары, карусели": "Fotos, sessões de fotos, produtos, carrosséis",
  "Голоса, клон, озвучка проектов, кавер": "Vozes, clone, locução de roteiros, cover",
  "Звёзды Telegram и карты": "Telegram Stars e cartões",
  "Не работает": "Fora do ar",
  "Как сделать по шагам": "Passo a passo",
  "Полезный ответ": "Resposta útil",
  "Ответ не помог": "Não ajudou",
  "Проверьте связь и попробуйте ещё раз": "Verifique a conexão e tente novamente",
  "Не удалось проверить владельца чата": "Não foi possível verificar o dono do chat",
  "Не удалось восстановить чат. Начните новый": "Não foi possível restaurar o chat. Comece um novo",
  "Клоны для озвучки": "Clones para narrações",
  "Создайте первый голос": "Crie sua primeira voz",
  "Люди и питомцы для фото": "Pessoas e pets para fotos",
  "Добавьте близких для фото": "Adicione pessoas queridas às fotos",
  "Сохранённые работы": "Trabalhos salvos",
  "Отмечайте работы сердцем": "Marque trabalhos com um coração",
  "Ежедневная серия и бонусы": "Sequência diária e bônus",
  "Частые вопросы и связь с нами": "Perguntas frequentes e contato",
  "Обучается": "Treinando",
  "Аккаунт недоступен": "Conta indisponível",
  "Эта неделя · {0}": "Esta semana · {0}",
  "Неделя с {0} · {1}": "Semana de {0} · {1}",
  "ID скопирован": "ID copiado",
  "Скопировать ID": "Copiar ID",
  "Баланс временно недоступен": "Saldo temporariamente indisponível",
  "Разбивка остатка временно недоступна": "Detalhamento do saldo temporariamente indisponível",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Destes, {0} C expira em {1}|Destes, {0} C expiram em {1}",
  "Ближайшие {0} C сгорят {1}": "Os próximos {0} C expiram em {1}",
  "Circle каждый месяц от {0}": "Circle todo mês a partir de {0}",
  "Circle каждый месяц с подпиской": "Circle todo mês com assinatura",
  "Тариф временно недоступен": "Plano temporariamente indisponível",
  "Аккаунт, подписка и баланс": "Conta, assinatura e saldo",
  "Статистика и моё": "Estatísticas e Meu",
  "{0} к прошлой неделе": "{0} vs. semana passada",
  "Работы по неделям: на этой неделе {0}": "Trabalhos por semana: {0} nesta semana",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Trabalhos por semana: {0} nesta semana, {1} na passada",
  "Статистика пока недоступна": "Estatísticas ainda indisponíveis",
  "Дата регистрации недоступна": "Data de cadastro indisponível",
  "С {0}": "Desde {0}",
  "Создано": "Criado",
  "Серия": "Sequência",
  "день подряд|дня подряд|дней подряд": "dia seguido|dias seguidos",
  "Общий аккаунт STEOS": "Conta STEOS unificada",
  "Для вывода Circle": "Para sacar Circle",
  "До {0}% с их покупок": "Até {0}% das compras deles",
  "Обновлено {0}": "Atualizado: {0}",
  "Действия": "Ações",
  "Сохранить имя": "Salvar nome",
  "Новое имя": "Novo nome",
  "Больше голосов с подпиской": "Mais vozes com assinatura",
  "Создание голосов пока недоступно": "Criação de vozes ainda indisponível",
  "Свободных мест нет": "Sem vagas livres",
  "с подпиской до {0}": "até {0} com assinatura",
  "Пауза «{0}»": "Pausar “{0}”",
  "Прослушать «{0}»": "Ouvir “{0}”",
  "Переименовать": "Renomear",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Grave 2 segundos de fala ou envie arquivos, e a voz vai soar como você",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Sem vagas livres. Exclua uma voz para gravar outra",
  "Выбрать за «Вы»": "Usar como “Você”",
  "голос по умолчанию": "voz padrão",
  "Сделать кружок с вариантом «{0}»": "Criar vídeo circular com o visual “{0}”",
  "Выбраны": "Selecionadas",
  "{0} фото|{0} фото|{0} фото": "{0} foto|{0} fotos",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} foto · para todas as ferramentas|{0} fotos · para todas as ferramentas",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} visual · vídeos circulares, fotos e vídeos|{0} visuais · vídeos circulares, fotos e vídeos",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} visual|{0} visuais",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "A voz {0} foi excluída; o visual {1} agora usa a voz padrão.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Vozes foram excluídas; os visuais {0} agora usam a voz padrão.",
  "Другой голос можно выбрать у каждого кружка": "Você pode escolher outra voz em cada vídeo circular",
  "Вариантов пока нет": "Ainda não há visuais",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Envie suas fotos, e seu visual vai falar com sua voz em vídeos circulares, fotos e vídeos",
  "Вы: свои фото и варианты": "Você: suas fotos e visuais",
  "добавьте фото": "adicione fotos",
  "Изменить «{0}»": "Editar “{0}”",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} pessoa querida · para fotos e vídeos|{0} pessoas queridas · para fotos e vídeos",
  "Люди и питомцы для фото и видео": "Pessoas e pets para fotos e vídeos",
  "Близких пока нет": "Ainda não há pessoas queridas",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Adicione pessoas e pets com fotos, e eles vão aparecer ao seu lado na imagem",
  "Открыть в «Истории»": "Abrir no Histórico",
  "Вернуть в избранное": "Voltar aos favoritos",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} trabalho com coração|{0} trabalhos com coração",
  "Отмеченные сердцем работы": "Trabalhos marcados com coração",
  "Открыть «Историю»": "Abrir Histórico",
  "Не удалось загрузить избранное": "Não foi possível carregar os favoritos",
  "Закройте лист и откройте его ещё раз": "Feche a janela e abra de novo",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Marque trabalhos com coração no Histórico, e eles aparecerão aqui",
  "Не удалось обновить. Попробуйте позже": "Não foi possível atualizar. Tente mais tarde",
  "Удалить голос «{0}»?": "Excluir a voz “{0}”?",
  "Голос пропадёт из списка. Вернуть его не получится.": "A voz sairá da lista. Não será possível recuperá-la.",
  "Удалить вариант «{0}»?": "Excluir o visual “{0}”?",
  "За «Вы» снова встанут ваши фото.": "Suas fotos voltarão a ser usadas como “Você”.",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Vídeos circulares e fotos prontos ficam no Histórico. Não será possível recuperar o visual.",
  "Не удалось удалить голос": "Não foi possível excluir a voz",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Não foi possível excluir o visual. Tente de novo",
  "«{0}»": "“{0}”",
  "подписка: до {0}": "até {0}",
  "варианты «Вы»: Новый вариант": "Novo visual",
  "в очереди": "na fila",
  "идёт": "em andamento",
  "завершено": "concluído",
  "не удалось": "falhou",
  "слово подтверждения: УДАЛИТЬ": "EXCLUIR",
  "Выгрузка: {0}": "Exportação: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Exclusão: {0}. O STEOS ID e os recibos financeiros são mantidos.",
  "Введите {0}": "Digite {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Transferência ainda não confirmada. A verificação continua: abra a janela mais tarde",
  "Этот STEOS ID уже связан с другим Telegram": "Este STEOS ID já está vinculado a outra conta do Telegram",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "As duas contas têm assinatura. Fale com o suporte para unificá-las",
  "Слишком много попыток. Попробуйте позже": "Muitas tentativas. Tente mais tarde",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "A conexão do STEOS ID está indisponível agora. Tente mais tarde",
  "Не удалось создать аккаунт. Попробуйте позже": "Não foi possível criar a conta. Tente mais tarde",
  "Не удалось отправить письмо": "Não foi possível enviar o e-mail",
  "Фото не подошло. Выберите другое": "A foto não serviu. Escolha outra",
  "Загрузите фото заново": "Envie a foto novamente",
  "Данные изменились. Откройте заново": "Os dados mudaram. Abra de novo",
  "подряд": "seguidos",
  "Начните {0}": "Comece {0}",
  "серию": "uma sequência",
  "Завтра +{0} C": "Amanhã +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Entre todos os dias: a recompensa cresce, no sétimo dia são {0} C. Se falhar um dia, a sequência recomeça.",
  "Забрать {0} C": "Recolher {0} C",
  "Прогресс": "Progresso",
  "Заданий здесь пока нет": "Ainda não há tarefas aqui",
  "Время обновления недоступно": "Hora de atualização indisponível",
  "Новые через {0}": "Novas em {0}",
  "Выполнено {0} из {1}": "{0} de {1} concluídas",
  "друг|друга|друзей": "amigo|amigos",
  "{0} с вами": "{0} com você",
  "Прогресс друзей недоступен": "Progresso dos amigos indisponível",
  "Пригласить": "Convidar",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Contam os amigos que chegam pelo seu link ou código promocional e criam o primeiro trabalho",
  "Ещё {0} {1} до награды {2}": "Mais {0} {1} para {2}",
  "Все ступени пройдены": "Todos os níveis concluídos",
  "Получено {0} из {1}": "{0} de {1} recebidas",
  "Задания": "Tarefas",
  "покупатель|покупателя|покупателей": "comprador|compradores",
  "Партнёрская программа": "Programa de parceiros",
  "Партнёрам": "Para parceiros",
  "До {0}% {1}": "Até {0}% {1}",
  "с покупок друзей": "das compras de amigos",
  "Заработано {0} с покупок {1} {2}": "Ganhou {0} com compras de {1} {2}",
  "друга|друзей|друзей": "amigo|amigos",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Escolha: mais possibilidades no STEOS ou rendimento das recomendações.",
  "Ещё {0} до уровня {1}": "Mais {0} para {1}",
  "Максимальный уровень: вывод через STEOS ID": "Nível máximo: saque via STEOS ID",
  "Статистика, материалы и вывод": "Estatísticas, materiais e levantamentos",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "É preciso verificar o pedido de recompensa anterior. Novos créditos estão bloqueados por agora",
  "Загружаем награды": "A carregar recompensas",
  "Награды не загрузились": "As recompensas não carregaram",
  "Создайте 3 работы": "Crie 3 trabalhos",
  "Сделайте кружок": "Crie um vídeo circular",
  "Персонаж или вы сами": "Uma personagem ou você",
  "Озвучьте текст": "Narre um texto",
  "Голосом героя или клона": "Com a voz de uma personagem ou clone",
  "Улучшите описание": "Melhore uma descrição",
  "Бот допишет детали": "O bot acrescenta os detalhes",
  "Отправьте работу": "Envie um trabalho",
  "Из «Истории» в любой чат": "Do Histórico para qualquer chat",
  "Неделя кружков": "Semana de vídeos circulares",
  "Создайте 10 кружков за неделю": "Crie 10 vídeos circulares numa semana",
  "Исследователь": "Explorador",
  "Попробуйте 5 разных инструментов студии": "Experimente 5 ferramentas diferentes do Estúdio",
  "Первый кружок": "Primeiro vídeo circular",
  "Видеокружок для Telegram": "Vídeo circular para o Telegram",
  "Клон голоса": "Clone de voz",
  "Всего 2 секунды речи": "Só 2 segundos de fala",
  "Первое фото": "Primeira foto",
  "Портрет в любом стиле": "Retrato em qualquer estilo",
  "Первый рилс с вами": "O seu primeiro reel",
  "Шаблон одной кнопкой": "Modelo com um toque",
  "Первый кавер": "Primeiro cover",
  "Песня другим голосом": "Uma música com outra voz",
  "Кружки и видео с вами": "Vídeos circulares e vídeos com você",
  "С вашей ссылкой": "Com o seu link",
  "Бот в чате": "Bot num chat",
  "Добавьте бота в группу": "Adicione o bot a um grupo",
  "Вход в STEOS ID": "Entrar com STEOS ID",
  "Один аккаунт с сайтом": "Uma conta com o site",
  "Первый друг": "Primeiro amigo",
  "3 друга": "3 amigos",
  "10 друзей": "10 amigos",
  "25 друзей": "25 amigos",
  "Первый покупатель": "Primeiro comprador",
  "Первая оплата друга": "Primeiro pagamento de um amigo",
  "{0} мин": "{0} min",
  "{0} ч": "{0} h",
  "Последний день": "Último dia",
  "Ещё {0} {1}": "Faltam {0} {1}",
  "Это задание выполняется вне мини-приложения": "Esta tarefa é feita fora da Mini App",
  "Задание пока недоступно": "Tarefa ainda indisponível",
  "Прогресс временно недоступен": "Progresso temporariamente indisponível",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Não foi possível recuperar o pedido de recompensa anterior. Verifique o saldo e contacte o suporte",
  "Награды временно недоступны. Попробуйте обновить данные": "As recompensas estão temporariamente indisponíveis. Tente atualizar",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Recompensa confirmada. Atualize os dados: não precisa recolher de novo",
  "Задание ещё не выполнено. Обновите прогресс": "A tarefa ainda não foi concluída. Atualize o progresso",
  "Награда уже получена. Обновите данные": "Recompensa já recebida. Atualize os dados",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Crédito não confirmado. Verifique o pedido anterior: novas recompensas estão bloqueadas",
  "Сначала обновите данные наград": "Atualize primeiro as recompensas",
  "Сначала проверьте прежний запрос награды": "Verifique primeiro o pedido de recompensa anterior",
  "Рассказчик": "Narrador",
  "Встреча на тракте": "Encontro na estrada",
  "Геральт": "Geralt",
  "Цири": "Ciri",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Chovia havia três dias, e a estrada para a fortaleza quase sumira sob a lama.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Você foi na frente sem mim de novo. Eu pedi para esperar na ponte.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Eu esperei. Uma hora inteira. Depois achei que você tinha se perdido.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Bruxos não se perdem. Às vezes escolhemos o caminho mais longo.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Então, da próxima vez, escolha mais rápido. Estou congelando.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Em silêncio, ele tirou a capa e a pôs sobre os ombros dela. À frente já se viam as luzes da fortaleza.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Vamos. O Vesemir com certeza já pôs a sopa no fogo.",
  "Опять ты?": "Você de novo?",
  "Мне нужна помощь": "Preciso de ajuda",
  "Вставьте сценарий или начните с нуля": "Cole um roteiro ou comece do zero",
  "Напишите хотя бы одну реплику": "Escreva pelo menos uma fala",
  "Сократите реплику: до {0} знаков": "Encurte a fala: até {0} caracteres",
  "Сократите проект: до {0} знаков": "Encurte o projeto: até {0} caracteres",
  "Озвучка проектов временно недоступна": "A locução de roteiros está temporariamente indisponível",
  "Выберите голос для каждой роли": "Escolha uma voz para cada papel",
  "Озвучить · {0} C": "Narrar · {0} C",
  "Без названия": "Sem título",
  "Роль": "Papel",
  "вчера": "ontem",
  "Проекты": "Projetos",
  "роль|роли|ролей": "papel|papéis",
  "реплика|реплики|реплик": "fala|falas",
  "Нет реплик": "Sem falas",
  "{0} знаков": "{0} caracteres",
  "Строки «Имя: реплика» сами станут ролями и голосами": "Linhas «Nome: fala» viram papéis e vozes",
  "Начать с нуля": "Começar do zero",
  "Роли и реплики добавите сами": "Adicione papéis e falas você mesmo",
  "Открыть пример": "Abrir exemplo",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Os projetos são salvos sozinhos: volte a eles quando quiser",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Um papel com o nome de uma personagem recebe a voz dela: Geralt, Ciri, Yennefer",
  "Переименовать проект": "Renomear projeto",
  "Загрузить свежую": "Carregar a mais recente",
  "{0}: голос {1}. Сменить голос": "{0}: voz {1}. Mudar a voz",
  "Действия с ролью": "Ações do papel",
  "Озвучиваем": "Narrando",
  "Действия с репликой": "Ações da fala",
  "Реплика: {0}": "Fala: {0}",
  "Реплик пока нет": "Ainda não há falas",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Toque em «Fala» abaixo ou cole um roteiro pronto",
  "Реплика": "Fala",
  "за проект": "por projeto",
  "Цена — по числу знаков": "Preço conforme os caracteres",
  "Добавить реплику": "Adicionar fala",
  "проект|проекта|проектов": "projeto|projetos",
  "{0} {1} · сохраняются сами": "{0} {1} · salvos automaticamente",
  "Пока ни одного": "Nenhum ainda",
  "Новый проект": "Novo projeto",
  "Вставить сценарий или начать с нуля": "Colar um roteiro ou começar do zero",
  "Удаление проекта": "Exclusão do projeto",
  "Новая роль": "Novo papel",
  "Это первая реплика": "Esta é a primeira fala",
  "Это последняя реплика": "Esta é a última fala",
  "Удалить роль": "Excluir papel",
  "Вместе с её репликами": "Junto com as falas",
  "В проекте нужна хотя бы одна роль": "O projeto precisa de pelo menos um papel",
  "Удалить роль «{0}»?": "Excluir o papel «{0}»?",
  "Вместе с ней уйдут {0} {1}.": "Também será excluído: {0} {1}.",
  "Удалить проект?": "Excluir o projeto?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Os papéis e as falas serão excluídos; não será possível recuperar o projeto.",
  "Выбор голоса откроется в приложении": "A escolha de voz abre no app",
  "Не удалось удалить проект: {0}": "Não foi possível excluir o projeto: {0}",
  "Не получилось открыть аудио": "Não foi possível abrir o áudio",
  "Не получилось включить звук": "Não foi possível reproduzir o som",
  "Сначала напишите текст реплики": "Escreva primeiro o texto da fala",
  "Аудио реплики пока недоступно": "O áudio da fala ainda não está disponível",
  "Готовим роли": "Preparando papéis",
  "Роли готовы": "Papéis prontos",
  "Озвучиваем реплики": "Narrando falas",
  "Реплики озвучены": "Falas narradas",
  "Собираем дорожку": "Montando a faixa",
  "Дорожка собрана": "Faixa montada",
  "дубль {0}": "versão {0}",
  "Время реплики пока недоступно": "O tempo da fala ainda não está disponível",
  "Общий файл · {0}": "Arquivo completo · {0}",
  "Аудио пока недоступно": "Áudio ainda indisponível",
  "Слушать дорожку": "Ouvir a faixa",
  "реплика {0} из {1}": "fala {0} de {1}",
  "Проект не озвучен": "Projeto não narrado",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Você pode sair da tela: a narração continua, e a faixa aparecerá aqui e no Histórico.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Você pode sair da tela: o bot avisa quando a faixa estiver pronta.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Envie o arquivo completo para o chat ou baixe-o. Qualquer fala pode ser narrada de novo separadamente.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "O bot já enviou o arquivo completo para o chat, num tópico separado. Qualquer fala pode ser narrada de novo separadamente.",
  "Сценарий не прошёл проверку": "O roteiro não passou na verificação",
  "проект не озвучен": "projeto não narrado",
  "Не получилось собрать дорожку": "Não foi possível montar a faixa",
  "К сценарию": "Voltar ao roteiro",
  "Звук дорожки не загрузился: скачайте файл": "O som da faixa não carregou: baixe o arquivo",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Cada fala numa nova linha: nome, dois-pontos, texto. Uma linha sem nome fica com o papel anterior",
  "голос персонажа": "voz da personagem",
  "Заменить сценарий": "Substituir roteiro",
  "Сейчас {0} {1}, они уйдут": "Agora há {0} {1}; serão removidas",
  "реплику|реплики|реплик": "fala|falas",
  "Заменить на {0} {1}": "Substituir por {0} {1}",
  "Добавить {0} {1}": "Adicionar {0} {1}",
  "Заменить реплики": "Substituir falas",
  "Добавить реплики": "Adicionar falas",
  "Не нашли реплик: имя, двоеточие, текст": "Nenhuma fala encontrada: nome, dois-pontos, texto",
  "Вставьте сценарий в поле": "Cole o roteiro no campo",
  "Роли и голоса появятся сами": "Papéis e vozes aparecem sozinhos",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Geralt: Você de novo. O que foi desta vez?\nCiri: Preciso da sua ajuda.",
  "Сейчас нельзя": "Agora não é possível",
  "Вставьте текст в поле": "Cole o texto no campo",
  "Загружаем проекты": "Carregando projetos",
  "Проекты не загрузились": "Os projetos não carregaram",
  "Не хватает Circle: пополните баланс": "Circle insuficiente: adicione saldo",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Preço: {0} C. Toque de novo para narrar",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Não foi possível calcular o preço. Tente novamente",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "O roteiro não passou na verificação. Altere o texto e tente novamente.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Não foi possível montar a faixa. Se Circle foi debitado, ele voltará ao saldo.",
  "Запуск не подтверждён": "Início não confirmado",
  "Не получилось собрать дорожку.": "Não foi possível montar a faixa.",
  "Повторная проверка не спишет Circle дважды.": "Verificar de novo não cobra Circle duas vezes.",
  "Отправили в чат": "Enviado para o chat",
  "Отправка принята: бот пришлёт дорожку в чат": "Envio aceito: o bot enviará a faixa para o chat",
  "Прослушивание реплики пока недоступно": "A audição da fala ainda não está disponível",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Ouvir fala: {0} C. Toque de novo",
  "Переозвучка реплики пока недоступна": "Narrar a fala de novo ainda não está disponível",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Narrar a fala de novo: {0} C. Toque de novo",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Não é possível salvar projetos agora. Atualize os dados.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Não é possível editar projetos agora. Atualize os dados.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "O projeto ainda está sendo salvo. Tente daqui a um segundo.",
  "Результат больше недоступен.": "O resultado não está mais disponível.",
  "Не удалось проверить владельца проекта.": "Não foi possível verificar o dono do projeto.",
  "Операция не найдена. Проверьте историю.": "Operação não encontrada. Verifique o Histórico.",
  "Проект ещё не сохранён.": "O projeto ainda não foi salvo.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "A locução de roteiros não está disponível agora. Atualize os dados.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "A audição da fala não está disponível agora. Atualize os dados.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Narrar a fala de novo não está disponível agora. Atualize os dados.",
  "Дорожка ещё не готова.": "A faixa ainda não está pronta.",
  "Аккаунт сменился. Обновите страницу.": "A conta mudou. Recarregue a página.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "O envio ainda não foi confirmado. Toque de novo para verificar o pedido anterior.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "O resultado do projeto ainda não está disponível. Verifique o status novamente.",
  "Не удалось открыть аудио проекта.": "Não foi possível abrir o áudio do projeto.",
  "месяц|месяца|месяцев": "mês|meses",
  "покупателя|покупателей|покупателей": "comprador|compradores",
  "рабочий день|рабочих дня|рабочих дней": "dia útil|dias úteis",
  "друг купит|друга купят|друзей купят": "amigo comprar|amigos comprarem",
  "покупателем|покупателями|покупателями": "comprador|compradores",
  "Баннеры": "Banners",
  "Постер": "Cartaz",
  "Голос героя": "Voz do personagem",
  "Персонаж говорит": "Personagem fala",
  "Было и стало": "Antes e depois",
  "Подарок другу": "Presente para um amigo",
  "Кружок, который говорит": "Um vídeo circular que fala",
  "Персонаж читает ваш текст": "Uma personagem lê o seu texto",
  "Рилс с вами одной кнопкой": "Um reel consigo num toque",
  "Сюжет, монтаж и музыка в шаблоне": "Enredo, edição e música incluídos",
  "Герой говорит": "O herói fala",
  "Герой говорит вашим текстом": "Um herói diz o seu texto",
  "Голос и губы в такт": "Voz e lábios em sincronia",
  "Старое фото как новое": "Fotos antigas como novas",
  "Цвет и резкость за минуту": "Cor e nitidez num minuto",
  "Кавер любым голосом": "Um cover com qualquer voz",
  "Рок, джаз или lo-fi": "Rock, jazz ou lo-fi",
  "Фотосессия в любом образе": "Sessão de fotos em qualquer visual",
  "По паре своих фото": "Com algumas fotos suas",
  "Друзьям": "Para amigos",
  "Личное сообщение": "Mensagem privada",
  "Подписчикам": "Para seguidores",
  "Пост в канал": "Publicação no canal",
  "Семье": "Para a família",
  "Сообщение родным": "Mensagem à família",
  "Геймерам": "Para gamers",
  "Чат по интересам": "Chat temático",
  "Для работы": "Para o trabalho",
  "Коллегам и в рабочий чат": "Colegas e chat de trabalho",
  "Авторам": "Para criadores",
  "Блогерам и создателям роликов": "Bloggers e criadores de vídeos",
  "Подарок по моему промокоду": "Um presente com o meu código",
  "Кружки, фото и голос с ИИ прямо в Telegram": "Vídeos circulares, fotos e voz com IA no Telegram",
  "Кружки с персонажами": "Vídeos circulares com personagens",
  "Пишете текст, персонаж его говорит": "Escreve, a personagem fala",
  "Озвучка любым голосом": "Locução com qualquer voz",
  "Из библиотеки или своим клоном": "Da biblioteca ou com o seu clone",
  "Фотосессия без студии": "Sessão de fotos sem estúdio",
  "Пара своих фото, любой образ": "Algumas fotos, qualquer visual",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0} desde o registo pelo seu link ou desde a primeira compra com o seu código. Durante esse tempo recebe uma percentagem de todos os pagamentos do amigo. O código só funciona até à primeira compra; se o amigo veio pelo link, o código já não altera a ligação.",
  "Что получает друг?": "O que recebe o amigo?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C de imediato: não podem ser levantados e expiram em {1}.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "O desconto de {0}% no primeiro pacote Circle vale durante {1} após a assinatura, porque os pacotes Circle só são vendidos com assinatura. Um presente por conta: pelo link ou pelo código.",
  "Что считается оплатой?": "O que conta como pagamento?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Assinaturas e pacotes Circle pagos com Stars ou cartão. A percentagem é calculada sobre o valor pago pelo amigo, com desconto. Moedas de bónus, recompensas de tarefas e reembolsos não contam.",
  "Какие бывают промокоды?": "Que códigos existem?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "O seu código de parceiro dá um presente ao amigo e liga-o a si; só funciona até à primeira compra. Os códigos STEOS são publicados pela equipa no canal e na comunidade STEOS: dão Circle com prazo próprio e funcionam para todos, uma vez por conta.",
  "Когда приходят Circle?": "Quando chegam os Circle?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Logo após o pagamento do amigo, diretamente no saldo. No nível {0} pode levantá-los.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Logo após o pagamento do amigo, diretamente no saldo. Nos níveis {0} funcionam dentro do STEOS; no {1} pode levantá-los.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Logo após o pagamento do amigo, diretamente no saldo. No nível {0} funcionam dentro do STEOS; no {1} pode levantá-los.",
  "Считаются ли друзья с истёкшей привязкой?": "Contam os amigos com ligação expirada?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Sim. Deixa de receber percentagem dos pagamentos deles, mas continuam a contar para o nível: é calculado com todos os compradores de sempre.",
  "Кто может выводить?": "Quem pode sacar?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "Parceiros do nível {0} (a partir de {1}) com status de MEI, autônomo ou equivalente estrangeiro, após entrar com STEOS ID. Saque só em dinheiro para uma conta: aqui ou em {2}.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Embaixadores (a partir de {0}) com status de MEI, autônomo ou equivalente estrangeiro, após entrar com STEOS ID. Saque só em dinheiro para uma conta: aqui ou em {1}.",
  "Можно ли вывести монеты, заработанные до входа?": "Posso sacar moedas ganhas antes de entrar?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Sim. Os Circle ganhos no nível {0} antes de entrar com STEOS ID ficam no saldo e podem ser levantados depois de entrar.",
  "Какие монеты тратятся первыми?": "Que moedas são gastas primeiro?",
  "Можно пригласить самого себя?": "Posso convidar-me a mim mesmo?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Não. Compras da sua conta e de contas duplicadas não contam.",
  "Международный": "Internacional",
  "Self-employed, sole trader или компания вне РФ": "Independente, empresário ou empresa fora da Rússia",
  "Самозанятый в РФ": "Independente na Rússia",
  "Налог на профессиональный доход": "Imposto sobre rendimento profissional (NPD)",
  "ИП в РФ": "Empresário individual na Rússia",
  "Индивидуальный предприниматель": "Empresário em nome individual",
  "Имя или компания": "Nome ou empresa",
  "Как в документах": "Como nos documentos",
  "TIN или номер в вашей стране": "TIN ou número fiscal do seu país",
  "ФИО": "Nome completo",
  "Как в паспорте": "Como no passaporte",
  "ИНН": "INN",
  "12 цифр": "12 dígitos",
  "Название ИП": "Nome do empresário",
  "Как в выписке": "Como na certidão",
  "ИНН или ОГРНИП": "INN ou OGRNIP",
  "От 10 до 15 цифр": "De 10 a 15 dígitos",
  "НДС": "IVA",
  "Плательщик НДС": "Sujeito passivo de IVA",
  "Адрес": "Morada",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "Sede da STEOS",
  "Платёжный агент STEOS в России": "Agente de pagamentos da STEOS na Rússia",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Aqui abrirá a escolha de chat do Telegram com este texto, link e código",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Aqui abrirá a escolha de chat do Telegram: o banner segue com legenda e o botão «Abrir STEOS»",
  "Ещё <b>{0} {1}</b> до уровня {2}": "Mais <b>{0} {1}</b> até {2}",
  "Максимальный уровень": "Nível máximo",
  "До следующего уровня": "Até ao próximo nível",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Ganhe até&nbsp;{0}% <span>das compras dos amigos</span>",
  "Период": "Período",
  "Кого показать": "Mostrar",
  "Перешли": "Cliques",
  "Зарегистрировались": "Registos",
  "Купили": "Compraram",
  "Пока нет данных": "Ainda sem dados",
  "{0} к прошлому периоду": "{0} face ao período anterior",
  "за {0} {1}": "em {0} {1}",
  "Пока не считаем": "Ainda não contamos",
  "нет начислений": "sem ganhos",
  "Пик <b>{0} C</b>": "Pico <b>{0} C</b>",
  "Начисления по месяцам": "Ganhos por mês",
  "Начисления по дням": "Ganhos por dia",
  "Здесь появятся начисления": "Os ganhos aparecerão aqui",
  "Подписка Про": "Assinatura Pro",
  "Купила Circle": "Comprou Circle",
  "Купил Circle": "Comprou Circle",
  "Покупатель": "Comprador",
  "по промокоду": "com código",
  "привязка истекла": "ligação expirada",
  "Это весь список · {0}": "É a lista toda · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "O amigo fica ligado a si durante {0}: desde o registo pelo link ou desde a primeira compra com o código. O código só funciona até à primeira compra do amigo.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Os compradores com ligação expirada continuam a contar para o nível.",
  "Пока никого": "Ainda ninguém",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Partilhe o link ou o código e os primeiros amigos aparecerão aqui",
  "Картинка": "Imagem",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "O link e o código já estão na imagem. Toque num modelo para editar a legenda e publicar.",
  "{0}, открыть и опубликовать": "{0}, abrir e publicar",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Para Reels, Shorts, TikTok e VK Clips. O código e o link já estão no vídeo; o bot envia-o para o chat.",
  "{0}, открыть": "{0}, abrir",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "O link e o código já estão no texto. Copie-o ou envie-o para um chat.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "A imagem vai para o chat com legenda e o botão «Abrir STEOS». Serve para grupos, canais e mensagens privadas.",
  "Баннер «{0}» с вашим промокодом": "Banner «{0}» com o seu código",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "Cartaz QR: o código abre o seu link, código {0}",
  "Кружки, фото и голос с ИИ": "Vídeos circulares, fotos e voz com IA",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C para começar com o código",
  "Начните по ссылке или промокоду": "Comece pelo link ou pelo código",
  "Наведите камеру телефона": "Aponte a câmara do telemóvel",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 para imprimir: expositores, montras, cartões. O QR abre o seu link e o código abaixo pode ser introduzido sem câmara.",
  "Цвет постера": "Cor do cartaz",
  "Прислать PDF в чат": "Enviar PDF ao chat",
  "Вывести": "Sacar",
  "Заявка на {0} C не подтверждена": "Pedido de {0} C não confirmado",
  "Вывод сейчас недоступен": "Saque indisponível no momento",
  "Вывод недоступен": "Indisponível",
  "Деньгами на ваш счёт за {0}": "Na sua conta em {0}",
  "Вывод от {0} C": "Saque a partir de {0} C",
  "Вывод заработает после входа через STEOS ID": "O saque fica ativo após entrar com STEOS ID",
  "Войдите через STEOS ID": "Entre com STEOS ID",
  "Вывод доступен на уровне {0}, от {1}": "Saque no nível {0}, a partir de {1}",
  "Нужен уровень {0}": "Requer nível {0}",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "O saque abre no nível {0}, a partir de {1}. Até lá, os Circle funcionam dentro do STEOS",
  "Не подключён": "Não ligado",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Ao entrar, a conta do bot liga-se à sua conta STEOS comum: o saldo fica partilhado e o saque funciona aqui e no site STEOS ID.",
  "Выплачено": "Pago",
  "В обработке": "Em processamento",
  "Отклонено": "Recusado",
  "Не удалось загрузить историю выводов": "Não foi possível carregar o histórico",
  "Выводов пока не было": "Ainda sem levantamentos",
  "за всё время": "no total",
  "Можно вывести": "Disponível para sacar",
  "Тестовая программа: настоящих выплат нет": "Programa de teste: sem pagamentos reais",
  "Баланс и выводы есть и на {0}.": "O saldo e os levantamentos também estão em {0}.",
  "Вопрос о выводе?": "Dúvida sobre levantamentos?",
  "Напишите в поддержку": "Contacte o suporte",
  "Поделитесь ссылкой или промокодом": "Partilhe o link ou o código",
  "Друг привязывается к вам на {0}": "O amigo fica ligado a si durante {0}",
  "Друг получает подарок": "O amigo recebe um presente",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C de imediato e −{1}% no primeiro pacote Circle após a assinatura",
  "Друг платит в STEOS": "O amigo paga no STEOS",
  "Подписка и пакеты Circle звёздами или картой": "Assinatura e pacotes Circle com Stars ou cartão",
  "Вам приходит процент": "Recebe uma percentagem",
  "{0}% с каждой оплаты, сразу на баланс": "{0}% de cada pagamento, direto no saldo",
  "Шаг {0}": "Passo {0}",
  "От {0}": "A partir de {0}",
  "С первого дня": "Desde o primeiro dia",
  "Если {0} {1} {2}": "Se {0} {1} {2}",
  "{0} C за {1}": "{0} C em {1}",
  "Хватит на {0} в месяц": "Chega para {0} por mês",
  "Кружок стоит {0} C": "Um vídeo circular custa {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Calculado com a assinatura {0}: {1} por mês, ou seja {2}&nbsp;C. A percentagem vem de cada pagamento do amigo durante {3} de ligação.",
  "Уровень считается вместе с вашими {0}.": "Os seus compradores atuais contam para o nível: {0}.",
  "Калькулятор дохода": "Calculadora de rendimento",
  "Тариф друзей": "Plano dos amigos",
  "Сколько друзей купят подписку": "Quantos amigos compram assinatura",
  "Вы получите": "Vai receber",
  "C в месяц": "C por mês",
  "Проценты, сроки и ограничения": "Percentagens, prazos e limites",
  "Circle можно вывести": "Circle levantáveis",
  "Circle работают внутри STEOS": "Circle dentro do STEOS",
  "Привязка на {0}": "Ligação por {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Percentagem de todos os pagamentos do amigo: desde o registo pelo link ou desde a primeira compra com o código",
  "Ссылка главнее промокода": "O link prevalece sobre o código",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Se o amigo veio pelo link, o código já não altera a ligação",
  "Промокод только до первой покупки": "Código só até à primeira compra",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Após o primeiro pagamento do amigo, o seu código de parceiro deixa de funcionar para ele",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C de imediato, expiram em {1}. {2} no primeiro pacote Circle durante {3} após a assinatura",
  "Только уровень {0}": "Só nível {0}",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "A partir de {0} {1}, após entrar com STEOS ID. Para empresários, independentes e equivalentes noutros países",
  "Счёт на компанию STEOS": "Fatura a uma empresa STEOS",
  "Плательщик появится, когда вывод откроется": "O pagador aparece quando o saque abrir",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "Na Rússia: {0}, em rublos. Estatuto internacional: {1}, em euros",
  "Выплата за {0}": "Pagamento em {0}",
  "После проверки счёта, от {0} C": "Após verificar a fatura, a partir de {0} C",
  "Коротко о главном": "O essencial em resumo",
  "Здесь краткое изложение. Полный текст условий на {0}": "Isto é um resumo. Os termos completos estão em {0}",
  "Понятно": "Entendi",
  "У вас {0}.": "Tem {0}.",
  "Покупателей пока нет.": "Ainda sem compradores.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "O nível conta todos os compradores de sempre, incluindo os de ligação expirada.",
  "Введите сумму": "Introduza um valor",
  "Можно вывести не больше {0} C": "Pode sacar até {0} C",
  "Заполните реквизиты": "Preencha os dados",
  "Загрузите счёт на оплату": "Carregue uma fatura",
  "Счёт ещё проверяется": "A fatura ainda está a ser verificada",
  "Выплата в {0} · 1 C = {1} {0}": "Pagamento em {0} · 1 C = {1} {0}",
  "Вывести {0} C": "Sacar {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Emita a fatura em {0}. Vamos verificá-la e o dinheiro chega em {1}.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Emita a fatura em euros. Vamos verificá-la e o dinheiro chega em {0}. Os dados ficam guardados no STEOS ID.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Emita a fatura em rublos. Vamos verificá-la e o dinheiro chega em {0}. Os dados ficam guardados no STEOS ID.",
  "Скопировать {0}": "Copiar {0}",
  "юридический адрес": "morada legal",
  "Скопировать название компании": "Copiar nome da empresa",
  "Скопировать все реквизиты": "Copiar todos os dados",
  "Реквизиты для счёта": "Dados para a fatura",
  "Проверяем счёт…": "A verificar a fatura…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG ou PNG, até 10 MB",
  "Можно вывести {0} C": "{0} C disponíveis",
  "Сумма, C": "Valor, C",
  "Сумма вывода, C": "Valor do saque, C",
  "Всё": "Tudo",
  "Придёт на счёт": "Vai receber",
  "Реквизиты": "Dados",
  "Счёт на оплату": "Fatura",
  "Заявка на вывод принята": "Pedido de saque aceite",
  "{0} придут за {1} после проверки счёта": "{0} chegam em {1} após a verificação da fatura",
  "Ролик принят в обработку": "Vídeo em preparação",
  "Ролик в чате с ботом": "Vídeo no chat do bot",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "O bot envia-o quando estiver pronto. A entrega ainda não foi confirmada.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Guarde-o e publique em Reels, Shorts, TikTok ou VK Clips",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "O código e o link já estão no vídeo. O bot envia-o para o chat, onde o pode guardar e publicar.",
  "Прислать в чат": "Enviar para o chat",
  "Текст выделен: скопируйте его вручную": "O texto está selecionado: copie-o manualmente",
  "Баннер готов: отправить его в чат можно из Telegram": "Banner pronto: pode enviá-lo para um chat no Telegram",
  "PDF принят в очередь": "PDF em fila",
  "PDF в чате": "PDF no chat",
  "Не удалось загрузить период. Попробуйте ещё раз": "Não foi possível carregar o período. Tente novamente",
  "Без начислений": "Sem ganhos",
  "Значение выделено: скопируйте его вручную": "Valor selecionado: copie-o manualmente",
  "Реквизиты выделены: скопируйте их вручную": "Dados selecionados: copie-os manualmente",
  "Нужен файл PDF, JPG или PNG": "É preciso um ficheiro PDF, JPG ou PNG",
  "Файл {0}, можно до 10 МБ": "Ficheiro de {0}, máximo 10 MB",
  "Партнёрство не загрузилось": "A parceria não carregou",
  "Загружаем партнёрскую программу": "A carregar o programa de parceiros",
  "за неделю": "na semana",
  "за месяц": "no mês",
  "Для вывода войдите через STEOS ID": "Entre com STEOS ID para sacar",
  "Вывод недоступен на текущем уровне": "Saque indisponível no seu nível",
  "Сумма больше доступной": "Valor acima do disponível",
  "Сумма меньше минимальной": "Valor abaixo do mínimo",
  "Проверьте реквизиты и счёт": "Verifique os dados e a fatura",
  "Счёт ещё не проверен. Загрузите его заново": "A fatura ainda não foi verificada. Carregue-a de novo",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Sem resposta. Verifique o mesmo pedido: os dados e a chave estão guardados",
  "Не удалось загрузить список друзей": "Não foi possível carregar a lista de amigos",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Não foi possível recuperar o pedido anterior. Contacte o suporte antes de fazer outro",
  "Партнёрская программа временно недоступна": "Programa de parceiros temporariamente indisponível",
  "Не удалось загрузить следующую страницу": "Não foi possível carregar a página seguinte",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Não foi possível preparar o banner. Tente novamente",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "O bot não consegue prepará-lo: abra o chat com o bot e tente novamente",
  "Материал сейчас недоступен": "Material indisponível no momento",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Envio não confirmado. Toque novamente: a repetição verifica o pedido anterior",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "O envio anterior não foi recuperado. Contacte o suporte",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Envio anterior confirmado. Toque novamente",
  "Отправка не подтверждена": "Envio não confirmado",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "A fatura não passou na verificação. Escolha PDF, JPG ou PNG até 10 MB",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Não foi possível guardar o pedido com segurança. Nada foi enviado",
  "Тут откроется инструмент «{0}»": "Aqui vai abrir a ferramenta “{0}”",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Geralt, Ciri e mais 2.400 vozes dizem tudo o que você escrever",
  "Снимите себя, и персонаж повторит ваши движения": "Filme-se e o personagem repete seus movimentos",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Escolha um visual e em um minuto terá 3 fotos de uma selfie",
  "Сделать": "Criar",
  "2 400 голосов, 19 языков": "2.400 vozes, 19 idiomas",
  "Текст в речь голосом персонажа или своим клоном": "Texto em fala na voz de um personagem ou do seu clone",
  "Ваш голос за две минуты": "Sua voz em dois minutos",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Grave uma amostra e o clone aparece em todas as ferramentas com locução",
  "Движения": "Movimentos",
  "бесплатно": "grátis",
  "/сек": "/s",
  "готов": "pronto",
  "Клон · готов": "Clone · pronto",
  "студия: Мой голос": "Minha voz",
  "Сейчас в тренде": "Em alta agora",
  "Популярное за неделю": "Popular nesta semana",
  "Геральт скажет ваш текст": "Geralt fala o seu texto",
  "Вы в знаменитых сценах": "Você em cenas famosas",
  "3 кадра в любом образе": "3 fotos em qualquer visual",
  "Готовый сюжет с вами": "Uma história pronta com você",
  "Вы повторите любой танец": "Você repete qualquer dança",
  "Ваш снимок в движении": "Sua foto em movimento",
  "Фото скажет ваш текст": "A foto fala o seu texto",
  "Легенды замка": "Lendas do castelo",
  "Город инков": "Cidade inca",
  "Неоновый дождь": "Chuva de neon",
  "Утренний бег": "Corrida matinal",
  "Танец теней": "Dança das sombras",
  "Дорога домой": "Caminho de casa",
  "Ночной рейв": "Rave noturna",
  "Снежный пик": "Pico nevado",
  "Тайны Хейвена": "Segredos de Haven",
  "Магия рун": "Magia das runas",
  "Странные дела": "Coisas estranhas",
  "Ночной рынок": "Mercado noturno",
  "Ретро-кадр": "Foto retrô",
  "Утро в горах": "Manhã nas montanhas",
  "Золотой час": "Hora dourada",
  "Студийный свет": "Luz de estúdio",
  "Полароид": "Polaroid",
  "Киберпанк": "Cyberpunk",
  "Старый маяк": "O velho farol",
  "Шторм в заливе": "Tempestade na baía",
  "Кинотрейлер": "Trailer de filme",
  "Город в движении": "Cidade em movimento",
  "Интервью": "Entrevista",
  "Пустыня на закате": "Deserto ao pôr do sol",
  "Подводный мир": "Mundo subaquático",
  "Кружок «Привет»": "Vídeo circular “Oi”",
  "Спокойной ночи": "Boa noite",
  "Поздравляю": "Parabéns",
  "Скучаю": "Saudades",
  "Новости дня": "Notícias do dia",
  "Нос корабля": "Proa do navio",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Duas pessoas na proa do navio, de braços abertos ao vento",
  "Героиня": "Heroína",
  "роль: Герой": "Herói",
  "Уклонение от пуль": "Desviando de balas",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "O tempo para, você se curva para trás e as balas passam",
  "Танец в закусочной": "Dança na lanchonete",
  "Пара танцует твист у стойки придорожной закусочной": "Um casal dança twist no balcão de uma lanchonete de estrada",
  "Танцор": "Dançarino",
  "Танцовщица": "Dançarina",
  "Свидание под дождём": "Encontro na chuva",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Chuva forte, uma casa antiga e um encontro esperado por anos",
  "Он": "Ele",
  "Она": "Ela",
  "Речь перед битвой": "Discurso antes da batalha",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "O líder passa pelas fileiras e o exército responde com um rugido",
  "Вождь": "Líder",
  "Знаменосец": "Porta-bandeira",
  "Погоня по крышам": "Perseguição nos telhados",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Saltos entre telhados da cidade à noite, a perseguição não fica para trás",
  "Беглец": "Fugitivo",
  "Преследователь": "Perseguidor",
  "Ограбление казино": "Assalto ao cassino",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Uma equipe de smoking atravessa o salão, o cofre já está aberto",
  "Главарь": "Chefe",
  "Напарник": "Parceiro",
  "Напарница": "Parceira",
  "Прощание на вокзале": "Despedida na estação",
  "Поезд трогается, двое держатся за руки до последнего": "O trem parte, os dois se dão as mãos até o último instante",
  "Пассажир": "Passageiro",
  "Провожающий": "Quem se despede",
  "Дуэль на закате": "Duelo ao pôr do sol",
  "Пустая улица, два стрелка и последние секунды тишины": "Rua vazia, dois pistoleiros e os últimos segundos de silêncio",
  "Шериф": "Xerife",
  "Злодей": "Vilão",
  "Танец на лестнице": "Dança na escadaria",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Um vilão de terno chamativo dança numa longa escadaria de rua",
  "Выход в открытый космос": "Caminhada espacial",
  "Астронавт парит над Землёй, трос уходит к станции": "Um astronauta flutua sobre a Terra, o cabo vai até a estação",
  "Астронавт": "Astronauta",
  "Рассвет над саванной": "Amanhecer na savana",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "O pet é erguido sobre a rocha e toda a savana olha para ele",
  "Главная роль": "Papel principal",
  "Хранитель": "Guardião",
  "Полёт под луной": "Voo sob a lua",
  "Велосипед отрывается от земли и летит на фоне луны": "A bicicleta sai do chão e voa diante da lua",
  "Финальная поддержка": "O saque final",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Corrida, salto e saque acima da cabeça sob aplausos",
  "Партнёрша": "Parceira",
  "Партнёр": "Parceiro",
  "Песня на холме": "Canção na colina",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Um prado alpino e o vento: você gira cantando e as crianças correm até você",
  "Бледная кожа": "Pele pálida",
  "Хвойный лес": "Floresta de pinheiros",
  "Первый взгляд": "Primeiro olhar",
  "Туман над рекой": "Névoa sobre o rio",
  "Полночь в школе": "Meia-noite na escola",
  "Двое на поляне": "Dois na clareira",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Um raio atravessa os pinheiros e dois ficam imóveis no meio da clareira",
  "Глаза цвета янтаря": "Olhos cor de âmbar",
  "Бал выпускников": "Baile de formatura",
  "Клятва": "O juramento",
  "Игра в грозу": "Jogo na tempestade",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Trovões sobre a clareira e cada tacada soa como um estrondo",
  "Отбивающий": "Rebatedor",
  "Подающая": "Arremessadora",
  "Ловец": "Apanhador",
  "К вершине сосны": "Ao topo do pinheiro",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Ele a leva nas costas até o topo de um pinheiro, lá embaixo a névoa e toda a floresta",
  "Примерка брони": "Vestindo a armadura",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "A armadura se encaixa peça por peça e o capacete fecha sobre o rosto",
  "Полёт над городом": "Voo sobre a cidade",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Aceleração sobre a cidade à noite, curva entre as torres e pouso no telhado",
  "Пилот брони": "Piloto da armadura",
  "Ночь в мастерской": "Noite na oficina",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Faíscas de solda, projetos no ar e o primeiro lançamento bem-sucedido",
  "Изобретатель": "Inventor",
  "Последний заряд": "A última carga",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "A carga da armadura está no fim, a equipe fica de costas uma para a outra e tudo se decide no último disparo",
  "Герой в броне": "Herói de armadura",
  "Качели на паутине": "Balanço na teia",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Um salto da beirada, a teia se estica e a rua passa sob seus pés",
  "Герой в маске": "Herói mascarado",
  "Поцелуй под дождём": "Beijo na chuva",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Um beco à noite e chuva forte: ele está de cabeça para baixo, ela levanta a ponta da máscara",
  "Крыша на закате": "Telhado ao pôr do sol",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Dois sentados na beira do telhado, a cidade agitada lá embaixo e o sol sumindo atrás das torres",
  "Бой в поезде": "Luta no trem",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Uma luta no teto de um trem em alta velocidade e depois o herói para o vagão com as mãos",
  "Пассажирка": "Passageira",
  "Для маркетплейса": "Para marketplaces",
  "Праздники": "Datas festivas",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Felicitações, vídeos circulares e posts para as datas: 1º de abril, Páscoa, 8 de março",
  "1 апреля": "1º de abril",
  "Пасха": "Páscoa",
  "8 марта": "8 de março",
  "Мода": "Moda",
  "Аватарки": "Avatares",
  "Фильмы": "Filmes",
  "Игры": "Jogos",
  "Путешествия": "Viagens",
  "Сумерки": "Crepúsculo",
  "Железный человек": "Homem de Ferro",
  "Человек-паук": "Homem-Aranha",
  "Романтика": "Romance",
  "Погони": "Perseguições",
  "Всей семьёй": "Em família",
  "Особая подборка": "Coleção especial",
  "Особая подборка {0}, {1}": "Coleção especial {0}, {1}",
  "Подборка {0}, {1}": "Coleção {0}, {1}",
  "{0} в подборке": "{0} na coleção",
  "шаблон|шаблона|шаблонов": "modelo|modelos",
  "шаблона|шаблонов|шаблонов": "modelo|modelos",
  "сцена|сцены|сцен": "cena|cenas",
  "инструмент|инструмента|инструментов": "ferramenta|ferramentas",
  "инструмента|инструментов|инструментов": "ferramenta|ferramentas",
  "стиль|стиля|стилей": "estilo|estilos",
  "кадра|кадров|кадров": "foto|fotos",
  "ребёнок|ребёнка|детей": "criança|crianças",
  "питомец|питомца|питомцев": "pet|pets",
  "кружки": "vídeos circulares",
  "голос": "voz",
  "текст": "texto",
  "для бизнеса": "negócios",
  "Кружок из видео": "Mensagem de vídeo de um vídeo",
  "Фото в новом стиле": "Foto em novo estilo",
  "Фото по описанию": "Foto por descrição",
  "Семейный портрет": "Retrato de família",
  "Видео в новом стиле": "Vídeo em novo estilo",
  "Видео по описанию": "Vídeo por descrição",
  "Видео другим голосом": "Vídeo com outra voz",
  "Объёмное фото": "Foto 3D",
  "Анимация из серии": "Animação de uma série",
  "Видео из поездки": "Vídeo da viagem",
  "Фильм из фотографий": "Filme com fotos",
  "Изменить видео": "Editar vídeo",
  "текст или запись": "texto ou gravação",
  "видео до 1 минуты": "vídeo de até 1 minuto",
  "1 фото и текст": "1 foto e texto",
  "запись или аудиофайл": "gravação ou arquivo de áudio",
  "5 фото лица": "5 fotos do rosto",
  "1 селфи": "1 selfie",
  "описание словами": "uma descrição",
  "фото или описание": "foto ou descrição",
  "старое фото": "uma foto antiga",
  "чёрно-белое фото": "uma foto em preto e branco",
  "фото близких": "fotos de pessoas queridas",
  "от 2 до 9 фото": "de 2 a 9 fotos",
  "тема поста": "tema do post",
  "1 фото или видео": "1 foto ou vídeo",
  "ваше фото": "sua foto",
  "фото тех, кто сыграет": "fotos de quem vai atuar",
  "1 видео": "1 vídeo",
  "видео и новый текст": "vídeo e novo texto",
  "видео с речью": "vídeo com fala",
  "текст поздравления": "texto de felicitação",
  "от 3 фото": "a partir de 3 fotos",
  "фото из поездки": "fotos da viagem",
  "семейные фото": "fotos de família",
  "сценарий": "roteiro",
  "запись голоса": "gravação de voz",
  "песня": "música",
  "файл или ссылка": "arquivo ou link",
  "название товара": "nome do produto",
  "от 1 до 5 фото товара": "de 1 a 5 fotos do produto",
  "фото товара": "fotos do produto",
  "1 видео с вами": "1 vídeo com você",
  "ваше видео": "seu vídeo",
  "картинка": "imagem",
  "идея словами": "uma ideia em palavras",
  "ваш промпт": "seu prompt",
  "нужно: 1 фото": "1 foto",
  "нужно: Текст": "Texto",
  "нужно: Тема": "Tema",
  "нужно: Запись": "Gravação",
  "формат: Reels": "Reels",
  "формат: фото": "fotos",
  "формат: видео": "vídeos",
  "формат: кружков": "vídeos circulares",
  "формат: шаблонов": "modelos",
  "любое, где хорошо видно лицо": "qualquer uma em que o rosto apareça bem",
  "лицо крупно и при хорошем свете": "rosto em close e com boa luz",
  "селфи, лицо крупно": "selfie, rosto em close",
  "снимок оживёт в ролике": "a foto ganha vida num vídeo",
  "что скажет герой": "o que o personagem vai dizer",
  "или фото, из которых сделаем слайды": "ou fotos que viram slides",
  "Сколько стоит одна генерация": "Quanto custa uma geração",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Uma foto custa {0} C, uma sessão de fotos {1} C por 3 fotos e um vídeo {2} C por 5 segundos. Os assistentes de texto, como a descrição de produto, custam {3} C. O preço sempre aparece no botão “Criar” antes da cobrança.",
  "Что такое C и как пополнить баланс": "O que é C e como recarregar",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C são as moedas Circle usadas para pagar as criações. Pacotes e assinatura são comprados na aba “Saldo”, onde também aparece o restante.",
  "Какие файлы можно загружать": "Quais arquivos posso enviar",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Vídeos de até 1 minuto e 15 MB, fotos em JPG ou PNG, áudio em MP3, WAV ou M4A. Cada ferramenta mostra seus limites.",
  "Как сделать дешевле": "Como deixar mais barato",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Se faltar Circle, o botão na parte de baixo abre “Circle insuficiente” com a opção “Deixar mais barato”. O desconto é de {0}% e o resultado terá marca d’água.",
  "Где найти готовые результаты": "Onde encontrar os resultados",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "Em “Histórico”, no menu “Mais”. Lá dá para baixar o arquivo de novo ou enviá-lo ao chat.",
  "Можно ли использовать свой голос": "Posso usar minha própria voz",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Sim. Clone sua voz na aba “Clone” e ela aparece na lista de vozes de todas as ferramentas com locução.",
  "Фотосессия из {0} в стиле шаблона": "Sessão de {0} no estilo do modelo",
  "По желанию: {0}": "Opcional: {0}",
  "Тут откроется шаблон «{0}»": "Aqui vai abrir o modelo “{0}”",
  "Только до": "Só antes",
  "Только после": "Só depois",
  "До: {0} %": "Antes: {0}%",
  "подборка": "coleção",
  "Все форматы": "Todos os formatos",
  "Состав": "Elenco",
  "Вкладки каталога": "Abas do catálogo",
  "Найти подборку": "Buscar coleção",
  "Найти шаблон": "Buscar modelo",
  "Поиск среди {0}": "Buscar entre {0}",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "Nenhuma coleção para “{0}”. Busque em todos os modelos",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "Nada para “{0}” em “{1}”. Busque em todos os modelos",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "Nada para “{0}” em “Para você”. Busque em todos os modelos",
  "В подборке «{0}» нет сцен «{1}»": "Nenhuma cena “{1}” em “{0}”",
  "Посмотрите все сцены подборки": "Veja todas as cenas da coleção",
  "В подборке «{0}» нет {1}": "Sem {1} em “{0}”",
  "Посмотрите во всех форматах": "Veja em todos os formatos",
  "В «Рекомендуем» нет {0}": "Sem {0} em “Para você”",
  "Пока ничего нет": "Ainda não há nada",
  "Шаблоны этого формата появятся совсем скоро": "Modelos neste formato chegam em breve",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "Sem {1} para “{0}”. Busque em todos os formatos",
  "Искать во всех форматах": "Buscar em todos os formatos",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "Nenhum modelo para “{0}”. Tente outra palavra",
  "Загружаем ещё": "Carregando mais",
  "Это все шаблоны": "Esses são todos os modelos",
  "Тренды": "Tendências",
  "Вкладки страницы": "Abas da página",
  "Найти сцену": "Buscar cena",
  "Найти в подборке": "Buscar na coleção",
  "Искать во всех сценах": "Buscar em todas as cenas",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "Nenhuma coleção para “{0}”. Busque em todas as cenas",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "Nada para “{0}” em “{1}”. Busque em todas as cenas",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "Nada para “{0}” em “Tendências”. Busque em todas as cenas",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "Nada para “{0}” em “Para você”. Busque em todas as cenas",
  "В «Трендах» нет сцен «{0}»": "Nenhuma cena “{0}” em “Tendências”",
  "В «Рекомендуем» нет сцен «{0}»": "Nenhuma cena “{0}” em “Para você”",
  "Посмотрите все сцены этой вкладки": "Veja todas as cenas desta aba",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "Nada em “{0}” para “{1}”. Busque em todos os modelos",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Esta coleção ainda não tem modelos assim. Veja a coleção inteira ou escolha outra aba",
  "Поиск в подборке «{0}»: {1}": "Buscar em “{0}”: {1}",
  "Вкладки подборки": "Abas da coleção",
  "Нужно: {0}": "Precisa: {0}",
  "Нужно": "Precisa",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "Nenhuma ferramenta ou modelo para “{0}”. Tente outra palavra ou veja todas as ferramentas",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "Nada para “{0}” em “{1}”. Busque em todas as ferramentas",
  "Искать во всех": "Buscar em tudo",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "Nenhuma ferramenta para “{0}”. Tente outra palavra",
  "Найти инструмент": "Buscar ferramenta",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Não foi possível abrir a ferramenta. Atualize o catálogo e tente de novo.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "A ferramenta não abriu em 30 segundos. Tente de novo ou volte.",
  "Карточка товара": "Card de produto",
  "Рилс готов": "Reels pronto",
  "Кавер не создан": "Cover não criado",
  "Фотосессия не создана": "Sessão de fotos não criada",
  "Рилс не создан": "Reels não criado",
  "Карточка не создана": "Card não criado",
  "Слайды не созданы": "Slides não criados",
  "Запись не обработана": "Gravação não processada",
  "Коллаж не создан": "Colagem não criada",
  "· остаток {0} C": "· restam {0} C",
  "Вернули {0} C": "Devolvemos {0} C",
  "Списано {0} C со скидкой, {1} водяной знак": "Cobrados {0} C com desconto, {1} marca d’água",
  "Списано {0} C": "Cobrados {0} C",
  "Рисованному стилю камера не нужна": "Um estilo desenhado não precisa de câmera",
  "У этой камеры объектив встроенный": "Esta câmera tem lente embutida",
  "У этой камеры резкость не настраивается": "Esta câmera não permite ajustar o foco",
  "У этого объектива диафрагма постоянная": "Esta lente tem abertura fixa",
  "Встроенный": "Embutida",
  "Как у камеры": "Como a câmera",
  "до {0} МБ": "até {0} MB",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "Nenhuma ferramenta ou modelo para {0}. Tente outra palavra ou veja todas as ferramentas",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "Nada para {0} em {1}. Busque em todas as ferramentas",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "Nenhuma ferramenta para {0}. Tente outra palavra",
  "в «Трендах»": "em “Tendências”",
  "в «Рекомендуем»": "em “Para você”",
  "в подборке {0}": "em {0}",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "Nada para {0} {1}. Busque em todas as cenas",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "Nada em {0} para {1}. Busque em todos os modelos",
  "сцен {0}": "cenas {0}",
  "В подборке {0} нет {1}": "Sem {1} em {0}",
  "В подборке {0} нет таких шаблонов": "{0} não tem modelos assim",
  "Посмотрите её целиком или выберите другую вкладку": "Veja a coleção inteira ou escolha outra aba",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Nada para {0} neste formato. Busque em todos os formatos",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "Nenhum modelo para {0}. Tente outra palavra",
  "Здесь нет шаблонов": "Não há modelos aqui",
  "Заказ принят": "Pedido recebido",
  "Бот пришлёт результат в чат, в отдельную тему.": "O bot vai enviar o resultado no chat, em um tópico separado.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Altere o pedido e tente de novo. Os Circle de um pedido verificado não são devolvidos.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Houve uma falha do nosso lado. Os Circle voltaram ao seu saldo.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "A ferramenta ainda está se conectando: o pedido está na fila e começa sozinho, o bot vai enviar o resultado no chat.",
  "Сначала отметьте согласие ниже": "Primeiro marque o consentimento abaixo",
  "Главное фото: {0}": "Foto principal: {0}",
  "Загружаем превью…": "Carregando prévia…",
  "Фото не подошло": "A foto não serviu",
  "Проверить загрузку": "Verificar envio",
  "Опишите, что хотите увидеть": "Descreva o que quer ver",
  "Не помещается: до {0} знаков": "Não cabe: até {0} caracteres",
  "{0} во весь экран": "{0} em tela cheia",
  "Загрузить картинку": "Enviar imagem",
  "Ваша": "Sua",
  "Убрать картинку": "Remover imagem",
  "Этот инструмент пока недоступен": "Esta ferramenta ainda não está disponível",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Escolha outra ferramenta ou volte aos modelos.",
  "Вернуться": "Voltar",
  "Образ": "Visual",
  "Ваши селфи": "Suas selfies",
  "Три разных кадра: лицо крупно, при хорошем свете": "Três fotos diferentes: rosto em close, com boa luz",
  "Подтверждаю согласие людей на фото": "Confirmo o consentimento das pessoas nas fotos",
  "От одного до пяти ракурсов, первый — главный": "De um a cinco ângulos, o primeiro é o principal",
  "Категория": "Categoria",
  "Набор сцен": "Conjunto de cenas",
  "Загрузите фото: нужно {0}": "Envie fotos: são necessárias {0}",
  "Выберите: {0}": "Escolha: {0}",
  "Не удалось загрузить экран.": "Não foi possível carregar a tela.",
  "Сцен: {0}": "Cenas: {0}",
  "Заказ создан, следите за ним в «Истории».": "Pedido criado, acompanhe em “Histórico”.",
  "Старые": "Mais antigas",
  "Длинные": "Mais longas",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "O estilo já define luz e cor. Escolha outro se quiser mudar",
  "{0} открывается только до f/{1}": "{0} só abre até f/{1}",
  "Объектив не задаёт светосилу": "A lente não define a abertura",
  "Этот объектив открывается только до f/{0}": "Esta lente só abre até f/{0}",
  "Назад к настройкам": "Voltar às configurações",
  "Группа": "Grupo",
  "Нашли {0}": "Encontrados: {0}",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Nada encontrado. Tente outra palavra ou limpe o grupo.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "A escolha volta direto às configurações. O preço não muda",
  "Сравнить: было и стало": "Comparar: antes e depois",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Pegamos o estilo: cor, luz e tratamento. A imagem em si e os rostos não são copiados",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Pegamos a cena: fundo, luz e composição. A imagem em si e os rostos não são copiados",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Pegamos o visual: roupa, pose, fundo e luz. Quem aparece é você, os rostos da imagem não são copiados",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "A imagem não serviu: não abre, tente JPG ou PNG",
  "Картинка не подошла: больше {0} МБ": "A imagem não serviu: maior que {0} MB",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "A imagem não serviu: pequena demais, mínimo {0} px",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "A imagem não serviu: tem conteúdo protegido ou proibido",
  "Загрузить картинку-референс": "Enviar imagem de referência",
  "Озвучка текста": "Texto em voz",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Grave 2 segundos de fala e o bot falará com a sua voz",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "As vozes prontas ficam na aba «Minhas» em Vozes",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "A voz aparece com este nome na sua lista. Só você vê a descrição",
  "Голос появится на вкладке «Мои»": "A voz aparecerá na aba «Minhas»",
  "Имя в списке голосов": "Nome na lista de vozes",
  "Уже в «Озвучке»": "Já em Vozes",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "A voz fica na aba «Minhas» com a etiqueta «Minha»",
  "Карточка голоса": "Ficha da voz",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Toque em uma voz da lista para renomear ou excluir",
  "Так голос выглядит в списке": "Assim a voz aparece na lista",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "A voz já está na aba «Minhas». Ouça como ela soa",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Verificação e treinamento em andamento, normalmente 1–3 minutos. A voz aparecerá sozinha na aba «Minhas»",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "A voz sumirá da aba «Minhas». Não será possível recuperá-la.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Normalmente 1–3 minutos. Pode fechar o app: a voz aparecerá na lista",
  "Можно закрыть приложение": "Pode fechar o app",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Grave a fala ou envie arquivos: de 0:02 a 1:30 no total. MP3, WAV, M4A, OGG e WEBM, até 10 arquivos de 20 MB",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "{n} de {n} clones criados. Exclua um para adicionar outro",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Sem assinatura, você pode criar {n} clones. Com ela, até {0}",
  "До {0} клонов": "Até {0} clones",
  "Три клона бесплатно": "Três clones grátis",
  "Запишите ещё один, другим тоном или настроением": "Grave outra com outro tom ou clima",
  "С подпиской можно создать до {0}": "Com assinatura, você pode criar até {0}",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Oi! Esta é uma gravação para a minha voz. Falo com calma e no ritmo normal, como numa conversa com um amigo. Quanto mais natural ficar agora, mais fiel será o clone.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Sabe o que é mais estranho em cozinhar vendo vídeo? Você vê alguém picar uma cebola em um minuto e pensa: é fácil. Depois, a cebola está em todo lugar, menos na frigideira.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Ontem finalmente desfiz as caixas da mudança. Achei um player antigo, três carregadores de celulares que eu nem tenho mais e um caderno com planos para o verão. O player ainda funciona.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "O tempo está estranho hoje: de manhã fez sol, na hora do almoço choveu e para a noite prometem neve. Hora perfeita de fazer algo quente e não ter pressa.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Um, dois, três, testando. Dá para me ouvir bem? Agora vou ler algumas frases em tons diferentes: primeiro com calma, depois um pouco mais alto e no fim bem baixinho, quase sussurrando.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Meu gato acha que o teclado foi feito para dormir e que o monitor serve para ser tapado com o rabo. Então, se algo farfalhar na gravação, saiba: foi trabalho em equipe.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Existe uma regra simples: se algo não dá certo na terceira tentativa, levante-se, sirva um chá e volte em cinco minutos. Normalmente, depois disso tudo dá certo sozinho.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Silêncio, ouviu? Passos aqui perto. Vamos espiar com cuidado na esquina e, se não houver ninguém, corremos até a porta. Só não faça barulho, por favor, é sério.",
  "Проверено": "Verificada",
  "Создание новых голосов пока недоступно": "Ainda não é possível criar novas vozes",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 segundos de fala: grave aqui ou envie arquivos",
  "Внутренняя ошибка, попробуйте позже": "Erro interno, tente mais tarde",
  "образцов: {n}": "amostras: {n}",
  "Образец короче 2 секунд": "A amostra tem menos de 2 segundos",
  "Образец длиннее 1,5 минуты": "A amostra tem mais de 1,5 minutos",
  "Слишком шумная запись — попробуйте в тихом месте": "Gravação muito ruidosa: tente num lugar silencioso",
  "В записи слышно несколько голосов": "Há várias vozes na gravação",
  "Проверка не пройдена: голос не совпадает с образцами": "Verificação falhou: a voz não corresponde às amostras",
  "Голос не прошёл правила площадки": "A voz não cumpre as regras da plataforma",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Verificação falhou: grave uma amostra sem música nem outras pessoas",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "São necessários de 2 segundos a 1,5 minutos de fala no total",
  "Результат обработки уточняется, загляните чуть позже": "O resultado está sendo confirmado, volte um pouco mais tarde",
  "Удалить голос «{n}»?": "Excluir a voz «{n}»?",
  "Навсегда, вместе с образцами": "Para sempre, com as amostras",
  "Например, спокойный, низкий": "Por exemplo, calma, grave",
  "Образец": "Amostra",
  "Запись или файлы, от 2 секунд": "Gravação ou arquivos, a partir de 2 s",
  "Имя, описание и согласие": "Nome, descrição e consentimento",
  "Проверка и обучение": "Verificação e treinamento",
  "Модель STEOS · 1–3 минуты": "Modelo STEOS · 1–3 min",
  "Тихое место без эха": "Um lugar silencioso e sem eco",
  "Фоновый шум и музыка попадут в голос": "Ruído de fundo e música vão parar na voz",
  "Хороший микрофон": "Um bom microfone",
  "Гарнитура или настольный микрофон лучше встроенного": "Um headset ou microfone de mesa é melhor que o embutido",
  "То же оборудование": "O mesmo equipamento",
  "Не меняйте микрофон между записями": "Não troque de microfone entre as gravações",
  "Под ним голос стоит в списке выбора": "A voz aparece com ele na lista",
  "Шумоподавление": "Redução de ruído",
  "Включайте, только если в записи слышен шум": "Ative só se houver ruído na gravação",
  "Согласие обязательно": "O consentimento é obrigatório",
  "Клонировать можно свой голос или с согласия владельца": "Você pode clonar a sua voz ou a de alguém com consentimento",
  "Проверка образца": "Verificação da amostra",
  "Один говорящий, без музыки и шума": "Uma só pessoa, sem música nem ruído",
  "Обучение": "Treinamento",
  "Модель STEOS, обычно 1–3 минуты": "Modelo STEOS, normalmente 1–3 minutos",
  "Голос появится в списке сам": "A voz aparecerá sozinha na lista",
  "Проверьте запись": "Verifique a gravação",
  "Один голос, без музыки и шума на фоне": "Uma só voz, sem música nem ruído de fundo",
  "Длина образца": "Duração da amostra",
  "Нужно не меньше 2 секунд чистой речи": "São necessários pelo menos 2 segundos de fala limpa",
  "Образцы сохранены": "Amostras salvas",
  "Можно попробовать снова с теми же файлами": "Você pode tentar de novo com os mesmos arquivos",
  "Не получилось — попробуйте снова": "Não deu certo, tente de novo",
  "Шаг {a} из {b}": "Etapa {a} de {b}",
  "Персональный": "Pessoal",
  "Дальше": "Avançar",
  "Продолжить": "Continuar",
  "К списку голосов": "Para a lista",
  "Результат уточняется": "Confirmando",
  "Попробовать снова": "Tentar de novo",
  "Голос готов": "A voz está pronta",
  "Опишите голос": "Descreva a voz",
  "Например, Мой голос": "Por exemplo, Minha voz",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Esta é a minha voz ou tenho o consentimento do dono. Não usarei o clone para enganar, ofender ou criar conteúdo proibido",
  "Загружаем {a} из {b}": "Enviando {a} de {b}",
  "Обрабатываем голос": "Processando a voz",
  "Не получилось создать голос": "Não foi possível criar a voz",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "O resultado ainda está sendo confirmado. Ainda não é possível tentar de novo.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "As amostras estão salvas: tente de novo com os mesmos arquivos",
  "Загруженные файлы": "Arquivos enviados",
  "Читаем аудио…": "Lendo o áudio…",
  "Записать ещё": "Gravar mais",
  "Ждём разрешение…": "Aguardando permissão…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Permita o acesso nas configurações do navegador ou envie um arquivo",
  "Другой текст": "Outro texto",
  "Прочитайте вслух": "Leia em voz alta",
  "Микрофон по умолчанию": "Microfone padrão",
  "Минимум": "Mínimo",
  "Хорошо": "Bom",
  "Отлично": "Excelente",
  "Набрано {a} из {b}": "{a} de {b} gravados",
  "из {t}": "de {t}",
  "всё готово": "tudo pronto",
  "Файлов с ошибкой: {n}": "Arquivos com erro: {n}",
  "до «{n}» ещё {t}": "faltam {t} para «{n}»",
  "Ещё {t} до минимума": "Faltam {t} para o mínimo",
  "Нужно не меньше 2 секунд": "São necessários pelo menos 2 segundos",
  "Загрузка образцов": "Envio das amostras",
  "Образцы приняты сервером": "O servidor recebeu as amostras",
  "Проверка голоса": "Verificação da voz",
  "Пройдена": "Aprovada",
  "Не запрашивалась": "Não solicitada",
  "Результат проверки пока недоступен": "O resultado da verificação ainda não está disponível",
  "Обработка голоса": "Processamento da voz",
  "Не удалось обработать": "Não foi possível processar",
  "Выполняется на сервере": "Em andamento no servidor",
  "Очистка шума": "Limpeza de ruído",
  "Пропущено": "Ignorado",
  "Модель STEOS · один говорящий, без музыки": "Modelo STEOS · uma pessoa, sem música",
  "Обучение голоса": "Treinamento da voz",
  "Файл больше 20 МБ": "Arquivo maior que 20 MB",
  "Запись {n}": "Gravação {n}",
  "Не удалось прочитать аудио": "Não foi possível ler o áudio",
  "Неподдерживаемый формат": "Formato não suportado",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "O resultado da criação anterior ainda está sendo confirmado. Volte à solicitação anterior para não criar um segundo clone.",
  "Проверить прошлое создание": "Verificar a anterior",
  "Остановить": "Parar",
  "Ждём доступ": "Aguardando",
  "Ещё раз": "De novo",
  "Начать запись": "Começar a gravar",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Toque em uma voz da lista para abrir a ficha: ouvir, renomear ou excluir.",
  "Озвучек": "Locuções",
  "Знаков": "Caracteres",
  "Образцов": "Amostras",
  "Доступна": "Disponível",
  "Недоступна": "Indisponível",
  "После обучения": "Após o treinamento",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Treinada com suas gravações: {n} amostras, {d} no total",
  "Происхождение: ваши записи. Подробнее": "Origem: suas gravações. Saiba mais",
  "Происхождение": "Origem",
  "Ваши записи": "Suas gravações",
  "Проверка": "Verificação",
  "Не пройдена": "Reprovada",
  "Идёт": "Em andamento",
  "Переозвучка аудио": "Nova narração de áudio",
  "Создан": "Criada",
  "Доступ": "Acesso",
  "Только вы": "Só você",
  "Голос пока недоступен для выбора. Обновите список.": "A voz ainda não pode ser escolhida. Atualize a lista.",
  "Голос ещё учится, обычно 1–3 минуты": "A voz ainda está em treinamento, normalmente 1–3 minutos",
  "Коротко о голосе": "Resumo da voz",
  "О голосе": "Sobre a voz",
  "Голос не создан": "A voz não foi criada",
  "Обработка дольше обычного": "Está demorando mais que o normal",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "O servidor ainda está processando a voz. Pode fechar o app e voltar mais tarde.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "O avatar {n} ficará sem voz; nos círculos tocará a voz padrão.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "Os avatares {n} ficarão sem voz; nos círculos tocará a voz padrão.",
  "Записать первый голос": "Gravar a primeira voz",
  "клон|клона|клонов": "clone|clones",
  "в месяц": "por mês",
  "{n} C в месяц": "{n} C por mês",
  "{n} своих голосов": "{n} vozes próprias",
  "Оформить": "Assinar",
  "Подписка активна": "Assinatura ativa",
  "Подписка «{n}»": "Assinatura «{n}»",
  "{n} голосов ваши": "{n} vozes são suas",
  "Доступно — своих голосов": "Vozes próprias disponíveis",
  "{n} голосов мало?": "{n} vozes é pouco?",
  "Возьмите {n}": "Tenha {n}",
  "Нужно больше голосов?": "Precisa de mais vozes?",
  "До {n} с подпиской": "Até {n} com assinatura",
  "Посмотрите доступные подписки": "Veja as assinaturas disponíveis",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a} de {b} em uso. Grave vozes para tarefas e climas diferentes",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Sem assinatura, você pode criar {a} {w}. Com qualquer assinatura, até {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Sem assinatura: {n}. O limite depende da assinatura escolhida.",
  "Занято {a} из {b}": "{a} de {b} em uso",
  "Без подписки · {n}": "Sem assinatura · {n}",
  "С подпиской · {n}": "Com assinatura · {n}",
  "Смотреть все подписки": "Ver todas as assinaturas",
  "Повторить сохранение": "Salvar de novo",
  "Сохраняем изменения…": "Salvando alterações…",
  "Управление голосами временно недоступно": "O gerenciamento de vozes está temporariamente indisponível",
  "клон: Мой голос": "Minha voz",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "As vozes próprias estão temporariamente indisponíveis. Atualize a lista mais tarde.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "O serviço de vozes está temporariamente indisponível. Tente mais tarde.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Não foi possível confirmar o limite de vozes. Atualize a lista mais tarde.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Não foi possível confirmar a conta. Tente mais tarde.",
  "Имя голоса должно содержать от 2 до 32 символов.": "O nome da voz deve ter de 2 a 32 caracteres.",
  "Описание должно содержать не больше 120 символов.": "A descrição deve ter no máximo 120 caracteres.",
  "Добавьте от 1 до 10 подходящих образцов.": "Adicione de 1 a 10 amostras adequadas.",
  "Превью этого голоса пока недоступно.": "A prévia desta voz ainda não está disponível.",
  "Не удалось загрузить превью. Попробуйте позже.": "Não foi possível carregar a prévia. Tente mais tarde.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "A gravação está muito ruidosa. Tente gravar num lugar silencioso.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Há várias vozes na gravação. Adicione a fala de uma só pessoa.",
  "Голос не прошёл правила площадки.": "A voz não cumpre as regras da plataforma.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "O serviço não conseguiu processar a voz. Verifique o status antes de tentar de novo.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "O consentimento mudou ou está indisponível. Atualize a lista e confirme a versão atual antes de tentar de novo.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Envio rejeitado. Toque no botão de novo para reenviar a amostra.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Envio ainda não confirmado. Toque no botão de novo: primeiro verificaremos o envio anterior.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Escolha um arquivo de áudio MP3, WAV, M4A, OGG ou WebM.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Não foi possível ler o áudio. Tente de novo ou envie um arquivo.",
  "Пример звучания": "Amostra de áudio",
  "Пример звучания пока недоступен": "A amostra de áudio ainda não está disponível",
  "Превью голоса": "Prévia da voz",
  "Прослушать пример": "Ouvir amostra",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "{0}% de desconto no primeiro pacote de Circle, válido por {1} {2} após assinar",
  "Вы уже пришли по ссылке партнёра": "Você já entrou pelo link de um parceiro",
  "Промокод партнёра уже применён": "Um código de parceiro já foi aplicado",
  "Тут откроется тема чата, куда бот прислал {0}": "Aqui vai abrir o tópico do chat com o seu resultado: {0}",
  "можно вывести": "pode sacar",
  "только в STEOS": "só no STEOS",
  "Не короче {0} знаков": "Mínimo de {0} caracteres",
  "Введите почту и пароль": "Digite o e-mail e a senha",
  "от {0} знаков": "mín. {0} caracteres",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Depois de entrar, seus Circle ficam compartilhados entre o bot e a conta STEOS. Saldo e saque também ficam em {0}.",
  "Вход или новый аккаунт": "Entrar ou nova conta",
  "Придумайте пароль": "Crie uma senha",
  "Ваш пароль": "Sua senha",
  "Принимаю {0} и {1} STEOS": "Aceito os {0} e a {1} do STEOS",
  "согласие: условия": "termos",
  "согласие: политику конфиденциальности": "política de privacidade",
  "Пришлём ссылку на почту": "Enviaremos um link para o seu e-mail",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Abra o link do e-mail e defina uma nova senha em {0}. Depois entre aqui com a nova senha.",
  "Ссылка для нового пароля ушла на {0}": "O link para a nova senha foi enviado para {0}",
  "Письма нет? Проверьте папку «Спам».": "Não chegou? Confira a pasta de spam.",
  "Аккаунт создан и подключён": "Conta criada e conectada",
  "Баланс бота теперь общий с аккаунтом STEOS.": "O saldo do bot agora é compartilhado com a conta STEOS.",
  "Подтвердите почту по ссылке из письма.": "Confirme o e-mail pelo link da mensagem.",
  "Вывод работает здесь и на {0}.": "O saque funciona aqui e em {0}.",
  "Открыть {0}": "Abrir {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Enviamos um link para {0}. Abra-o e depois verifique a conexão aqui.",
  "Проверить подключение": "Verificar conexão",
  "Почти готово": "Quase pronto",
  "Почта ещё не подтверждена": "E-mail ainda não confirmado",
  "Не удалось проверить. Попробуйте позже": "Não foi possível verificar. Tente mais tarde",
  "Озвучиваю тексты голосом героя": "Textos com a voz de um herói",
  "Любой голос из библиотеки или свой": "Qualquer voz da biblioteca ou a sua",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "Dou voz de heróis a textos no STEOS. Experimente pelo meu link, código promocional {0}",
  "Пишу текст, персонаж говорит": "Eu escrevo, o personagem fala",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "Faço vídeos circulares com personagens no STEOS: escrevo o texto e o personagem fala. Código promocional {0}",
  "Свои фото в любом образе": "Suas fotos em qualquer visual",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Uma sessão de fotos em qualquer visual a partir de duas fotos minhas, sem estúdio. STEOS, código promocional {0}",
  "Вы в кадре, монтаж и музыка сами": "Você em cena, edição e música automáticas",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "Apareço em reels com um toque no STEOS: roteiro, edição e música já estão no modelo. Código promocional {0}",
  "Персонаж оживает": "O personagem ganha vida",
  "Говорит вашим текстом": "Fala o seu texto",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "O personagem fala o meu texto com a própria voz. Experimente o STEOS, código promocional {0}",
  "Клон голоса за минуту": "Clone de voz em um minuto",
  "Запишите от 2 секунд, дальше говорит клон": "Grave 2 segundos e o clone fala por você",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "Um clone da minha voz em um minuto no STEOS: agora ele narra tudo sozinho. Código promocional {0}",
  "Старому фото цвет и резкость": "Cor e nitidez para fotos antigas",
  "Восстановление за минуту": "Restauração em um minuto",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "Devolvo cor e nitidez a fotos antigas no STEOS. Código promocional {0}",
  "По ссылке или промокоду": "Por link ou código promocional",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Dou +{0} C e {1}% de desconto no primeiro pacote do STEOS com meu código promocional {2}",
  "Кавер на любую песню": "Cover de qualquer música",
  "Рок, джаз, lo-fi любым голосом": "Rock, jazz, lo-fi com qualquer voz",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "Cover de qualquer música com qualquer voz no STEOS. Código promocional {0}",
  "Мой аватар в любом образе": "Meu avatar em qualquer visual",
  "Свой аватар из 10 фото": "Seu avatar a partir de 10 fotos",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Meu avatar em qualquer visual, feito com 10 fotos no STEOS. Código promocional {0}",
  "Это я, только говорю вашим текстом": "Sou eu, só que falando o seu texto",
  "сторис: Мой голос": "Minha voz",
  "на баланс сразу": "no saldo na hora",
  "на первый пакет Circle": "no primeiro pacote de Circle",
  "Сторис открыта в Telegram": "Story aberto no Telegram",
  "Сторис готова": "Story pronto",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Agora é só publicar no editor do Telegram",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Aqui vai abrir o editor de stories do Telegram com esta imagem e legenda",
  "Подпись к сторис": "Legenda do story",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "O botão com link nos stories do Telegram só existe com Premium. Todos veem o código promocional na imagem.",
  "Опубликовать в сторис": "Publicar nos stories",
  "Попробовать STEOS": "Experimentar o STEOS",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Não foi possível preparar o story. Tente de novo",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Quem publica stories é o Telegram: abra o Mini App no Telegram",
  "Ссылка и промокод уже на картинке": "O link e o código já estão na imagem",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Experimente o STEOS pelo meu link. Código promocional {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Experimente o STEOS pelo meu link: +{0} C e {1}% de desconto no primeiro pacote. Código promocional {2}",
  "Ссылка": "Link",
  "Скопировать ссылку": "Copiar link",
  "Друзьям {0} и {1} на первый пакет": "Amigos ganham {0} e {1} no primeiro pacote",
  "Промокод выделен: скопируйте вручную": "Código selecionado: copie manualmente",
  "Ссылка выделена: скопируйте вручную": "Link selecionado: copie manualmente",
  "Ссылка скопирована": "Link copiado",
  "Ссылка выделена: скопируйте её вручную": "Link selecionado: copie manualmente",
  "Ссылка выделена": "Link selecionado",
  "Вы пришли по приглашению": "Você foi convidado",
  "{0} C на баланс": "{0} C no saldo",
  "Сгорят через {0} {1}": "Expiram em {0} {1}",
  "{0} на первый пакет Circle": "{0} no primeiro pacote de Circle",
  "{0} {1} после оформления подписки": "{0} {1} após assinar",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Pacotes de Circle podem ser comprados com qualquer assinatura. O desconto começa assim que você assinar.",
  "Выбрать тариф": "Escolher plano",
  "QR-код ссылки приглашения, промокод {0}": "QR code do link de convite, código promocional {0}",
  "Друг наведёт камеру и откроет бота": "Seu amigo aponta a câmera e abre o bot",
  "Цвет карточки": "Cor do cartão",
  "Скачать картинку": "Baixar imagem",
  "Аврора": "Aurora",
  "Закат": "Pôr do sol",
  "Океан": "Oceano",
  "Графит": "Grafite",
  "Партнёры": "Parceiros",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Achei um bot em que qualquer personagem fala seu texto em uma mensagem de vídeo. Também faz fotos, vídeos e narrações com qualquer voz, tudo direto no Telegram.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Compartilhando uma descoberta: STEOS, um bot no Telegram onde eu faço mensagens de vídeo com personagens, narrações e fotos. Você escreve o texto, escolhe a voz e em um minuto está pronto.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Estou restaurando nossas fotos antigas de família no STEOS: em um minuto elas ganham cor e nitidez de volta. Me mandem as fotos que querem renovar ou testem vocês mesmos.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Quem queria uma mensagem de vídeo com a voz do seu herói favorito? No STEOS você escreve um texto e um personagem de jogo ou série fala. É um bot do Telegram.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Faço fotos de produto, cards com benefícios e descrições para marketplaces no STEOS em poucos minutos, sem estúdio nem designer. Talvez seja útil para vocês também.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Narro meus vídeos com meu clone de voz, apareço em reels com templates prontos e gravo covers. Tudo em um só bot STEOS no Telegram.",
  "По моей ссылке +{0} C на старт.": "Com meu link você ganha +{0} C para começar.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Com meu link: +{0} C e −{1}% no primeiro pacote.",
  "Попробуй сам.": "Experimente.",
  "Попробуйте сами.": "Experimentem.",
  "Актёры": "Atores",
  "Персонажи и актёры": "Personagens e atores",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "Nenhuma voz para “{q}”. Tente outra palavra ou veja as coleções",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Ainda não há vozes aqui. Veja as outras abas ou coleções",
  "Голос вернётся на экран создания": "A voz volta para a tela de criação",
  "После выбора пишите текст для озвучки в чат бота": "Depois, envie o texto para narrar no chat do bot",
  "От Я до А": "De Z a A",
  "Сортировка и фильтры": "Ordenação e filtros",
  "Сбросить": "Redefinir",
  "Чаще всего выбирают": "Os mais escolhidos",
  "Сначала свежие": "Mais recentes primeiro",
  "Сначала давние": "Mais antigos primeiro",
  "Сначала недорогие": "Mais baratos primeiro",
  "Сначала короткие ролики": "Vídeos curtos primeiro",
  "По названию": "Por nome",
  "По названию, с конца алфавита": "Por nome, do fim do alfabeto",
  "Вертикальные ролики": "Vídeos verticais",
  "Картинки и посты": "Imagens e posts",
  "Горизонтальные ролики": "Vídeos horizontais",
  "Видеосообщения Telegram": "Mensagens de vídeo do Telegram",
  "Один человек в кадре": "Uma pessoa no quadro",
  "Трое и больше": "Três ou mais",
  "С ребёнком": "Com uma criança",
  "С питомцем": "Com um animal de estimação",
  "Двое человек в кадре": "Duas pessoas no quadro",
  "О разделе": "Sobre",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Transforma texto em fala: uma voz do catálogo ou o seu clone, com ajustes de entonação e velocidade.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Uma cópia da sua voz a partir de uma gravação: use-a para narrar qualquer texto.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "Estúdio de IA: vídeos, fotos, círculos e outros modelos com você, seus queridos e personagens.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Créditos (C) na conta e recarga. Os créditos são gastos em narrações e pedidos do estúdio.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Tarefas e recompensas: conclua tarefas e ganhe créditos.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Todas as suas narrações e pedidos do estúdio: ouvir, baixar ou repetir.",
  "Ваш профиль и данные аккаунта.": "Seu perfil e dados da conta.",
  "Настройки приложения: язык, валюта и уведомления.": "Configurações do app: idioma, moeda e notificações.",
  "Ответы на частые вопросы и связь с поддержкой.": "Respostas a perguntas frequentes e contato com o suporte.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Programa de parceiros: convide amigos e receba uma porcentagem das recargas deles.",
  "Озвучка больших текстов и сценариев по ролям.": "Narração de textos longos e roteiros por papéis.",
  "Вы или один близкий": "Você ou uma pessoa querida",
  "Вы и близкий": "Você e uma pessoa querida",
  "Товары и места": "Produtos e lugares",
  "Фото товара, блюда или места": "Foto de um produto, prato ou lugar",
  "В избранном": "Nos favoritos",
  "Голоса и персонажи, которые вы отметили сердцем": "Vozes e personagens que você marcou com um coração",
  "Нажмите — выбрать голос": "Toque para escolher uma voz",
  "Удерживайте — карточка голоса": "Segure para ver o cartão da voz",
  "Карточка голоса или персонажа": "Cartão de voz ou personagem",
  "Нажмите на голос, чтобы выбрать его": "Toque numa voz para escolhê-la",
  "Удерживайте, чтобы открыть карточку голоса": "Mantenha pressionado para abrir o cartão da voz",
  "Удаление голоса": "Excluir a voz",
  "Подсказка": "Dica",
  "Пример звучания пока недоступен. Попробуйте позже.": "A amostra ainda não está disponível. Tente mais tarde.",
  "Языков: {0}": "Idiomas: {0}",
  "Ещё языков: {0}": "Mais idiomas: {0}",
  "Ход примера": "Progresso da amostra",
  "Голос говорит на {0} языках": "A voz fala {0} idiomas",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Todas as vozes são multilíngues e narram o texto em qualquer idioma do sistema.",
  "Голоса подборки": "Vozes da coleção",
  "Удерживайте голос, чтобы открыть его": "Mantenha uma voz pressionada para abri-la",
  "Назад к голосу": "Voltar à voz",
  "Оригинал голоса говорил на {0} языке": "A voz original falava {0}",
  "Происхождение: {0}. Подробнее": "Origem: {0}. Detalhes",
  "Новый": "Nova",
  "Официальный": "Oficial",
  "Актёр": "Ator",
  "Удерживайте, чтобы послушать": "Mantenha pressionado para ouvir",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Mantenha pressionada a linha de uma voz ou clique com o botão direito para abrir o cartão. Um personagem abre com um toque normal.",
  "Подборка · Голосов: {0}": "Coleção · Vozes: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "As vozes disponíveis aparecerão no catálogo. Aqui você poderá ouvir uma amostra e escolher uma voz para o bot.",
  "Зажмите голос": "Mantenha uma voz pressionada",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Mantenha pressionada a linha de uma voz para abrir o cartão: ouvir e ver as coleções. Um toque curto escolhe a voz.",
  "Нажмите на аватарку": "Toque no avatar",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "O avatar redondo da linha toca uma amostra da voz. Toque de novo para parar. Tocar na linha escolhe a voz.",
  "Сохраняйте в избранное": "Salve nos favoritos",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Toque no coração no cartão de uma voz ou personagem — eles vão para a coleção “Favoritos”, a primeira em “Coleções” e em “Recomendados”. Toque de novo para remover.",
  "Запишите свой голос": "Grave sua voz",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 segundos de fala ou alguns arquivos, e em dois minutos sua voz aparecerá em todas as ferramentas de narração. Toque em “Gravar” e leia o texto na tela.",
  "Читать полностью": "Ler mais",
  "Голос STEOS": "Voz STEOS",
  "Назад к персонажу": "Voltar ao personagem",
  "Назад к списку": "Voltar à lista",
  "Актёр STEOS": "Ator STEOS",
  "Персонаж STEOS": "Personagem STEOS",
  "Об актёре": "Sobre o ator",
  "О персонаже": "Sobre o personagem",
  "Голоса актёра": "Vozes do ator",
  "Голоса персонажа": "Vozes do personagem",
  "шапка: Мой голос": "Minha voz",
  "Пример голоса «{0}»": "Amostra da voz “{0}”",
  "Ещё языки": "Mais idiomas",
  "Юзеры": "Usuários",
  "Лайки": "Curtidas",
  "Пол": "Gênero",
  "В каталоге с": "No catálogo desde",
  "Автор": "Autor",
  "Откуда": "De",
  "Характер": "Personalidade",
  "Голосов": "Vozes",
  "Мужской": "Masculina",
  "Женский": "Feminina",
  "Детский": "Infantil",
  "Не указан": "Não informado",
  "Голос персонажа": "Voz do personagem",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Escolha um arquivo de áudio compatível de até {0} MB.",
  "пол: Детский": "Infantil",
  "Состав подборки": "Conteúdo da coleção",
  "Закрыть выбор голоса": "Fechar a escolha de voz",
  "Не удалось открыть запись для прослушивания.": "Não foi possível abrir a gravação para ouvir.",
  "Использовать готовую запись": "Usar uma gravação pronta",
  "Подтвердите права на материалы, чтобы взять запись.": "Confirme seus direitos sobre os materiais para usar a gravação.",
  "Работа из доната": "Trabalho de uma doação",
  "Модель синтеза": "Modelo de síntese",
  "Новая модель": "Modelo novo",
  "Прежняя модель": "Modelo anterior",
  "Удерживайте — карточка голоса и модель синтеза": "Mantenha pressionado: ficha da voz e modelo de síntese",
  "Модель для озвучки в чате": "Modelo para a locução no chat",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Modelo novo: emoções e entonação natural, perguntas, muitos idiomas, clones de voz",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Modelo anterior: só cinco idiomas, sem emoções nem entonação de pergunta, sem clones",
  "Активная модель: STEOS Voice": "Modelo ativo: STEOS Voice",
  "Активная модель:": "Modelo ativo:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Modelo novo: 19 idiomas, som natural com entonação viva — sem timbre metálico ou robótico, clonagem de voz de qualidade",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Modelo anterior: só 5 idiomas, sem emoções nem entonação de pergunta, sem clones de voz",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "No modelo STEOS Voice {0} todas as vozes são multilíngues e narram o texto em qualquer um destes idiomas.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "No modelo STEOS Voice {0} todas as vozes são multilíngues e narram o texto em qualquer um {1}.",
  "этих языков": "destes idiomas",
  "Языки озвучки": "Idiomas de narração",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "Qualquer voz do modelo STEOS Voice {0} narra o texto em cada um destes idiomas",
  "Все голоса": "Todas as vozes",
  "Озвучка текста и переозвучка": "Texto para fala e troca de voz",
  "Переозвучка записи": "Troca de voz na gravação",
  "Меняют голос в вашей записи": "Trocam a voz da sua gravação",
  "Выберите голос для переозвучки записи": "Escolha uma voz para trocar a voz da sua gravação",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Voz escolhida — volte ao chat e toque em «Continuar a troca de voz»"
}
